webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$Q8DXfG009VhLIFQ.jVOUc.PQP9veEMmsqkthzMdi8xIFTCRkf2AEm';

        this.site_url = 'https://wspk.herokuapp.com';
        this.site_name = 'SP';
        this.siteUrl = 'http://share.sellpoints.com.ng/';
        this.max_upload_image_info = "Maximum allowed Media Size Limit is 6MB";
        this.media_upload_timeout_msg = "Uploading Media is taking too long, may not complete upload...";

        this.request_from = localStorage.getItem("sp_request_from");
        this.request_url = localStorage.getItem("sp_request_url");
        this.request_url_page = localStorage.getItem("sp_request_url_page");

        this.baseURL = 'https://spattle.afiahub.com/api/';

        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';

        this.video_exts = ['mp4', 'mp3'];
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'getIPAddress',
        value: function getIPAddress(context) {
            return context.$http.get('https://api.ipify.org?format=jsonp&callback=getIP');
        }
    }, {
        key: 'sendErrorLog',
        value: function sendErrorLog(context, data) {
            return context.$http.post(this.baseURL + 'errors', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getStates',
        value: function getStates(context, id) {
            return context.$http.get(this.baseURL + 'states', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getCities',
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'regUser',
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'loginUser',
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'sessionGuard',
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'sessionSyncSet',
        value: function sessionSyncSet(context, id) {
            return context.$http.get(this.baseURL + 'auth/sessions/sync/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'sessionSync',
        value: function sessionSync(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'can_edit',
        value: function can_edit(context, data) {
            return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getUser',
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addUserBusinessInterests',
        value: function addUserBusinessInterests(context, data) {
            return context.$http.post(this.baseURL + 'users/interests/businesses', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserBusinessInterests',
        value: function getUserBusinessInterests(context, id) {
            return context.$http.get(this.baseURL + 'users/interests/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'validateBusinessUserName',
        value: function validateBusinessUserName(context, data) {
            return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getCategories',
        value: function getCategories(context) {
            return context.$http.get(this.baseURL + 'categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getMarketCategories',
        value: function getMarketCategories(context) {
            return context.$http.get(this.baseURL + 'market/categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getMarketActivityProducts',
        value: function getMarketActivityProducts(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'products/markets/activities/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'searchCategoryProducts',
        value: function searchCategoryProducts(context, name, type) {
            return context.$http.get(this.baseURL + 'products/search/categories/' + name + '/' + type, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'searchProducts',
        value: function searchProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'searchBusinessProducts',
        value: function searchBusinessProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/businesses/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'searchProductsByBusiness',
        value: function searchProductsByBusiness(context, search, business) {
            return context.$http.get(this.baseURL + 'products/search/businesses/' + search + '/' + business, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getFilters',
        value: function getFilters(context) {
            return context.$http.get(this.baseURL + 'filters', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addBusiness',
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addNewBusiness',
        value: function addNewBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/new', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addExistingBusiness',
        value: function addExistingBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/existing', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinesses',
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessByUserName',
        value: function getBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessNotifications',
        value: function getBusinessNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessMessages',
        value: function getBusinessMessages(context, id) {
            return context.$http.get(this.baseURL + 'messages/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessOrders',
        value: function getBusinessOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'readNotifications',
        value: function readNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getMainCategories',
        value: function getMainCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/main/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessSubCategories',
        value: function getBusinessSubCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessCategories',
        value: function getBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'uploadDataPhoto',
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: 'uploadBusinessDataPhoto',
        value: function uploadBusinessDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'businesses/uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: 'addCategory',
        value: function addCategory(context, data) {
            return context.$http.post(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editCategory',
        value: function editCategory(context, data) {
            return context.$http.put(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getProducts',
        value: function getProducts(context, id) {
            return context.$http.get(this.baseURL + 'products', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessProducts',
        value: function getBusinessProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getMarketProducts',
        value: function getMarketProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessMarket',
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getCategoryProducts',
        value: function getCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getProductSearch',
        value: function getProductSearch(context, id) {
            return context.$http.get(this.baseURL + 'products/product/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getProductImages',
        value: function getProductImages(context, id) {
            return context.$http.get(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteProductImage',
        value: function deleteProductImage(context, id) {
            return context.$http.delete(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteImages',
        value: function deleteImages(context, id, data) {
            return context.$http.put(this.baseURL + 'data/images/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addProduct',
        value: function addProduct(context, data) {
            return context.$http.post(this.baseURL + 'products', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: 'addProductItem',
        value: function addProductItem(context, data) {
            return context.$http.post(this.baseURL + 'products/items', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addProductDetail',
        value: function addProductDetail(context, data) {
            return context.$http.post(this.baseURL + 'products/details', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: 'addProductReview',
        value: function addProductReview(context, data) {
            return context.$http.post(this.baseURL + 'products/reviews', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: 'editProduct',
        value: function editProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editProductItem',
        value: function editProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editProductItemGroup',
        value: function editProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'removeProductItemGroup',
        value: function removeProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'removeProductItem',
        value: function removeProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'removeProduct',
        value: function removeProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editProductDetail',
        value: function editProductDetail(context, id, data) {
            return context.$http.put(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteProductDetail',
        value: function deleteProductDetail(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getProductDeliveryOptions',
        value: function getProductDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'products/delivery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'setProductDelivery',
        value: function setProductDelivery(context, id, data) {
            return context.$http.put(this.baseURL + 'products/delivery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'setProductShippingFeeStatus',
        value: function setProductShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getProductInformation',
        value: function getProductInformation(context, id) {
            return context.$http.get(this.baseURL + 'products/information/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addProductInformation',
        value: function addProductInformation(context, data) {
            return context.$http.post(this.baseURL + 'products/information', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: 'editProductInformation',
        value: function editProductInformation(context, id, data) {
            return context.$http.put(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteProductInformation',
        value: function deleteProductInformation(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getPointPosts',
        value: function getPointPosts(context, id) {
            return context.$http.get(this.baseURL + 'posts/points/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getPointGalleryPosts',
        value: function getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
            return context.$http.get(this.baseURL + 'posts/gallery/points/' + id + '/' + offset + '/' + limit + '/' + posts_offset + '/' + posts_limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getPostSearch',
        value: function getPostSearch(context, id) {
            return context.$http.get(this.baseURL + 'posts/post/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getGallerySearch',
        value: function getGallerySearch(context, id) {
            return context.$http.get(this.baseURL + 'posts/gallery/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addPost',
        value: function addPost(context, data) {
            return context.$http.post(this.baseURL + 'posts', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: 'addGallery',
        value: function addGallery(context, data) {
            return context.$http.post(this.baseURL + 'posts/gallery', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: 'editPost',
        value: function editPost(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deletePost',
        value: function deletePost(context, id) {
            return context.$http.delete(this.baseURL + 'posts/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editGallery',
        value: function editGallery(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteGallery',
        value: function deleteGallery(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editGalleryPost',
        value: function editGalleryPost(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/posts/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteGalleryPost',
        value: function deleteGalleryPost(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/posts/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'checkout',
        value: function checkout(context, data) {
            return context.$http.post(this.baseURL + 'orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getCheckoutOrder',
        value: function getCheckoutOrder(context, url) {
            return context.$http.get(this.baseURL + 'orders/url/' + url, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getCheckoutOrders',
        value: function getCheckoutOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/topays/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserDeliveryDetails',
        value: function getUserDeliveryDetails(context, id) {
            return context.$http.get(this.baseURL + 'users/deliverydetails/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'updatePayment',
        value: function updatePayment(context, data) {
            return context.$http.post(this.baseURL + 'payments', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getOrders',
        value: function getOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addService',
        value: function addService(context, data) {
            return context.$http.post(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editService',
        value: function editService(context, data) {
            return context.$http.put(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addSubscriptionGroup',
        value: function addSubscriptionGroup(context, data) {
            return context.$http.post(this.baseURL + 'businesses/subscriptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editSubscriptionGroup',
        value: function editSubscriptionGroup(context, data) {
            return context.$http.put(this.baseURL + 'businesses/subscriptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessDeliveryOptions',
        value: function getBusinessDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'businesses/deliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'checkBusinessPayOnDelivery',
        value: function checkBusinessPayOnDelivery(context, id) {
            return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'addDeliveryOption',
        value: function addDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editDeliveryOption',
        value: function editDeliveryOption(context, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteDeliveryOption',
        value: function deleteDeliveryOption(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'setProductDeliveryOption',
        value: function setProductDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editProductDeliveryOption',
        value: function editProductDeliveryOption(context, id, data) {
            return context.$http.put(this.baseURL + 'products/delivery/fees/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editBusinessDetails',
        value: function editBusinessDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/details', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'sendBusinessContactForm',
        value: function sendBusinessContactForm(context, data) {
            return context.$http.post(this.baseURL + 'businesses/contacts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'setBusinessFilterOptions',
        value: function setBusinessFilterOptions(context, data) {
            return context.$http.put(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'removeBusinessFilterOption',
        value: function removeBusinessFilterOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'setBusinessBankDetails',
        value: function setBusinessBankDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'switchProcessingFeePay',
        value: function switchProcessingFeePay(context, data) {
            return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'setShippingFeeStatus',
        value: function setShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessDiscountsAndCoupons',
        value: function getBusinessDiscountsAndCoupons(context, id) {
            return context.$http.get(this.baseURL + 'businesses/discounts/coupons/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'setDiscountsAndCoupons',
        value: function setDiscountsAndCoupons(context, data) {
            return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'editDiscountsAndCoupons',
        value: function editDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'deactivateDiscountsAndCoupons',
        value: function deactivateDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-1d65b7be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  "data-v-20e56ada",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_SELLPOINTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALL_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRODUCT_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRODUCT_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VIEW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_MSG; });
/* unused harmony export SUCCESS_MSG */
var ALL_SELLPOINTS = 'ALL_SELLPOINTS';
var ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS';

var ALL_PRODUCTS = 'ALL_PRODUCTS';
var ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';

var PRODUCT_BY_ID = 'PRODUCT_BY_ID';
var PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

var VIEW_CART = 'VIEW_CART';
var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';

var ERROR_MSG = 'ERROR_MSG';
var SUCCESS_MSG = 'SUCCESS_MSG';

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validate_array",
        value: function validate_array(str_array, error_msg) {
            var process_errors = [];

            var reg_num = /^[0-9]+$/;
            var reg_name = /^[\w\-\s]+$/;
            var reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var reg_phone = /^\d{4}\d{3}\d{4}$/;

            for (var i = 0; i < str_array.length; i++) {
                var arr_in_str_array = str_array[i];
                if (arr_in_str_array[1] == undefined || arr_in_str_array[1] == "") {
                    process_errors.push(error_msg + arr_in_str_array[0]);

                    if (arr_in_str_array[2] == "alpha") {
                        if (!reg_name.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "num") {
                        if (!reg_num.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "email") {
                        if (!reg_email.test(String(arr_in_str_array[1]).toLowerCase())) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "phone") {
                        if (!reg_phone.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }
                }
            }

            return process_errors;
        }
    }, {
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }
    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(237)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(234)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__register__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__manage__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buypoint__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__points__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sellpoints__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sellpoint__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__create__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sidehustle__ = __webpack_require__(136);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [__WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__register__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__manage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__buypoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__points__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__create__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__sidehustle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__sellpoints__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__sellpoint__["a" /* default */]]
}));

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(137);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
    key: 'vuex',
    storage: window.localStorage,
    reducer: function reducer(state) {
        return {
            cart: state.cart
        };
    }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        sellpoints: [],

        sellpoint: {},

        products: [],

        product: {},

        cart: [],

        showLoader: false
    },

    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* productGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["b" /* sellpointGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["c" /* cartGetters */]),
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* productMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* sellpointMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* cartMutations */]),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* productActions */], __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* sellpointActions */])
}));

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MenuLeftBar',

    data: function data() {
        return {
            user: {},
            loggedIn: false
        };
    },

    methods: {
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("sp_token") != null) {
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        }
    },

    created: function created() {
        this.checkLoggedIn();
    }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MenuModal',

    data: function data() {
        return {
            user: {},
            loggedIn: false
        };
    },

    methods: {
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("sp_token") != null) {
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        }
    },

    created: function created() {
        this.checkLoggedIn();
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products: {},
            post: {},
            gallery: {},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            action_loading: false,
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info
        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {},
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        addGallery: function addGallery() {
            var _this6 = this;

            this.activate_processing();

            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 1,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: 0,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this5 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;
                        this.gallery = data.body.data_gallery;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        var url = "/" + this.$route.params.id + "/g/" + this.gallery.gallery_posts_group_url_name;
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this5.data_media_error_message = "";
                                location.replace(url);
                            }
                        }).catch(function (err) {
                            if (err) {}
                            toastr.warning("Something went wrong.", 'Warning!');
                            _this5.data_error_message = "Something went wrong";
                            _this5.deactivate_processing();
                        });

                        this.data_media_error_message = service.media_upload_timeout_msg;
                        var self = this;
                        setTimeout(function () {
                            self.data_media_error_message;
                        }, 1200);
                        setTimeout(function () {
                            location.replace(url);
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this6.data_error_message = "Something went wrong";
                        _this6.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');

                this.data_error_message = "Kindly fill all fields";
                this.deactivate_processing();
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            post: {},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            action_loading: false,
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info
        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel = false;
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                    _this2.getSubCategories(_this2.sellpoint.business_category_id);
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addPost: function addPost() {
            var _this5 = this;

            this.activate_processing();

            var credentials = {
                post_title: this.post.post_title || "nill",
                post_text: this.post.post_text,
                post_point: this.sellpoint.business_id,
                post_product: 0 };

            var navi = this.$router;
            if (credentials.post_text != undefined) {
                service.addPost(this, credentials).then(function (data) {
                    var _this4 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "default_post_media");
                        var url = "/" + this.$route.params.id + "/p/" + this.post.post_url_name;
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this4.data_media_error_message = "";
                                location.replace(url);
                            }
                        }).catch(function (err) {
                            if (err) {}
                            toastr.warning("Something went wrong.", 'Warning!');
                            _this4.data_error_message = "Something went wrong.";
                        });

                        this.data_media_error_message = service.media_upload_timeout_msg;
                        var self = this;
                        setTimeout(function () {
                            self.data_media_error_message;
                        }, 1200);
                        setTimeout(function () {
                            location.replace(url);
                        }, 2000);
                        this.deactivate_processing();
                    } else {
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this5.deactivate_processing();
                        toastr.warning("Something went wrong", 'Warning!');
                        _this5.data_error_message = "Something went wrong.";
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields";

                this.deactivate_processing();
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products: {},
            product: {},
            post: {},
            gallery: {},
            selected_produts: [],
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            showProductForm: false,
            canAddGallery: true,
            is_product_service: "product",
            existing_gallery: {},
            newGallery: true,
            action_loading: false,
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info

        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "add-to-gallery-product") {
                var if_index = this.selected_produts.indexOf(attr2.product_id);
                if (if_index != -1) {
                    this.selected_produts.splice(if_index);
                    document.getElementById(attr2.product_id + "PRD").style.border = "none";
                } else {
                    this.selected_produts.push(attr2.product_id);
                    document.getElementById(attr2.product_id + "PRD").style.border = "1px solid #0000CC";
                }
            }
            if (attr1 == "show-add-product-form") {
                if (this.showProductForm) {
                    this.showProductForm = false;
                    this.canAddGallery = true;
                } else {
                    this.showProductForm = true;
                    this.canAddGallery = false;
                }
            }
        },
        reset: function reset() {
            this.showProductForm = false;
            this.canAddGallery = true;
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();

                        if (_this.$route.params.idg != undefined) {
                            _this.newGallery = false;
                            _this.setGallery();
                        }
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                    _this2.getSubCategories(_this2.sellpoint.business_category_id);
                    _this2.getSellpointProducts();
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        addGallery: function addGallery() {
            var _this5 = this;

            this.deactivate_processing();

            this.activate_processing();
            var gallery_new_group = true;
            var gallery_post_group = 0;
            if (!this.newGallery) {
                gallery_post_group = this.existing_gallery.gallery_posts_group_id;
                gallery_new_group = false;
            }

            var credentials = {
                gallery_new_group: gallery_new_group,
                gallery_group_type: 2,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: gallery_post_group,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Post Created";

                        this.gallery = data.body.data;
                        if (this.newGallery) {
                            location.replace("/" + this.$route.params.id + "/g/" + this.gallery.gallery_posts_group_url_name);
                        } else {
                            location.reload();
                        }
                    }
                    this.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        _this5.data_error_message = "Something went wrong";

                        _this5.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        addProduct: function addProduct() {
            var _this7 = this;

            this.activate_processing();

            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this6 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Product Added Successfully";

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_id);

                        this.imageForm.append("data_type", "products");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this6.data_media_error_message = "";
                                _this6.selected_produts.push(_this6.product.product_id);
                                _this6.addGallery();
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this6.data_error_message = "Something went wrong";
                        });

                        this.data_media_error_message = service.media_upload_timeout_msg;
                        var self = this;
                        setTimeout(function () {
                            self.data_media_error_message;
                        }, 1200);
                        setTimeout(function () {
                            self.selected_produts.push(self.product.product_id);
                            self.addGallery();
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this7.data_error_message = "Something went wrong";

                        _this7.disable_btn = false;
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        setGallery: function setGallery() {
            var _this8 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.idg).then(function (response) {
                if (response.body.status == 200) {
                    _this8.existing_gallery = response.body.data;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItemGroup', 'productItem'],
  data: function data() {
    return {
      user: {},
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem.active_order = true;
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_order_url = this.productMain.product_business_ownername + "-" + this.productMain.product_url_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;

      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        this.productItem.product_item_image = '';
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);

      this.redir('order');
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    },
    configureCTAButton: function configureCTAButton() {}
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItemGroup', 'productItem'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;

      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        this.productItem.product_item_image = '';
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            product: {},
            product_item: {},
            service_duration: "",
            is_product_service: "product",
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            action_loading: false,
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            product_subscription_active: false,
            product_app_subscription_active: false,
            product_app_subscription: 0,
            product_subscription_group: 0,
            product_subscription_category: "",
            subscription_list: []

        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel = false;
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});

                    _this2.getCategories(_this2.sellpoint.business_category_id);
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this3 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        addProductSubscription: function addProductSubscription() {
            this.is_product_service = "service";
            this.product.product_listed_category = this.product_subscription_category;
            this.product.product_group_name = this.product_subscription_category;
            this.product.product_is_subscribed_to = this.product_subscription_group;
            this.product.product_is_subscribed_to_app = this.product_app_subscription;

            this.addProduct();
        },
        addProduct: function addProduct() {
            var _this4 = this;

            this.activate_processing();

            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1,
                product_group_name: this.product.product_group_name || "nill",

                product_description_name: this.product.product_descr_name || "nill",
                product_is_subscribed_to: this.product.product_is_subscribed_to || 0,
                product_is_subscribed_to_app: this.product.product_is_subscribed_to_app || 0,
                product_subscription_details: this.subscription_list,
                product_item_service_tag: this.product.product_item_service_tag || "Nill",
                product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year',

                product_service_app_products_limit: this.product.product_service_app_product_limit || 0,
                product_service_app_product_items_limit: this.product.product_service_app_product_items_limit || 0,
                product_service_app_posts_limit: this.product.product_service_app_posts_limit || 0,
                product_service_app_gallery_limit: this.product.product_service_app_gallery_limit || 0,
                product_service_app_gallery_posts_limit: this.product.product_service_app_gallery_posts_limit || 0
            };

            var navi = this.$router;
            if (credentials.product_name != undefined || credentials.product_name != '') {
                service.addProduct(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');
                        this.data_success_message = "Product Added Successfully";

                        this.product = data.body.data;

                        var url = "/" + this.$route.params.id + "/" + this.product.product_url_name + "?setup=yes";

                        if (!this.product_subscription_active) {
                            this.imageForm.append("data_id", this.product.product_id);

                            this.imageForm.append("data_type", "products");
                            service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                                if (data.body.status == 200) {

                                    location.replace(url);
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });

                            this.data_media_error_message = service.media_upload_timeout_msg;
                            var self = this;
                            setTimeout(function () {
                                self.data_media_error_message;
                            }, 1200);
                            setTimeout(function () {
                                location.replace(url);
                            }, 2000);
                        } else {
                            location.replace(url);
                        }
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this4.data_error_message = "Something went wrong";
                        _this4.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields";
                this.deactivate_processing();
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        if (localStorage.getItem("sp-subscription") == 'active') {
            this.product_subscription_active = true;
            this.product_subscription_group = localStorage.getItem("sp-subscription-active");
            this.product_subscription_category = localStorage.getItem("sp-subscription-group");

            if (localStorage.getItem("sp-app-subscription-active") == 'active') {
                this.product_app_subscription_active = true;
                this.product_app_subscription = localStorage.getItem("sp-app-subscription");
            }
        }

        this.preset();
    }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductItemForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            product: {},
            product_items: {},
            service_duration: "",
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false,
            showProductItemGroups: true,
            showAddNewProductItemGroup: false,
            loading: false,
            action_loading: true,
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info
        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'reset-edit') {}
            if (attr1 == 'set-product-item-group') {
                this.product.product_item_group = attr2;

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }

                document.getElementById(attr2 + "PRTGR").style = "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            if (attr1 == 'show-product-item-group') {
                if (this.showAddNewProductItemGroup) {
                    this.showAddNewProductItemGroup = false;
                }
                if (this.showProductItemGroups) {
                    this.showProductItemGroups = false;
                } else {
                    this.showProductItemGroups = true;
                }
            }
            if (attr1 == 'show-add-product-item-group') {
                if (this.showProductItemGroups) {
                    this.showProductItemGroups = false;
                }if (this.showAddNewProductItemGroup) {
                    this.showAddNewProductItemGroup = false;
                } else {
                    this.showAddNewProductItemGroup = true;
                }
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.setProduct();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setProduct: function setProduct() {
            var _this2 = this;

            this.action_loading = true;
            service.getProductSearch(this, this.$route.params.idp).then(function (response) {
                if (response.body.status == 200) {
                    _this2.product = response.body.data;
                    _this2.action_loading = false;

                    if (_this2.product.product_item_groups.length == 0) {
                        _this2.showAddNewProductItemGroup = true;
                        _this2.showProductItemGroups = false;
                    }
                }
            }).catch(function (err) {
                _this2.action_loading = false;
            });
        },
        addProductItem: function addProductItem() {
            var _this3 = this;

            this.activate_processing();
            var new_product_item_group = false;
            var product_item_group_is_color_image = 'IMG';
            if (this.product.product_item_group == undefined) {
                new_product_item_group = true;
            }
            if (this.product.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }
            var credentials = {
                product_new_product_item_group: new_product_item_group,
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product.product_item_group_color || "Nill",
                product_item_group_image: this.product.product_item_group_image || 0,


                product_item_group: this.product.product_item_group || 1,

                product_id: this.product.product_id,
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1,
                product_item_size: this.product.product_item_size || "Nill",
                product_item_service_tag: this.product.product_item_service_tag || "Nill",
                product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";

                        location.reload(true);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this3.data_error_message = "Something went wrong", 'Warning!';

                        _this3.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');

                this.deactivate_processing();
            }
        },
        onFileChangeXX: function onFileChangeXX(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);


                this.imageForm = formData;
            }
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this4 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this4.product.product_item_group_image = data.body.data_id;
                            _this4.data_media_error_message = "";
                            _this4.getProductImages();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });

                this.data_media_error_message = service.media_upload_timeout_msg;
                var self = this;
                setTimeout(function () {
                    self.data_media_error_message;
                }, 65000);
                setTimeout(function () {
                    self.data_media_error_message = "";
                }, 95000);
            }
        },
        getProductImages: function getProductImages() {
            var _this5 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product.product_images = response.body.data;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.imageForm = new FormData();
        this.setProduct();
    }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-list',
  created: function created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },

  computed: {
    products: function products() {
      return this.$store.getters.allProducts;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sellpoint-list',
  created: function created() {
    if (this.sellpoints.length === 0) {
      this.$store.dispatch('allSellpoints');
    }
  },

  computed: {
    sellpoints: function sellpoints() {
      var data = this.$store.getters.allSellpoints;
      if (data.status == 200) {
        return data.data;
      }
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_BASE; });
/* unused harmony export imageURL */
var API_BASE = 'http://localhost/kokoeco/dev/koko/v1/api/';
var imageURL = 'http://localhost/kokoeco/dev/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_touch_events__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_touch_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(67);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_clipboard___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_touch_events___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '\n    <div id="app">\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        return {
            user: {},
            sellpoints: {},
            img_url: service.imageURL,
            user_business_interests: {}
        };
    },

    components: {},
    methods: {
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.user = data.body.data;

                                    _this.getSellpoints(element.user_id);

                                    _this.getUserBusinessInterests(element.user_id);
                                }
                            }).catch(function (err) {
                                if (err) {
                                    toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            });
                        }, _this2);
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpoints: function getSellpoints(user) {
            var _this3 = this;

            service.getBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this3.sellpoints = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        },
        getUserBusinessInterests: function getUserBusinessInterests(user) {
            var _this4 = this;

            service.getUserBusinessInterests(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this4.user_business_interests = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        }
    },
    created: function created() {
        document.title = "Account" + " | SP";
        this.preset();
    }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_slider_component__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_slider_component__);













var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            filters: {},
            selected_filters: [],
            orders: {},
            notifications: {},
            messages: {},
            details: {},
            cities: {},
            states: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            discount_coupon: {},
            products_unfiltered: {},
            products: {},
            product: {},
            product_item: {},
            market: {},
            subscriptions: {},
            services: {},
            posts: {},
            galleria: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addPanel: false,
            addProductPanel: false,
            addPostPanel: false,
            addGalleryPanel: false,
            addProductGalleryPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            spMessagesPanel: false,
            spOrdersPanel: false,
            spServicesPanel: false,
            spBlogPanel: false,
            spGalleryPanel: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel: false,
            spSubscriptionPanel: false,
            setDiscount: false,
            viewDiscounts: true,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            visitor_url: service.request_url,
            visitor_app: service.request_from,
            bg_main: '',
            other_delivery_option: false,
            edit_other_delivery_option: false,
            set_bank_details: false,
            edit_city: false,
            ipaddress: "",
            notifications_unread: 0,
            siteUrl: "",
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            copied: false,

            slider_type: [],
            slider_options: {
                min: 0,
                max: 0,
                width: "80%",
                processStyle: {
                    "backgroundImage": "-webkit-linear-gradient(left, #333333, #3498db)"
                }
            },
            price_filter_is_set: false,
            color_filter_is_set: false,
            size_filter_is_set: false,
            brand_filter_is_set: false,
            product_search_messsage: "",
            filter_array: [],
            sorting_by: 'best-match',
            sellpoint_product_item_groups: {},
            sellpoint_product_sizes: {},
            sellpoint_product_services: {},
            search_data: "",

            bottombar_search: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default.a,
        'new-post-form': __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue___default.a,
        'new-gallery-form': __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue___default.a,
        'new-product-gallery-form': __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue___default.a,
        'menu-modal': __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue___default.a,
        'menu-left-bar': __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue___default.a,
        'vue-slider': __WEBPACK_IMPORTED_MODULE_11_vue_slider_component___default.a
    },
    methods: {
        closeMobileBottomBar: function closeMobileBottomBar() {
            document.getElementById("mobileBottomBar").style.display = "none";
        },
        mobileBottomBarActions: function mobileBottomBarActions(attr1, attr2) {
            document.getElementById("mobileBottomBar").style.display = "block";

            if (attr1 == 'display-search-bar') {
                this.bottombar_search = true;
            }
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        mouseover: function mouseover() {
            var x = document.getElementById("product-action-display-menu");
            x.style.display = "block";
        },
        mouseleave: function mouseleave() {
            var x = document.getElementById("product-action-display-menu");

            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        showSectionById: function showSectionById(section) {
            var x = document.getElementById(section);
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        copyLink: function copyLink() {
            if (this.copied) {
                this.copied = false;
            } else {
                this.$clipboard(this.siteUrl);
                this.copied = true;
            }
        },
        checkIfVideo: function checkIfVideo(url) {
            var ext = url.split('.').pop();
            if (service.video_exts.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;

            $('#menuModal').modal('hide');

            this.child_route_view = false;

            document.getElementById("mobileSideNav").style.width = "0";

            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
            }
            if (attr1 == 'sellpoint-panel') {
                this.addPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.addGalleryPanel = false;
            }
            if (attr1 == 'spProductsPanel') {
                if (attr2 == 'show-products') {
                    this.products = this.products_unfiltered;
                }
                this.spMarketPanel = false;
                this.spProductsPanel = true;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;

                if (attr2 == 'market') {
                    this.spMarketPanel = true;
                }
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spProfilePanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = true;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spContactPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spDeliveryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spDeliveryPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spMessagesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spOrdersPanel = false;
                this.spMessagesPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spOrdersPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spSettingsPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = true;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spSubscriptionPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spServicesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = true;
            }
            if (attr1 == 'spBlogPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spServicesPanel = false;
                this.spGalleryPanel = false;
                this.spBlogPanel = true;
            }
            if (attr1 == 'spGalleryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spServicesPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = true;
            }
            if (attr1 == 'add-product') {
                this.addPanel = true;
                this.addProductPanel = true;
                this.addPostPanel = false;
                this.addGalleryPanel = false;
                this.addProductGalleryPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-post') {
                this.addPanel = true;
                this.addPostPanel = true;
                this.addProductPanel = false;
                this.addGalleryPanel = false;
                this.addProductGalleryPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-gallery') {
                this.addPanel = true;
                this.addGalleryPanel = true;
                this.addProductGalleryPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-gallery') {
                this.addPanel = true;
                this.addProductGalleryPanel = true;
                this.addGalleryPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'edit-category') {
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if (attr1 == 'reset-edit-category') {
                this.category.edit = false;
                this.category = {};
            }

            if (attr1 == 'view-all-products') {
                this.viewAllProductsBanner = false;
                this.products = this.products_unfiltered;
            }
            if (attr1 == 'list-view') {
                this.marketView = false;
                this.listView = true;
            }
            if (attr1 == 'market-view') {
                this.marketView = true;
                this.listView = false;
            }
            if (attr1 == 'add-delivery-information') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
            }
            if (attr1 == 'view-discounts') {
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.viewDiscounts = true;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'edit-service') {
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'edit-tagline') {
                this.details = {};
                this.details.tagline_edit = true;
            }
            if (attr1 == 'edit-profile') {
                this.details = {};
                this.details.profile_edit = true;
            }
            if (attr1 == 'edit-contact-info') {
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if (attr1 == 'edit-delivery-information') {
                this.details = {};
                this.details.delivery_edit = true;
            }
            if (attr1 == 'edit-bank-details') {
                this.details = {};
                this.details.bank_details_edit = true;
                this.set_bank_details = true;
            }
            if (attr1 == 'reset-delivery-information') {
                this.addDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = false;
            }
            if (attr1 == 'edit-discount-coupon') {
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }
            if (attr1 == 'reset-discount-coupon') {
                this.viewDiscounts = true;
                this.discount_coupon.edit = false;
                this.discount_coupon = {};
                this.setDiscount = false;
            }
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },


        prep: function prep() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");

            return parts[0];
        },

        syncset: function syncset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.site_url,
                request_from: service.site_name,
                request_status: "SENDING...",
                request: service.request_url_page };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.request_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                    }
                });
            }
        },
        toggleSidebar: function toggleSidebar() {
            if (this.showSidebarMobile == true) {
                this.showSidebarMobile = false;
            } else {
                this.showSidebarMobile = true;
            }
        },
        toggleFilterSortBoard: function toggleFilterSortBoard() {
            var x = document.getElementById("filterSortBoard");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        resetFilterSortOptions: function resetFilterSortOptions() {
            this.products = this.products_unfiltered;
            this.setComponent("spProductsPanel", "");
        },
        filterByPrice: function filterByPrice() {
            this.products = this.products_unfiltered;
            var self = this;
            this.products = this.products.filter(function (product) {
                return product.product_price_range >= self.slider_type[0] && product.product_price_range <= self.slider_type[1];
            });
            this.setComponent("spProductsPanel", "");
        },
        sortBy: function sortBy(sort_by) {
            this.sorting_by = sort_by;

            if (this.filter_array.length == 0) {
                this.products = this.products_unfiltered;
            }

            var self = this;
            var sorted_array = [];

            if (sort_by == 'featured') {
                sorted_array = this.products.filter(function (product) {
                    return product.product_is_featured == true;
                });
                if (sorted_array.length != 0) {
                    var orderd_sorted_array = this.local_sort_by_key(sorted_array, "product_featured_reg_date_f");
                    this.products = orderd_sorted_array.reverse();
                    this.product_search_messsage = "Showing Featured Products from list";
                }
            }

            if (sort_by == 'orders-made') {
                sorted_array = this.local_sort_by_key(this.products, "product_total_items_orders");
                this.products = sorted_array.reverse();
                this.product_search_messsage = "Showing Products from Highest to lowest Orders";
            }

            if (sort_by == 'discounted') {
                sorted_array = this.products.filter(function (product) {
                    return product.product_is_discounted != 0;
                });
                if (sorted_array.length != 0) {
                    this.products = this.local_sort_by_key(sorted_array, "product_reg_date_f");
                    this.product_search_messsage = "Showing Discounted Products from the list";
                }
            }

            if (sort_by == 'pre-orders') {
                sorted_array = this.products.filter(function (product) {
                    return product.product_is_featured == true;
                });
                if (sorted_array.length != 0) {
                    this.products = this.local_sort_by_key(sorted_array, "product_featured_reg_date_f");
                    this.product_search_messsage = "Showing Products that you can Pre Order";
                }
            }

            if (sort_by == 'price-low-high') {
                sorted_array = this.local_sort_by_key(this.products, "product_price_range");
                this.products = sorted_array;
                this.product_search_messsage = "Showing Products from Lowest to Highest prices";
            }

            if (sort_by == 'price-high-low') {
                sorted_array = this.local_sort_by_key(this.products, "product_price_range");

                this.products = sorted_array.reverse();
                this.product_search_messsage = "Showing Products from Highest to Lowest prices";
            }

            if (sorted_array.length == 0) {
                this.product_search_messsage = "No Products found...showing related matches";
            }

            if (this.filter_array.length != 0) {
                this.product_search_messsage = "";
            }

            this.setComponent("spProductsPanel", "");
        },
        local_sort_by_key: function local_sort_by_key(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];var y = b[key];
                return x < y ? -1 : x > y ? 1 : 0;
            });
        },
        filterBy: function filterBy(filter_key, filter_key_value_id, filter_key_value) {
            var array_row = [filter_key, filter_key_value_id, filter_key_value];

            if (this.filter_array.length != 0) {
                var index = this.filter_array.findIndex(function (c) {
                    return c[1] === filter_key_value_id;
                });
                if (index < 0) {
                    this.filter_array.push(array_row);
                }
            } else {
                this.filter_array.push(array_row);
            }

            var filtered_array = [];
            var data = this.filter_array;

            data.forEach(function (row) {
                if (row[0] == 1) {
                    var products_to_filter = this.products_unfiltered;
                    products_to_filter.forEach(function (product) {
                        if (product.product_category_id == row[1]) {
                            if (filtered_array.length != 0) {
                                var _index = filtered_array.findIndex(function (p) {
                                    return p.product_id === product.product_id;
                                });
                                if (_index < 0) {
                                    filtered_array.push(product);
                                }
                            } else {
                                filtered_array.push(product);
                            }
                        }
                    }, this);
                }

                if (row[0] == 2) {
                    var _products_to_filter = this.products_unfiltered;
                    _products_to_filter.forEach(function (product) {
                        product.product_item_groups.forEach(function (group) {
                            if (group.product_item_group_name == row[2]) {
                                if (filtered_array.length != 0) {
                                    var _index2 = filtered_array.findIndex(function (p) {
                                        return p.product_id === product.product_id;
                                    });
                                    if (_index2 < 0) {
                                        filtered_array.push(product);
                                    }
                                } else {
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);
                }

                if (row[0] == 3) {
                    var _products_to_filter2 = this.products_unfiltered;
                    _products_to_filter2.forEach(function (product) {
                        product.product_items.forEach(function (item) {
                            if (item.product_item_size == row[2]) {
                                if (filtered_array.length != 0) {
                                    var _index3 = filtered_array.findIndex(function (p) {
                                        return p.product_id === product.product_id;
                                    });
                                    if (_index3 < 0) {
                                        filtered_array.push(product);
                                    }
                                } else {
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);
                }

                if (row[0] == 4) {
                    var _products_to_filter3 = this.products_unfiltered;
                    _products_to_filter3.forEach(function (product) {
                        product.product_items.forEach(function (item) {
                            if (item.product_item_service_tag == row[2]) {
                                if (filtered_array.length != 0) {
                                    var _index4 = filtered_array.findIndex(function (p) {
                                        return p.product_id === product.product_id;
                                    });
                                    if (_index4 < 0) {
                                        filtered_array.push(product);
                                    }
                                } else {
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);
                }
            }, this);

            if (filtered_array.length != 0) this.products = filtered_array;else {
                this.products = this.products_unfiltered;
            }

            this.sortBy(this.sorting_by);

            this.setComponent("spProductsPanel", "");
        },
        searchProductsByBusiness: function searchProductsByBusiness() {
            var _this = this;

            service.searchProductsByBusiness(this, this.search_data, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.product.product_search_messsage = "Showing search result for " + _this.search_data;
                    if (_this.products.length == 0) {
                        _this.product.product_search_messsage = "No products found";
                    }
                    _this.setComponent("spProductsPanel", "");
                }
            }).catch(function (err) {});
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.setSellpoint();
                        }, _this2);
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        is_editing: function is_editing() {
            var _this3 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.edit_mode = true;
                        _this3.can_edit = true;
                    } else {
                        _this3.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getIPAddress: function getIPAddress() {
            var _this4 = this;

            service.getIPAddress(this).then(function (response) {
                _this4.ipaddress = response.data;
            }).catch(function (err) {});
        },
        getStates: function getStates() {
            var _this5 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this5.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this6 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this6.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        setSellpoint: function setSellpoint() {
            var _this7 = this;

            this.loading = true;
            var sp = "";
            if (this.$route.params.id != undefined) {
                sp = this.$route.params.id;
            } else {
                sp = this.prep();
            }
            service.getBusinessByUserName(this, sp).then(function (response) {
                if (response.body.status == 200) {
                    _this7.sellpoint = response.body.data;
                    localStorage.setItem("sp#cp", _this7.sellpoint.business_username);
                    document.title = _this7.sellpoint.business_name + " | SP";
                    localStorage.setItem("sp_#_sellpoint", _this7.sellpoint.business_username);

                    _this7.siteUrl = service.siteUrl + "?s=" + _this7.sellpoint.business_username + "&s1=" + encodeURI(_this7.sellpoint.business_name) + "&s2=" + encodeURI(_this7.sellpoint.business_name) + "&s3=" + encodeURI(_this7.sellpoint.business_tagline) + "&s4=" + _this7.sellpoint.business_banner_image + " ";

                    _this7.is_editing();

                    if (_this7.sellpoint.business_market_category_id != 1) {
                        _this7.getSellpointMarket();
                    }
                    _this7.prepareFilters();

                    if (_this7.sellpoint.business_layout == 1) {
                        _this7.spProductsPanel = true;
                    } else if (_this7.sellpoint.business_layout == 2) {
                        _this7.spServicesPanel = true;
                    } else if (_this7.sellpoint.business_layout == 3) {
                        _this7.spGalleryPanel = true;
                    } else if (_this7.sellpoint.business_layout == 4) {
                        _this7.spBlogPanel = true;
                    } else {
                        _this7.spProductsPanel = true;
                    }

                    _this7.loading = false;

                    var promises = [];
                    for (var i = 0; i < 9; ++i) {
                        if (i == 1) {
                            promises.push(_this7.getCategories(_this7.sellpoint.business_category_id));
                        }
                        if (i == 2) {
                            promises.push(_this7.getSellpointProducts());
                        }
                        if (i == 3) {
                            promises.push(_this7.getSellpointNotifications());
                        }

                        if (i == 4) {
                            promises.push(_this7.getSellpointMessages());
                        }

                        if (i == 5) {
                            promises.push(_this7.getSellpointOrders());
                        }

                        if (i == 6) {
                            promises.push(_this7.getFilters());
                        }
                        if (i == 7) {
                            promises.push(_this7.getPosts());
                        }
                        if (i == 8) {
                            promises.push(_this7.getGalleryPosts());
                        }
                    }

                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                        var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                        promises.forEach(function (promise) {
                            result.then(function () {});
                        });
                    }).catch(function (e) {});
                } else {}
            }).catch(function (err) {
                console.log(err);
                _this7.loading = true;
            });
        },
        prepareFilters: function prepareFilters() {
            this.sellpoint.business_filters.forEach(function (filter) {
                if (filter.business_filter_id == 2) {
                    this.price_filter_is_set = true;
                }
                if (filter.business_filter_id == 3) {
                    this.color_filter_is_set = true;
                }
                if (filter.business_filter_id == 4) {
                    this.size_filter_is_set = true;
                }
            }, this);
        },
        getSellpointNotifications: function getSellpointNotifications() {
            var _this8 = this;

            service.getBusinessNotifications(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this8.notifications = response.body.data;
                    _this8.notifications_unread = response.body.data_1;
                }
            }).catch(function (err) {});
        },
        getSellpointMessages: function getSellpointMessages() {
            var _this9 = this;

            service.getBusinessMessages(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this9.messages = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointOrders: function getSellpointOrders() {
            var _this10 = this;

            service.getBusinessOrders(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this10.orders = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this11 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this11.products = response.body.data;
                    _this11.products_unfiltered = response.body.data;

                    _this11.slider_type = [response.body.min_price_range, response.body.max_price_range];
                    _this11.slider_options.min = response.body.min_price_range;
                    _this11.slider_options.max = response.body.max_price_range;

                    _this11.sellpoint_product_item_groups = response.body.data_product_items_groups_filtered;
                    _this11.sellpoint_product_sizes = response.body.data_product_sizes_filtered;
                    _this11.sellpoint_product_services = response.body.data_product_services_filtered;
                }
            }).catch(function (err) {});
        },
        getSellpointMarketProducts: function getSellpointMarketProducts() {
            var _this12 = this;

            service.getMarketProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this12.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this13 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this13.subscriptions = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this14 = this;

            service.getBusinessMarket(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this14.market = response.body.data;
                    _this14.getMarketMainProductsAsSubscriptions();
                    _this14.getSellpointMarketProducts();
                }
            }).catch(function (err) {
                _this14.getIPAddress();
                _this14.market = {};

                var err_payload = {
                    err_int_id: _this14.user.user_id || 0,
                    err_mod_id: 5,
                    err_route: _this14.$route.path,
                    err_func: "getSellpointMarket",
                    err_api_cl: "GET::" + err.url,
                    err_message: err.bodyText,
                    err_ln_rang: '363-377',
                    err_poss_cos: "returned could be 404 || 400",
                    err_ip_address: _this14.ipaddress
                };
            });
        },
        getPosts: function getPosts() {
            var _this15 = this;

            service.getPointPosts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this15.posts = response.body.data;
                }
            }).catch(function (err) {});
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this16 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, 50, 0, 50).then(function (response) {
                if (response.body.status == 200) {
                    _this16.galleria = response.body.data;
                }
            }).catch(function (err) {});
        },
        getFilters: function getFilters() {
            var _this17 = this;

            service.getFilters(this).then(function (response) {
                if (response.body.status == 200) {
                    _this17.filters = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this18 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this18.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        addCategory: function addCategory() {
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                business_id: this.sellpoint.business_id
            };
            service.addCategory(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Category Added Successfull", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {});
        },
        editCategory: function editCategory() {
            var _this19 = this;

            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Category edited", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {
                _this19.category = {};
            });
        },
        getCategoryProducts: function getCategoryProducts(category) {
            var products_to_filter = this.products_unfiltered;
            var fetch_array = [];
            products_to_filter.forEach(function (product) {
                if (product.product_category_id == category.business_category_id) {
                    fetch_array.push(product);
                }
            }, this);
            this.products = fetch_array;
            this.setComponent("spProductsPanel", "");
            this.viewAllProductsBanner = true;
        },
        onFileChange: function onFileChange(e, type) {
            var _this20 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this20.sellpoint.business_banner_image = data.body.data;
                        }
                        if (type == "business_brand_image") {
                            _this20.sellpoint.business_brand_image = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        addService: function addService() {
            var _this21 = this;

            var payload = {
                business_service: this.service.service_name || "Service Details",
                business_id: this.sellpoint.business_id
            };
            service.addService(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Service Added Successfully", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service = {};
                }
            }).catch(function (err) {
                _this21.service = {};
            });
        },
        editService: function editService() {
            var _this22 = this;

            this.service.business_id = this.sellpoint.business_id;
            service.editService(this, this.service).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Service edited", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service.edit_set = false;
                    this.service = {};
                }
            }).catch(function (err) {
                _this22.service = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this23 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this23.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            toastr.success("Sellpoint Delivery Details edited", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this24.delivery_option.edit_set = false;
                        _this24.editDeliveryInformation = false;
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this25 = this;

            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Delivery Details deleted", 'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this25.delivery_option = {};
            });
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this26 = this;

            if (attr == "tagline") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_tagline: this.sellpoint.business_tagline
                };
            }
            if (attr == "profile") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_profile: this.sellpoint.business_profile
                };
            }
            if (attr == "contact_info") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint edited", 'Success!');
                }
                this.details = {};
            }).catch(function (err) {
                _this26.details = {};
            });
        },
        sendBusinessContactForm: function sendBusinessContactForm() {
            var _this27 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                contact_form_name: this.contact_form.name || "nill",
                contact_form_email: this.contact_form.email || "nill",
                contact_form_message: this.contact_form.message || "nill"
            };
            service.sendBusinessContactForm(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Message Sent", 'Ok!');
                }
                this.contact_form = {};
            }).catch(function (err) {
                _this27.contact_form = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    product_item_id: 0,
                    is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                    coupon_business_category: this.discount_coupon.discount_category,
                    coupon_percentage: this.discount_coupon.discount_percentage,
                    coupon_start_date: this.discount_coupon.discount_start_date,
                    coupon_end_date: this.discount_coupon.discount_end_date
                };
                service.setDiscountsAndCoupons(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("New Discount Set", 'Update!');
                        this.sellpoint.business_discounts_coupons = data.body.data;
                        this.setComponentActions('reset-discount-coupon', '');
                    }
                }).catch(function (err) {});
            } else {
                validated_arr.forEach(function (error) {
                    toastr.error(error);
                }, this);
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        setBankDetails: function setBankDetails() {
            var payload = {
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessBankDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Bank Details Set", 'Update!');
                }
                this.set_bank_details = false;
            }).catch(function (err) {});
        },
        switchProcessingFee: function switchProcessingFee(to) {
            var payload = {
                business_process_fee_pay: to,
                business_id: this.sellpoint.business_id
            };

            service.switchProcessingFeePay(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Processing Fee Set", 'Reset!');
                    this.sellpoint.business_processing_fee_pay_status = to;
                }
            }).catch(function (err) {});
        },
        setFilterOptions: function setFilterOptions() {
            var payload = {
                business_filters: this.selected_filters,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessFilterOptions(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Filter Options Set", 'Update!');
                }
                this.sellpoint.business_filters = data.body.data;
            }).catch(function (err) {});
        },
        removeFilterOption: function removeFilterOption(option) {
            var payload = {
                business_filter: option,
                business_id: this.sellpoint.business_id
            };

            service.removeBusinessFilterOption(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Filter Option Removed", 'Update!');
                }
                this.sellpoint.business_filters = data.body.data;
            }).catch(function (err) {});
        },
        readNotifications: function readNotifications() {
            this.notifications_unread = 0;
            var payload = {
                notification_type: "business",
                notification_module: "notifications",
                notification_business: this.sellpoint.business_username
            };
            service.readNotifications(this, payload).then(function (data) {}).catch(function (err) {});
        }
    },
    mounted: function mounted() {
        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.setSellpoint();
        }
    },
    created: function created() {
        this.loading = true;


        this.getStates();
        this.getIPAddress();
    }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(9);




var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            group_products: {},
            item_product: {},
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            coupon_code: [],
            product_delivery_fee: "",
            sellpoint_delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_delivery_fee: 0.0,
            processed_groups: 0,
            process_count: 0,
            loggedIn: false
        };
    },

    components: {},
    computed: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        toggleProductDelivery: function toggleProductDelivery(attr1, i, product_index) {
            if (attr1 == 'item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if (attr1 == 'hide-item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },
        toggleSellpointDelivery: function toggleSellpointDelivery(attr1, i) {
            if (attr1 == 'group-delivery-options') {
                this.sorted_cart[i].display_delivery_details++;
            }
            if (attr1 == 'hide-group-delivery-options') {
                this.sorted_cart[i].display_delivery_details = false;
            }
        },
        removeFromCart: function removeFromCart(item_id, group_index, item) {
            this.removeFromSortedCart(group_index, item);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["j" /* REMOVE_FROM_CART */], item_id);
        },
        removeFromSortedCart: function removeFromSortedCart(group_index, item) {
            var index = this.sorted_cart[group_index][1].findIndex(function (p) {
                return p._id === item._id;
            });
            this.sorted_cart[group_index][1].splice(index, 1);
        },
        prepCart: function prepCart() {
            var sorted_cart = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.cart.reduce(function (result, obj) {
                (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                return result;
            }, {}));
            var count = 0;var sorted_cart_array = [];
            sorted_cart.forEach(function (element) {
                var pre_sort = [];

                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];

                element.forEach(function (item) {
                    item.can_remove = true;
                    item.display_delivery_details = false;

                    item.has_delivery = false;
                    if (item.product_checked) {
                        item.product_checked = false;
                    }

                    service.getProductDeliveryOptions(this, item.product_main_id).then(function (response) {
                        if (response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        } else {
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch(function (err) {
                        pre_sort.products_without_delivery_details_count += 1;
                    });
                }, this);
                pre_sort.display_delivery_details = 0;
                pre_sort[0] = element[0].product_business;
                pre_sort[1] = element;
                pre_sort.items_in_checkout = 0;
                pre_sort.total_order_amt = 0.0;
                pre_sort.delivery_option_fee = 0.0;
                pre_sort.total_delivery_charge = 0.0;
                pre_sort.order_coupons_discounts = [];
                var promises = [];
                for (var i = 0; i < 5; ++i) {
                    if (i == 1) {
                        promises.push(service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[4] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 2) {
                        promises.push(service.getBusinessDeliveryOptions(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[2] = response.body.data;
                            } else {
                                pre_sort.delivery_option = "Free Delivery";
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 3) {
                        promises.push(service.checkBusinessPayOnDelivery(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[3] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }
                }

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                    sorted_cart_array.push(pre_sort);
                }).catch(function (e) {});
            }, this);

            this.sorted_cart = sorted_cart_array;
            return this.sorted_cart;
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.prepCart();
                        }, _this);
                        _this.loggedIn = true;
                    } else {}
                    _this.loading = false;
                }).catch(function (err) {
                    if (err) {}
                });
            } else {
                this.$router.push('login');
            }
        },
        set_coupons: function set_coupons(i, coupon, coupon_percentage) {
            var calc = 0;
            if (this.sorted_cart[i].total_order_amt != 0) {
                if (!coupon.added) {
                    calc = coupon_percentage / 100 * this.sorted_cart[i].total_order_amt;

                    coupon.added = true;
                    coupon.value = calc;
                    this.sorted_cart[i].order_coupons_discounts.push(coupon);

                    this.sorted_cart[i].total_order_amt -= calc;

                    this.total_order_amt -= calc;
                } else {
                    calc = coupon.value;

                    coupon.added = false;
                    var index = this.sorted_cart[i].order_coupons_discounts.findIndex(function (c) {
                        return c.discount_id === coupon.discount_id;
                    });
                    this.sorted_cart[i].order_coupons_discounts.splice(index, 1);

                    this.sorted_cart[i].total_order_amt += calc;

                    this.total_order_amt += calc;
                    coupon.value = 0;
                }
            } else {
                toastr.warning("Select an Order", 'Warning!');
                this.coupon_code.checked = false;
            }
        },
        calc_product_delivery_fee: function calc_product_delivery_fee(i, option, product_index) {
            if (this.sorted_cart[i][1][product_index].delivery_option_fee != undefined) {
                if (this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0) {
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option;

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee: function calc_sellpoint_delivery_fee(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);

            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_total_delivery_fee: function calc_total_delivery_fee() {
            this.sorted_cart.forEach(function (element) {});
        },
        setPaymentOption: function setPaymentOption(i, option) {
            this.sorted_cart[i].payment_mode = option;
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        refreshCheckout: function refreshCheckout(it, group_index, item_index) {
            this.sorted_cart[group_index].total_order_amt = 0;
            this.total_order_amt = 0;
            this.checked_out.forEach(function (item) {
                this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

                this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            }, this);
        },
        addToCheckout: function addToCheckout(item, group_index, item_index) {
            this.sorted_cart[group_index][1][item_index].can_remove = false;
            this.sorted_cart[group_index].products_in_checkout = true;
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            } else {
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true;
            this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout++;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true;
            }
        },
        removeFromCheckout: function removeFromCheckout(item, group_index, item_index) {
            var index = this.checked_out.findIndex(function (p) {
                return p._id === item._id;
            });
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                var _index = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(_index, 1);;
            } else {
                var _index2 = this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(_index2, 1);;
            }

            this.sorted_cart[group_index].total_order_amt -= item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout--;

            this.sorted_cart[group_index][1][item_index].can_remove = true;
            if (this.sorted_cart[group_index].items_in_checkout == 0 && this.sorted_cart[group_index].delivery_option != "Free Delivery") {
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee;
                this.sorted_cart[group_index].delivery_option_fee = 0;
                this.sorted_cart[group_index].delivery_option = 0;
                this.sorted_cart[group_index].total_delivery_charge = 0;
            }
        },
        process_checkout: function process_checkout(group) {
            var processed_checkout = {};

            processed_checkout.order_user_id = this.user.user_id;
            processed_checkout.order_mode = 1;
            processed_checkout.order_business = group[0];
            processed_checkout.order_delivery_option = group.delivery_option;
            processed_checkout.order_payment_mode = group.payment_mode || 1;
            processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
            processed_checkout.order_items = [];
            this.checked_out.forEach(function (element) {
                if (element.product_business == group[0]) {
                    processed_checkout.order_items.push(element);
                }
                processed_checkout.status = "processed";
            }, this);
            if (processed_checkout.status == "processed") {
                service.checkout(this, processed_checkout).then(function (data) {
                    if (data.body.status == 201) {
                        this.process_count++;

                        processed_checkout.order_items.forEach(function (item) {
                            this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                            var index = this.checked_out.findIndex(function (p) {
                                return p._id === item._id;
                            });
                            this.checked_out.splice(index, 1);
                        }, this);
                    }

                    if (this.process_count == this.processed_groups) {
                        this.total_delivery_fee = 0;
                        this.total_order_amt = 0;

                        location.replace("/checkout");
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                    }
                });
            }
        },
        process_orders: function process_orders() {
            var processed = [];
            var product_errors = 0;

            this.checked_out.forEach(function (item) {
                if (item.has_delivery && item.delivery_option == 0) {
                    product_errors++;
                    toastr.error("Please select a delivery option for " + item.product_name, 'Warning!');
                }
            }, this);

            this.sorted_cart.forEach(function (group) {
                var with_delivery = group.products_with_delivery_details_checked.length;
                var without_delivery = group.products_without_delivery_details_checked.length;

                if (with_delivery != 0 && without_delivery == 0) {
                    group.delivery_option = "Product Specific Delivery Set";
                }

                if (group.items_in_checkout) {
                    if (group.delivery_option != 0 && group.delivery_option != undefined) {
                        processed.push(group);
                    } else {
                        product_errors++;
                        toastr.error("Please select a delivery option for " + group[0], 'Warning!');
                    }
                }
            }, this);

            if (processed.length != 0 && product_errors == 0) {
                this.processed_groups = processed.length;
                processed.forEach(function (group) {
                    this.process_checkout(group);
                }, this);
            }
        },
        processPayment: function processPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this2 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_user_id: this.user.user_id
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Payment Processed!", "Success!");

                        if (_this2.request_page != '') {
                            _this2.$router.push(_this2.request_page);
                        } else {
                            _this2.$router.go('/');
                        }
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        document.title = "Cart" + " | SP";

        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.prepCart();
        }
    }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(9);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            user: {},
            selected_order: [],
            checkout_orders: {},
            delivery_details: [],
            payment_details: {},
            payment_mode: "",
            request_page: "orders",
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            item_delivery_fee: "",
            delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_orders_amount: 0.0,
            states: {},
            cities: []
        };
    },

    components: {},
    computed: {},
    methods: {
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, i) {
            var _this2 = this;

            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        displayDeliveryOptions: function displayDeliveryOptions(order) {
            this.selected_order = [];
            this.selected_order = order;
            if (this.selected_order.display_delivery) {
                this.selected_order.display_delivery = false;
            } else {
                this.selected_order.display_delivery = true;
            }
        },
        preset: function preset() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            if (this.$route.query["order"]) {
                                this.getCheckoutOrder();
                            } else {
                                this.getCheckoutOrders();
                            }
                            this.getUserDeliveryDetails();
                        }, _this3);
                    } else {}
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                    }
                });
            } else {}
        },
        getCheckoutOrder: function getCheckoutOrder() {
            var _this4 = this;

            service.getCheckoutOrder(this, this.$route.query["order"]).then(function (response) {
                if (response.body.status == 200) {
                    _this4.checkout_orders = response.body.data;
                    _this4.total_orders_amount = response.body.data_total_orders_amount;
                    _this4.payment_details = response.body.payment_data;

                    _this4.checkout_orders.forEach(function (order) {
                        order.display_delivery = false;
                    }, _this4);
                }
            }).catch(function (err) {
                _this4.$router.push("orders");
            });
        },
        getCheckoutOrders: function getCheckoutOrders() {
            var _this5 = this;

            service.getCheckoutOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.checkout_orders = response.body.data;

                    _this5.total_orders_amount = response.body.data_total_orders_amount;
                    _this5.payment_details = response.body.payment_data;

                    _this5.checkout_orders.forEach(function (order) {
                        order.display_delivery = false;
                        order.cities = {};
                    }, _this5);
                } else {
                    _this5.$router.push("orders");
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        getUserDeliveryDetails: function getUserDeliveryDetails() {
            var _this6 = this;

            service.getUserDeliveryDetails(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.delivery_details = response.body.data;
                }
            }).catch(function (err) {});
        },
        calc_delivery_fee: function calc_delivery_fee(i, option) {
            this.total_order_amt -= this.checkout_orders[i].order_delivery_fee;
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_delivery_fee;
            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;

            this.total_order_amt += option.business_delivery_option_price;
            this.checkout_orders[i].order_total += option.business_delivery_option_price;
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == option.business_delivery_option) {
                    this.checkout_orders[i].order_user_delivery_addresses = [];

                    this.checkout_orders[i].order_user_delivery_addresses.push(detail);
                }
            }, this);
        },
        calc_product_specific_delivery_fee: function calc_product_specific_delivery_fee(i, i2, option) {
            this.total_order_amt -= this.checkout_orders[i].order_items[i2].order_delivery_fee;
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_items[i2].order_delivery_fee;
            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_delivery_city = option.business_delivery_option;

            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;

            this.total_order_amt += option.business_delivery_option_price;
            this.checkout_orders[i].order_total += option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_user_delivery_addresses = [];

            this.delivery_details.forEach(function (detail) {
                if (detail.address_city == option.business_delivery_option_city_id) {
                    this.checkout_orders[i].order_items[i2].order_user_delivery_addresses.push(detail);
                } else {}
            }, this);
        },
        setUserDeliveryAddress: function setUserDeliveryAddress(i, city) {
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == city) {
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },
        setPaymentOption: function setPaymentOption(option) {
            this.payment_mode = option;
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        processPayment: function processPayment() {
            var process_errors = [];

            this.checkout_orders.forEach(function (order) {
                if (order.order_user_delivery_address == undefined && order.order_user_new_delivery_address == undefined) {
                    process_errors.push("Please enter delivery address for " + order.order_business);
                }

                order.order_items.forEach(function (item) {
                    if (item.order_delivery_city) {
                        if (item.order_user_delivery_address == undefined && item.order_user_new_delivery_address == undefined) {
                            process_errors.push("Please enter delivery address for " + item.product_name);
                        }
                    }
                }, this);
            }, this);
            if (process_errors.length != 0) {
                process_errors.forEach(function (error) {
                    toastr.error(error);
                }, this);
            } else {
                this.processCardPayment(this.payment_details);
            }
        },
        processCardPayment: function processCardPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this7 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_user_id: this.user.user_id,
                payment_orders: this.checkout_orders,
                payment_details: this.payment_details.payment_service
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Payment Processed!", "Success!");

                        if (_this7.request_page != '') {
                            _this7.$router.push(_this7.request_page);
                        } else {
                            _this7.$router.go('/');
                        }
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        document.title = "Checkout" + " | SP";

        this.preset();
        this.getStates();
    }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(9);



var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            group_products: {},
            item_product: {},
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            coupon_code: [],
            delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_delivery_fee: 0.0,
            processed_groups: 0,
            process_count: 0,
            disable_btn: false,
            order_url: "" };
    },

    components: {},
    computed: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        toggleProductDelivery: function toggleProductDelivery(attr1, i, product_index) {
            if (attr1 == 'item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if (attr1 == 'hide-item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },
        toggleSellpointDelivery: function toggleSellpointDelivery(attr1, i) {
            if (attr1 == 'group-delivery-options') {
                this.sorted_cart[i].display_delivery_details++;
            }
            if (attr1 == 'hide-group-delivery-options') {
                this.sorted_cart[i].display_delivery_details = false;
            }
        },
        removeFromCart: function removeFromCart(item_id, group_index, item) {
            this.removeFromSortedCart(group_index, item);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* REMOVE_FROM_CART */], item_id);
        },
        removeFromSortedCart: function removeFromSortedCart(group_index, item) {
            var index = this.sorted_cart[group_index][1].findIndex(function (p) {
                return p._id === item._id;
            });
            this.sorted_cart[group_index][1].splice(index, 1);
        },
        prepCart: function prepCart() {
            var active_orders = [];
            this.cart.forEach(function (item) {
                if (item.active_order) {
                    active_orders.push(item);
                }
            }, this);

            var sorted_cart = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(active_orders.reduce(function (result, obj) {
                (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                return result;
            }, {}));
            var count = 0;var sorted_cart_array = [];
            sorted_cart.forEach(function (element) {
                var _this = this;

                var pre_sort = [];

                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];

                element.forEach(function (item) {
                    item.can_remove = true;
                    item.display_delivery_details = false;

                    item.has_delivery = false;
                    if (item.product_checked) {
                        item.product_checked = false;
                    }

                    service.getProductDeliveryOptions(this, item.product_main_id).then(function (response) {
                        if (response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        }
                    }).catch(function (err) {
                        pre_sort.products_without_delivery_details_count += 1;
                    });
                }, this);
                pre_sort.display_delivery_details = 0;
                pre_sort[0] = element[0].product_business;
                pre_sort[1] = element;
                pre_sort.items_in_checkout = 0;
                pre_sort.total_order_amt = 0.0;
                pre_sort.delivery_option_fee = 0.0;
                pre_sort.total_delivery_charge = 0.0;
                pre_sort.order_coupons_discounts = [];
                service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(function (response) {
                    if (response.body.status == 200) {
                        pre_sort[4] = response.body.data;
                    }
                }).catch(function (err) {});

                service.getBusinessDeliveryOptions(this, element[0].product_business).then(function (response) {
                    pre_sort[2] = response.body.data;
                    if (response.status == 204) {
                        pre_sort.delivery_option = "Free Delivery";
                    }

                    service.checkBusinessPayOnDelivery(_this, element[0].product_business).then(function (response) {
                        if (response.body.status == 200) {
                            pre_sort[3] = response.body.data;
                            sorted_cart_array.push(pre_sort);
                        }
                    }).catch(function (err) {});
                }).catch(function (err) {});
            }, this);

            this.sorted_cart = sorted_cart_array;
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.prepCart();
                        }, _this2);
                    } else {}
                    _this2.loading = false;
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        login: function login() {
            var _this3 = this;

            this.disable_btn = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name);
                        localStorage.setItem("sp_token", data.user_session_key);
                        localStorage.setItem("sp_token_key", data.user_token_key);
                        navi.push('account');
                    } else {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this3.disable_btn = false;
                    }
                }).catch(function (err) {
                    toastr.warning("invalid login credentials", 'Warning!');
                    _this3.disable_btn = false;
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        set_coupons: function set_coupons(i, coupon, coupon_percentage) {
            var calc = 0;
            if (this.sorted_cart[i].total_order_amt != 0) {
                if (!coupon.added) {
                    calc = coupon_percentage / 100 * this.sorted_cart[i].total_order_amt;

                    coupon.added = true;
                    coupon.value = calc;
                    this.sorted_cart[i].order_coupons_discounts.push(coupon);

                    this.sorted_cart[i].total_order_amt -= calc;

                    this.total_order_amt -= calc;
                } else {
                    calc = coupon.value;

                    coupon.added = false;
                    var index = this.sorted_cart[i].order_coupons_discounts.findIndex(function (c) {
                        return c.discount_id === coupon.discount_id;
                    });
                    this.sorted_cart[i].order_coupons_discounts.splice(index, 1);

                    this.sorted_cart[i].total_order_amt += calc;

                    this.total_order_amt += calc;
                    coupon.value = 0;
                }
            } else {
                toastr.warning("Select an Order", 'Warning!');
                this.coupon_code.checked = false;
            }
        },
        calc_product_delivery_fee: function calc_product_delivery_fee(i, option, product_index) {
            if (this.sorted_cart[i][1][product_index].delivery_option_fee != undefined) {
                if (this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0) {
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }
            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = option.business_delivery_option_price;

            this.sorted_cart[i].total_delivery_charge += option.business_delivery_option_price;
            this.total_delivery_fee += option.business_delivery_option_price;
        },
        calc_sellpoint_delivery_fee: function calc_sellpoint_delivery_fee(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = option.business_delivery_option_price;

            this.sorted_cart[i].total_delivery_charge += option.business_delivery_option_price;

            this.total_delivery_fee += option.business_delivery_option_price;
        },
        calc_total_delivery_fee: function calc_total_delivery_fee() {
            this.sorted_cart.forEach(function (element) {});
        },
        setPaymentOption: function setPaymentOption(i, option) {
            this.sorted_cart[i].payment_mode = option;
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        refreshCheckout: function refreshCheckout(it, group_index, item_index) {
            this.sorted_cart[group_index].total_order_amt = 0;
            this.total_order_amt = 0;
            this.checked_out.forEach(function (item) {
                this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

                this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            }, this);
        },
        addToCheckout: function addToCheckout(item, group_index, item_index) {
            this.sorted_cart[group_index][1][item_index].can_remove = false;
            this.sorted_cart[group_index].products_in_checkout = true;
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            } else {
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true;
            this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout++;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true;
            }
        },
        removeFromCheckout: function removeFromCheckout(item, group_index, item_index) {
            var index = this.checked_out.findIndex(function (p) {
                return p._id === item._id;
            });
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                var _index = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(_index, 1);;
            } else {
                var _index2 = this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(_index2, 1);;
            }

            this.sorted_cart[group_index].total_order_amt -= item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout--;

            this.sorted_cart[group_index][1][item_index].can_remove = true;
            if (this.sorted_cart[group_index].items_in_checkout == 0 && this.sorted_cart[group_index].delivery_option != "Free Delivery") {
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee;
                this.sorted_cart[group_index].delivery_option_fee = 0;
                this.sorted_cart[group_index].delivery_option = 0;
                this.sorted_cart[group_index].total_delivery_charge = 0;
            }
        },
        process_checkout: function process_checkout(group) {
            var processed_checkout = {};

            processed_checkout.order_user_id = this.user.user_id;
            processed_checkout.order_business = group[0];
            processed_checkout.order_delivery_option = group.delivery_option;
            processed_checkout.order_payment_mode = group.payment_mode || 1;
            processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
            processed_checkout.order_items = [];

            this.checked_out.forEach(function (element) {
                if (element.product_business == group[0]) {
                    processed_checkout.order_url = element.product_order_url;
                    this.order_url = element.product_order_url;
                    processed_checkout.order_items.push(element);
                }
                processed_checkout.status = "processed";
            }, this);
            if (processed_checkout.status == "processed") {
                service.checkout(this, processed_checkout).then(function (data) {
                    if (data.body.status == 201) {
                        this.process_count++;

                        processed_checkout.order_items.forEach(function (item) {
                            this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                            var index = this.checked_out.findIndex(function (p) {
                                return p._id === item._id;
                            });
                            this.checked_out.splice(index, 1);
                        }, this);
                    }

                    if (this.process_count == this.processed_groups) {
                        this.total_delivery_fee = 0;
                        this.total_order_amt = 0;

                        location.replace("/checkout?order=" + this.order_url);
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                    }
                });
            }
        },
        process_orders: function process_orders() {
            var processed = [];
            var product_errors = 0;

            this.checked_out.forEach(function (item) {
                if (item.has_delivery && item.delivery_option == 0) {
                    product_errors++;
                    toastr.error("Please select a delivery option for " + item.product_name, 'Warning!');
                }
            }, this);

            this.sorted_cart.forEach(function (group) {
                var with_delivery = group.products_with_delivery_details_checked.length;
                var without_delivery = group.products_without_delivery_details_checked.length;

                if (with_delivery != 0 && without_delivery == 0) {
                    group.delivery_option = "Product Specific Delivery Set";
                }

                if (group.items_in_checkout) {
                    if (group.delivery_option != 0 && group.delivery_option != undefined) {
                        processed.push(group);
                    } else {
                        toastr.error("Please select a delivery option for " + group[0], 'Warning!');
                    }
                }
            }, this);

            if (processed.length != 0 && product_errors == 0) {
                this.processed_groups = processed.length;
                processed.forEach(function (group) {
                    this.process_checkout(group);
                }, this);
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Orders',
    data: function data() {
        return {
            user: {},
            orders: {},
            order: {},
            img_product_url: service.imageProductsURL
        };
    },

    components: {},

    methods: {
        setOrder: function setOrder(order) {
            this.order = order;
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getOrders: function getOrders() {
            var _this2 = this;

            service.getOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.orders = response.body.data;
                    _this2.orders.set = true;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        document.title = "Orders" + " | SP";

        this.preset();
    }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            business_product_categories: [],
            business_service_categories: [],
            market_categories: {},
            business_category_type: 0,
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            validate_user_name_message: "",
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            onboarding: false,
            sp_set: false,
            bp_set: false,
            sp_set_layout: false,
            not_onboarding: false,
            bp_interests: []
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        validateUserName: function validateUserName() {
            var _this = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status == 200) {
                    _this.validate_user_name_error = false;
                    _this.validate_user_name_message = "This sellpoint does not exist";
                } else {
                    _this.validate_user_name_error = true;
                    _this.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this.validate_user_name_error = true;
                _this.validate_user_name_message = "This username already exist";
            });
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this2);

                        _this2.getBusinessCategories();
                        _this2.getMarketCategories();
                        _this2.getSellpoints(_this2.user.user_id);

                        _this2.loading = false;
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;

                this.categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        },
        getMarketCategories: function getMarketCategories() {
            service.getMarketCategories(this).then(function (data) {
                this.market_categories = data.body.data;
            });
        },
        getSellpoints: function getSellpoints(user) {
            var _this3 = this;

            service.getBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    var result = data.body.data;
                    var arr = [];
                    result.forEach(function (element) {
                        if (element.business_type == 1) {
                            arr.push(element);
                        }
                    });
                    _this3.sellpoints = arr;
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        },
        setupAccount: function setupAccount(account) {
            if (account == "sp") {
                this.sp_set = true;
                this.sp_set_layout = true;
                this.onboarding = false;
            }
            if (account == "bp") {
                this.bp_set = true;
                this.onboarding = false;
            }
        },
        cancelSetupAccount: function cancelSetupAccount() {
            this.sp_set = false;
            this.bp_set = false;
            this.onboarding = true;
        },
        selectSellpointLayout: function selectSellpointLayout(layout) {
            this.business.business_view_layout = layout;
            this.sp_set_layout = false;
        },
        createBuypoint: function createBuypoint() {
            var _this4 = this;

            this.disable_btn = true;

            var credentials = {
                bp_interests: this.bp_interests,
                point_owner: this.user.user_id
            };
            var navi = this.$router;
            service.addUserBusinessInterests(this, credentials).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success(" Successfull", 'Success!');
                    navi.push('account');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.warning("Something went wrong", 'Warning!');
                    _this4.disable_btn = false;
                }
            });
        },
        createSellpoint: function createSellpoint() {
            var _this5 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_market_category: this.business.market_category || 0,
                business_layout: this.business.business_view_layout || 1,
                business_owner: this.user.user_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                this.business = data.body.data;
                                navi.push('/' + this.business.business_user_name);
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this5.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addSelectedExistingSellpoint: function addSelectedExistingSellpoint() {
            var _this6 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (credentials.business_user_name != undefined) {
                service.addExistingBusiness(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Sellpoint Added Successfull", 'Success!');

                        navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                        _this6.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        addExistingSellpoint: function addExistingSellpoint() {
            var _this7 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (!this.validate_user_name_error) {
                toastr.error('This Sellpoint does not exist', 'Warning!');
            } else {
                if (credentials.business_user_name != undefined) {
                    service.addExistingBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Added Successfull", 'Success!');

                            navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.warning("Something went wrong", 'Warning!');
                            _this7.disable_btn = false;
                        }
                    });
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addNewSellpoint: function addNewSellpoint() {
            var _this8 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill",
                business_layout: this.business.business_view_layout || 1 };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addNewBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this8.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.setup == "yes") {
            this.onboarding = true;
        } else if (this.$route.query.create == "new") {
            this.add_sellpoint = true;this.sp_set = true;

            this.not_onboarding = true;
        } else if (this.$route.query.create == "add") {
            this.sp_set = true;
            this.sp_set_layout = true;
            this.add_sellpoint = true;
            this.add_business = true;
            this.not_onboarding = true;
        } else {
            this.sp_set = true;
            this.sp_set_layout = true;
            this.not_onboarding = true;
        }
    }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue__);










var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            product: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            other_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel: false,
            removeProductPanel: false,
            product_details_descr: true,
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default.a,
        "product-item-form": __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default.a,
        'add-to-cart-button': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default.a,
        'product-cta-button': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default.a,
        'menu-left-bar': __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue___default.a

    },
    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'edit-product') {
                this.editProductPanel = true;
            }
            if (attr1 == 'remove-product') {
                this.removeProductPanel = true;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.product_item = attr2;
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.product.product_business_id;

                            this.is_editing();

                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true;
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        setProduct: function setProduct() {
            var _this5 = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product = response.body.data;

                    document.title = _this5.product.product_name + " | " + _this5.product.product_business_name + " | SP";

                    _this5.product_display_image = _this5.product.product_images[0];
                    _this5.product_item = _this5.product.product_items[0];

                    _this5.siteUrl = service.siteUrl + "?p=" + _this5.product.product_url_name + "&p1=" + _this5.product.product_business_ownername + "&p2=" + _this5.product.product_url_name + "&p3=" + encodeURI(_this5.product.product_name) + "&p4=" + encodeURI(_this5.product.product_description) + "&p5=" + _this5.product_item.product_item_image + " ";

                    _this5.product.product_share_url = "http://sellpoints.com.ng/" + _this5.product.product_business_ownername + "/" + _this5.product.product_url_name;

                    _this5.preset();

                    _this5.setOtherProducts(_this5.product.product_business_id);

                    _this5.getSellpointCategories();

                    _this5.check_in_cart();
                    _this5.loading = false;
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        check_in_cart: function check_in_cart() {
            this.cart.forEach(function (element) {
                if (element.product_item_id == this.product_item.product_item_id) {
                    this.is_product_in_cart = true;
                }
            }, this);
        },
        setOtherProducts: function setOtherProducts(sellpoint_id) {
            var _this6 = this;

            service.getBusinessProducts(this, sellpoint_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.other_products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getProductImages: function getProductImages() {
            var _this7 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.product.product_images = response.body.data;
                    _this7.product_display_image = _this7.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
            }).catch(function (err) {});
        },
        editProduct: function editProduct() {
            var _this8 = this;

            this.disable_btn = true;

            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,
                product_category: this.product.product_category || this.product.product_category_id,
                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill"
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this8.editProductPanel = false;
                        _this8.product = response.body.data;
                        navi.push("/" + _this8.product.product_business_ownername + "/" + _this8.product.product_url_name);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this8.editProductPanel = false;
                        _this8.disable_btn = false;
                    }
                });
            } else {
                this.disable_btn = false;
            }
        },
        editProductItem: function editProductItem() {
            var _this9 = this;

            this.disable_btn = true;
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                product_item_price: this.product_item.product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_quantity: this.product_item.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this9.product_item = response.body.data;
                        _this9.editProductItemPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this9.disable_btn = false;
                    }
                });
            } else {
                this.disable_btn = false;
            }
        },
        removeProduct: function removeProduct() {
            var _this10 = this;

            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this10.redir(_this10.$route.params.id1);

                    _this10.removeProductPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this10.disable_btn = false;
                    _this10.redir(_this10.$route.params.id1);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this11 = this;

            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this11.redir(_this11.$route.params.id1);
                    }
                    _this11.product.product_item = response.body.data;
                    _this11.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this11.disable_btn = false;
                }
            });
        },
        addProductDetail: function addProductDetail() {
            var _this12 = this;

            var payload = {
                product_detail: this.details.new_product_detail || "nill",
                product_id: this.product.product_id
            };
            service.addProductDetail(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_details = data.body.data;
                    this.details = {};
                }
            }).catch(function (err) {
                _this12.details = {};
            });
        },
        editProductDetail: function editProductDetail() {
            var _this13 = this;

            this.details.product_id = this.product.product_id;
            service.editProductDetail(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this13.service = {};
            });
        },
        setProductDelivery: function setProductDelivery() {
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.details = {};

                    this.details.edit_product_delivery = false;
                }
            }).catch(function (err) {});
        },
        deleteProductDetail: function deleteProductDetail(details) {
            var _this14 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this14.service = {};
            });
        },
        addProductReview: function addProductReview() {
            var _this15 = this;

            var payload = {
                product_reviewed_by: this.user.user_id || 1,
                product_review: this.reviews.review || "nill",
                product_id: this.product.product_id
            };
            service.addProductReview(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    console.log(data.body.data);
                    this.product.product_reviews = data.body.data;
                    this.reviews = {};
                }
            }).catch(function (err) {
                _this15.reviews = {};
            });
        },
        getProductInformation: function getProductInformation() {
            var _this16 = this;

            service.getProductInformation(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this16.product.product_information = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProductInformation: function addProductInformation() {
            var _this17 = this;

            var payload = {
                product_info_detail: this.information.product_info_detail || "nill",
                product_info_type: "text",
                product_id: this.product.product_id
            };
            if (payload.product_information != "nill") {
                service.addProductInformation(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.product.product_information = data.body.data;
                        this.information = {};
                    }
                }).catch(function (err) {
                    _this17.details = {};
                });
            }
        },
        editProductInformation: function editProductInformation() {
            var _this18 = this;

            this.details.product_id = this.product.product_id;
            service.editProductInformation(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this18.service = {};
            });
        },
        deleteProductInformation: function deleteProductInformation(details) {
            var _this19 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this19.service = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this20 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_product: this.product.product_id,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this20.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this21 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this21.delivery_option.edit_set = false;
                        _this21.editDeliveryInformation = false;
                    });
                } else {}
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this22 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this22.delivery_option = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: this.product_item.product_item_id,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D',
                coupon_business_category: 0,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date
            };
            service.setDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    this.editDiscount = false;
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    payload.discount_status_id = 6;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this23 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this23.getProductImages();
                        }
                        if (type == "product_information") {
                            _this23.getProductInformation();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this24 = this;

            service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this24, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this24.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        handleScrollFix: function handleScrollFix(event) {
            var x = document.getElementById("menuHeader");

            var isMobile = false;
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                isMobile = true;
            }
            if (isMobile) {
                if (document.documentElement.scrollTop >= 300) {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        }
    },
    created: function created() {
        if (this.$route.query.setup == "yes") {
            this.new_added = true;
        }
        this.setProduct();
        this.getStates();

        window.addEventListener('scroll', this.handleScrollFix);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScrollFix);
    }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_slider_component__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_slider_component__);













var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            categories: {},
            filters: {},
            selected_filters: [],
            orders: {},
            notifications: {},
            messages: {},
            details: {},
            cities: {},
            states: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            discount_coupon: {},
            products_unfiltered: {},
            products: {},
            product: {},
            market: {},
            product_item: {},
            posts: {},
            galleria: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addProductPanel: false,
            addPostPanel: false,
            addGalleryPanel: false,
            addProductGalleryPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            spMessagesPanel: false,
            spOrdersPanel: false,
            spServicesPanel: false,
            spBlogPanel: false,
            spGalleryPanel: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel: false,
            setDiscount: false,
            viewDiscounts: true,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            bg_main: '',
            other_delivery_option: false,
            edit_other_delivery_option: false,
            set_bank_details: false,
            edit_city: false,
            ipaddress: "",
            notifications_unread: 0,
            siteUrl: "",
            copied: false,

            slider_type: [],
            slider_options: {
                min: 0,
                max: 0,
                width: "80%",
                processStyle: {
                    "backgroundImage": "-webkit-linear-gradient(left, #333333, #3498db)"
                }
            },
            price_filter_is_set: false,
            color_filter_is_set: false,
            size_filter_is_set: false,
            brand_filter_is_set: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default.a,
        'new-post-form': __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue___default.a,
        'new-gallery-form': __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue___default.a,
        'new-product-gallery-form': __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue___default.a,
        'menu-modal': __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue___default.a,
        'menu-left-bar': __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue___default.a,
        'vue-slider': __WEBPACK_IMPORTED_MODULE_11_vue_slider_component___default.a
    },
    methods: {
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        mouseover: function mouseover() {
            var x = document.getElementById("product-action-display-menu");
            x.style.display = "block";
        },
        mouseleave: function mouseleave() {
            var x = document.getElementById("product-action-display-menu");

            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        showSectionById: function showSectionById(section) {
            var x = document.getElementById(section);
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        copyLink: function copyLink() {
            if (this.copied) {
                this.copied = false;
            } else {
                this.$clipboard(this.siteUrl);
                this.copied = true;
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;

            $('#menuModal').modal('hide');
            window.location.hash = '#spMain';
            document.getElementById("mobileSideNav").style.width = "0";

            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
            }
            if (attr1 == 'sellpoint-panel') {
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.addGalleryPanel = false;
            }
            if (attr1 == 'spProductsPanel') {
                this.spMarketPanel = false;
                this.spProductsPanel = true;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;

                if (attr2 == 'market') {
                    this.spMarketPanel = true;
                }
            }
            if (attr1 == 'spProfilePanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = true;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if (attr1 == 'spContactPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if (attr1 == 'spDeliveryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spDeliveryPanel = true;
            }
            if (attr1 == 'spMessagesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spOrdersPanel = false;
                this.spMessagesPanel = true;
            }
            if (attr1 == 'spOrdersPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = true;
            }
            if (attr1 == 'spSettingsPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = true;
            }
            if (attr1 == 'spServicesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = true;
            }
            if (attr1 == 'spBlogPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spServicesPanel = false;
                this.spGalleryPanel = false;
                this.spBlogPanel = true;
            }
            if (attr1 == 'spGalleryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spServicesPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = true;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addPostPanel = false;
                this.addGalleryPanel = false;
                this.addProductGalleryPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-post') {
                this.addPostPanel = true;
                this.addProductPanel = false;
                this.addGalleryPanel = false;
                this.addProductGalleryPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-gallery') {
                this.addGalleryPanel = true;
                this.addProductGalleryPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-gallery') {
                this.addProductGalleryPanel = true;
                this.addGalleryPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'edit-category') {
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if (attr1 == 'reset-edit-category') {
                this.category.edit = false;
                this.category = {};
            }

            if (attr1 == 'view-all-products') {
                this.viewAllProductsBanner = false;
                this.getSellpointProducts();
            }
            if (attr1 == 'list-view') {
                this.marketView = false;
                this.listView = true;
            }
            if (attr1 == 'market-view') {
                this.marketView = true;
                this.listView = false;
            }
            if (attr1 == 'add-delivery-information') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
            }
            if (attr1 == 'view-discounts') {
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.viewDiscounts = true;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'edit-service') {
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'edit-tagline') {
                this.details = {};
                this.details.tagline_edit = true;
            }
            if (attr1 == 'edit-profile') {
                this.details = {};
                this.details.profile_edit = true;
            }
            if (attr1 == 'edit-contact-info') {
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if (attr1 == 'edit-delivery-information') {
                this.details = {};
                this.details.delivery_edit = true;
            }
            if (attr1 == 'edit-bank-details') {
                this.details = {};
                this.details.bank_details_edit = true;
                this.set_bank_details = true;
            }
            if (attr1 == 'reset-delivery-information') {
                this.addDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = false;
            }
            if (attr1 == 'edit-discount-coupon') {
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }
            if (attr1 == 'reset-discount-coupon') {
                this.viewDiscounts = true;
                this.discount_coupon.edit = false;
                this.discount_coupon = {};
                this.setDiscount = false;
            }
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },


        prep: function prep() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");

            return parts[0];
        },

        toggleSidebar: function toggleSidebar() {
            if (this.showSidebarMobile == true) {
                this.showSidebarMobile = false;
            } else {
                this.showSidebarMobile = true;
            }
        },
        toggleFilterSortBoard: function toggleFilterSortBoard() {
            var x = document.getElementById("filterSortBoard");
            if (x.style.display === "none") {
                x.style.display = "block";
                document.getElementById("showFilters").style.display = "none";
            } else {
                x.style.display = "none";
                document.getElementById("showFilters").style.display = "block";
            }
        },
        resetFilterSortOptions: function resetFilterSortOptions() {
            this.products = this.products_unfiltered;
            this.setComponent("spProductsPanel", "");
        },
        filterByPrice: function filterByPrice() {
            this.products = this.products_unfiltered;
            var self = this;
            this.products = this.products.filter(function (product) {
                return product.product_price_range >= self.slider_type[0] && product.product_price_range <= self.slider_type[1];
            });
            this.setComponent("spProductsPanel", "");
        },
        sortProducts: function sortProducts(sort_by) {
            this.products = this.products_unfiltered;
            var self = this;
            this.products = this.products.filter(function (product) {
                return product.product_price_range >= self.slider_type[0] && product.product_price_range <= self.slider_type[1];
            });
            this.setComponent("spProductsPanel", "");
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.setSellpoint();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                        _this2.can_edit = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getIPAddress: function getIPAddress() {
            var _this3 = this;

            service.getIPAddress(this).then(function (response) {
                _this3.ipaddress = response.data;
            }).catch(function (err) {});
        },
        getStates: function getStates() {
            var _this4 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this4.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this5 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this5.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        setSellpoint: function setSellpoint() {
            var _this6 = this;

            this.loading = true;
            var sp = "";
            if (this.$route.params.id != undefined) {
                sp = this.$route.params.id;
            } else {
                sp = this.prep();
            }
            service.getBusinessByUserName(this, sp).then(function (response) {
                if (response.body.status == 200) {
                    _this6.sellpoint = response.body.data;
                    localStorage.setItem("sp#cp", _this6.sellpoint.business_username);
                    document.title = _this6.sellpoint.business_name + " | SP";
                    localStorage.setItem("sp_#_sellpoint", _this6.sellpoint.business_username);

                    _this6.siteUrl = service.siteUrl + "?s=" + _this6.sellpoint.business_username + "&s1=" + encodeURI(_this6.sellpoint.business_name) + "&s2=" + encodeURI(_this6.sellpoint.business_name) + "&s3=" + encodeURI(_this6.sellpoint.business_tagline) + "&s4=" + _this6.sellpoint.business_banner_image + " ";

                    _this6.is_editing();

                    if (_this6.sellpoint.business_market_category_id != 1) {
                        _this6.getSellpointMarket();
                    }
                    _this6.prepareFilters();

                    if (_this6.sellpoint.business_layout == 1) {
                        _this6.spProductsPanel = true;
                    } else if (_this6.sellpoint.business_layout == 2) {
                        _this6.spServicesPanel = true;
                    } else if (_this6.sellpoint.business_layout == 3) {
                        _this6.spGalleryPanel = true;
                    } else if (_this6.sellpoint.business_layout == 4) {
                        _this6.spBlogPanel = true;
                    } else {
                        _this6.spProductsPanel = true;
                    }

                    _this6.loading = false;

                    var promises = [];
                    for (var i = 0; i < 9; ++i) {
                        if (i == 1) {
                            promises.push(_this6.getCategories(_this6.sellpoint.business_category_id));
                        }
                        if (i == 2) {
                            promises.push(_this6.getSellpointProducts());
                        }
                        if (i == 3) {
                            promises.push(_this6.getSellpointNotifications());
                        }

                        if (i == 4) {
                            promises.push(_this6.getSellpointMessages());
                        }

                        if (i == 5) {
                            promises.push(_this6.getSellpointOrders());
                        }

                        if (i == 6) {
                            promises.push(_this6.getFilters());
                        }
                        if (i == 7) {
                            promises.push(_this6.getPosts());
                        }
                        if (i == 8) {
                            promises.push(_this6.getGalleryPosts());
                        }
                    }

                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                        var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                        promises.forEach(function (promise) {
                            result.then(function () {});
                        });
                    }).catch(function (e) {});
                } else {}
            }).catch(function (err) {
                console.log(err);
                _this6.loading = true;
            });
        },
        prepareFilters: function prepareFilters() {
            this.sellpoint.business_filters.forEach(function (filter) {
                if (filter.business_filter_id == 2) {
                    this.price_filter_is_set = true;
                }
                if (filter.business_filter_id == 3) {
                    this.color_filter_is_set = true;
                }
                if (filter.business_filter_id == 4) {
                    this.size_filter_is_set = true;
                }
            }, this);
        },
        getSellpointNotifications: function getSellpointNotifications() {
            var _this7 = this;

            service.getBusinessNotifications(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.notifications = response.body.data;
                    _this7.notifications_unread = response.body.data_1;
                }
            }).catch(function (err) {});
        },
        getSellpointMessages: function getSellpointMessages() {
            var _this8 = this;

            service.getBusinessMessages(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this8.messages = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointOrders: function getSellpointOrders() {
            var _this9 = this;

            service.getBusinessOrders(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this9.orders = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this10 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this10.products = response.body.data;
                    _this10.products_unfiltered = response.body.data;

                    _this10.slider_type = [response.body.min_price_range, response.body.max_price_range];
                    _this10.slider_options.min = response.body.min_price_range;
                    _this10.slider_options.max = response.body.max_price_range;
                }
            }).catch(function (err) {});
        },
        getSellpointMarketProducts: function getSellpointMarketProducts() {
            var _this11 = this;

            service.getMarketProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this11.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this12 = this;

            service.getBusinessMarket(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this12.market = response.body.data;
                    _this12.getSellpointMarketProducts();
                }
            }).catch(function (err) {
                _this12.getIPAddress();
                _this12.market = {};

                var err_payload = {
                    err_int_id: _this12.user.user_id || 0,
                    err_mod_id: 5,
                    err_route: _this12.$route.path,
                    err_func: "getSellpointMarket",
                    err_api_cl: "GET::" + err.url,
                    err_message: err.bodyText,
                    err_ln_rang: '363-377',
                    err_poss_cos: "returned could be 404 || 400",
                    err_ip_address: _this12.ipaddress
                };
            });
        },
        getPosts: function getPosts() {
            var _this13 = this;

            service.getPointPosts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this13.posts = response.body.data;
                }
            }).catch(function (err) {});
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this14 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this14.galleria = response.body.data;
                }
            }).catch(function (err) {});
        },
        getFilters: function getFilters() {
            var _this15 = this;

            service.getFilters(this).then(function (response) {
                if (response.body.status == 200) {
                    _this15.filters = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this16 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this16.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addCategory: function addCategory() {
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                business_id: this.sellpoint.business_id
            };
            service.addCategory(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Category Added Successfull", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {});
        },
        editCategory: function editCategory() {
            var _this17 = this;

            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Category edited", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {
                _this17.category = {};
            });
        },
        getCategoryProducts: function getCategoryProducts(category) {
            var _this18 = this;

            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this18.products = response.body.data;
                    _this18.viewAllProductsBanner = true;
                    _this18.showSidebarMobile = false;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type) {
            var _this19 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this19.sellpoint.business_banner_image = data.body.data;
                        }
                        if (type == "business_brand_image") {
                            _this19.sellpoint.business_brand_image = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        addService: function addService() {
            var _this20 = this;

            var payload = {
                business_service: this.service.service_name || "Service Details",
                business_id: this.sellpoint.business_id
            };
            service.addService(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Service Added Successfully", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service = {};
                }
            }).catch(function (err) {
                _this20.service = {};
            });
        },
        editService: function editService() {
            var _this21 = this;

            this.service.business_id = this.sellpoint.business_id;
            service.editService(this, this.service).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Service edited", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service.edit_set = false;
                    this.service = {};
                }
            }).catch(function (err) {
                _this21.service = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this22 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this22.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this23 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            toastr.success("Sellpoint Delivery Details edited", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this23.delivery_option.edit_set = false;
                        _this23.editDeliveryInformation = false;
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Delivery Details deleted", 'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this24.delivery_option = {};
            });
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this25 = this;

            if (attr == "tagline") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_tagline: this.sellpoint.business_tagline
                };
            }
            if (attr == "profile") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_profile: this.sellpoint.business_profile
                };
            }
            if (attr == "contact_info") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint edited", 'Success!');
                }
                this.details = {};
            }).catch(function (err) {
                _this25.details = {};
            });
        },
        sendBusinessContactForm: function sendBusinessContactForm() {
            var _this26 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                contact_form_name: this.contact_form.name || "nill",
                contact_form_email: this.contact_form.email || "nill",
                contact_form_message: this.contact_form.message || "nill"
            };
            service.sendBusinessContactForm(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Message Sent", 'Ok!');
                }
                this.contact_form = {};
            }).catch(function (err) {
                _this26.contact_form = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    product_item_id: 0,
                    is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                    coupon_business_category: this.discount_coupon.discount_category,
                    coupon_percentage: this.discount_coupon.discount_percentage,
                    coupon_start_date: this.discount_coupon.discount_start_date,
                    coupon_end_date: this.discount_coupon.discount_end_date
                };
                service.setDiscountsAndCoupons(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("New Discount Set", 'Update!');
                        this.sellpoint.business_discounts_coupons = data.body.data;
                        this.setComponentActions('reset-discount-coupon', '');
                    }
                }).catch(function (err) {});
            } else {
                validated_arr.forEach(function (error) {
                    toastr.error(error);
                }, this);
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        setBankDetails: function setBankDetails() {
            var payload = {
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessBankDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Bank Details Set", 'Update!');
                }
                this.set_bank_details = false;
            }).catch(function (err) {});
        },
        switchProcessingFee: function switchProcessingFee(to) {
            var payload = {
                business_process_fee_pay: to,
                business_id: this.sellpoint.business_id
            };

            service.switchProcessingFeePay(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Processing Fee Set", 'Reset!');
                    this.sellpoint.business_processing_fee_pay_status = to;
                }
            }).catch(function (err) {});
        },
        setFilterOptions: function setFilterOptions() {
            var payload = {
                business_filters: this.selected_filters,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessFilterOptions(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Filter Options Set", 'Update!');
                }
                this.sellpoint.business_filters = data.body.data;
            }).catch(function (err) {});
        },
        removeFilterOption: function removeFilterOption(option) {
            var payload = {
                business_filter: option,
                business_id: this.sellpoint.business_id
            };

            service.removeBusinessFilterOption(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Filter Option Removed", 'Update!');
                }
                this.sellpoint.business_filters = data.body.data;
            }).catch(function (err) {});
        },
        readNotifications: function readNotifications() {
            this.notifications_unread = 0;
            var payload = {
                notification_type: "business",
                notification_module: "notifications",
                notification_business: this.sellpoint.business_username
            };
            service.readNotifications(this, payload).then(function (data) {}).catch(function (err) {});
        },
        handleScrollFix: function handleScrollFix(event) {
            var x = document.getElementById("menuHeader");
            var s = document.getElementById("spSidebar");
            var m = document.getElementById("spMain");
            if ($(window).scrollTop() >= 300) {
                x.classList.add('sp-shop-menu-section-fixed-header');
                document.getElementById("product-action-display-menu").style.display = "block";
            } else {
                x.classList.remove('sp-shop-menu-section-fixed-header');

                document.getElementById("product-action-display-menu").style.display = "none";
            }

            var isMobile = false;
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                isMobile = true;
            }
            if (!isMobile) {
                if ($(window).scrollTop() > $('.sp-side').height() / 1 && $(window).scrollTop() > $('body').height() / 8) {
                    s.classList.add('sp-side-fixed-sidebar');
                    m.classList.add('sp-main-fixed-sidebar-effect');
                } else {
                    s.classList.remove('sp-side-fixed-sidebar');
                    m.classList.remove('sp-main-fixed-sidebar-effect');
                }
            }
        }
    },
    mounted: function mounted() {
        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.setSellpoint();
        }
    },
    created: function created() {
        this.loading = true;

        this.getStates();
        this.getIPAddress();

        window.addEventListener('scroll', this.handleScrollFix);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScrollFix);
    }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DashboardTemplate',
    data: function data() {
        return {
            loading: false

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {}
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            products: {},
            product: {},
            items: [],
            checked_out_items: [],
            img_url: service.imageURL
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-list': __WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        getProducts: function getProducts() {
            var _this = this;

            service.getProducts(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.products = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        addToCart: function addToCart(item) {
            item.quantity = 0;
            item.quantity += 1;

            item.checked_out = false;
            this.items.push(item);
        },
        removeFromCart: function removeFromCart(item) {
            item.quantity -= 1;
            this.items.splice(this.items.indexOf(item), 1);
        },
        checkout: function checkout() {
            this.items.forEach(function (element) {
                element.checked_out = true;
            }, this);
            this.checked_out_items = this.items;
            this.items = [];
        }
    },
    created: function created() {}
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.clear();
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        login: function login() {
            var _this = this;

            this.disable_btn = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name);
                        localStorage.setItem("sp_token", data.user_session_key);
                        localStorage.setItem("sp_token_key", data.user_token_key);
                        navi.push('account');
                    } else {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this.disable_btn = false;
                    }
                }).catch(function (err) {
                    toastr.warning("invalid login credentials", 'Warning!');
                    _this.disable_btn = false;
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        }
    },
    created: function created() {
        this.reset();
    }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menumodal_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menumodal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menumodal_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    data: function data() {
        return {
            user: '',
            user_slug: {},
            products: {},
            product: {},
            items: [],
            checked_out_items: [],
            img_url: service.imageURL,
            loggedIn: false
        };
    },

    components: {
        'menu-modal': __WEBPACK_IMPORTED_MODULE_1__components_menumodal_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("sp_token") != null) {
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        },
        getProducts: function getProducts() {
            var _this = this;

            service.getProducts(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.products = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        addToCart: function addToCart(item) {
            item.quantity = 0;
            item.quantity += 1;

            item.checked_out = false;
            this.items.push(item);
        },
        removeFromCart: function removeFromCart(item) {
            item.quantity -= 1;
            this.items.splice(this.items.indexOf(item), 1);
        },
        checkout: function checkout() {
            this.items.forEach(function (element) {
                element.checked_out = true;
            }, this);
            this.checked_out_items = this.items;
            this.items = [];
        }
    },
    created: function created() {
        this.checkLoggedIn();
    }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        return {
            user: {},
            sellpoints: {},
            img_url: service.imageURL,
            user_business_interests: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        syncset: function syncset() {
            var navi = this.$router;
            service.sessionSyncSet(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;

                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key);
                    localStorage.setItem("sp_token_key", data.user_token_key);
                    localStorage.setItem("sp_request_url", data.request_url);
                    localStorage.setItem("sp_request_url_page", data.request);
                    localStorage.setItem("sp_request_from", data.request_from);

                    navi.push('/' + data.request);
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        }
    },
    created: function created() {
        document.title = "Account" + " | SP";
        this.syncset();
    }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Points',
    data: function data() {
        return {
            sellpoint: {},
            products: {},
            img_url: service.imageURL,
            ajk: this.$route.path

        };
    },


    methods: {
        prep: function prep() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");

            return parts[0];
        },
        getSellpoint: function getSellpoint() {
            var _this = this;

            var search = this.prep();
            service.getBusinesses(this, search).then(function (data) {
                if (data.body.status == 200) {
                    _this.sellpoint = data.body.data;
                    _this.products = _this.getProducts(_this.sellpoint.business_id);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getSellpointSearch: function getSellpointSearch() {
            var _this2 = this;

            var search = this.$route.query.pg;
            service.getBusinessSearch(this, search).then(function (data) {
                if (data.body.status == 200) {
                    _this2.sellpoint = data.body.data;
                    _this2.products = _this2.getProducts(_this2.sellpoint.business_id);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getProducts: function getProducts(sellpoint) {
            var _this3 = this;

            service.getBusinessProducts(this, sellpoint).then(function (data) {
                if (data.body.status == 200) {
                    _this3.products = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        }
    },
    created: function created() {
        this.getSellpoint();
    }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            loading: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        reg: function reg() {
            this.disable_btn = true;
            this.user.agree = true;
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                if (this.user.agree) {
                    this.loading = true;
                    service.regUser(this, credentials).then(function (data) {
                        var _this = this;

                        if (data.body.status == 201) {
                            toastr.success("Registration Successfull", 'Success!');

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data = response.body.data;
                                    localStorage.setItem("sp_user", _data.user_name);
                                    localStorage.setItem("sp_token", _data.user_session_key);
                                    localStorage.setItem("sp_token_key", _data.user_token_key);
                                    navi.push('create?setup=yes');
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    toastr.warning("invalid login credentials", 'Warning!');
                                    _this.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            toastr.warning("This User is already registered", 'Warning!');
                            this.disable_btn = false;
                        }
                    });
                } else {
                    toastr.error('Please agree to Terms', 'Warning!');
                    this.disable_btn = false;
                }
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newproductgallery_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_posts_newproductgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCartActions_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_ProductCTAActions_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_ProductCTAActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_product_ProductCTAActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_menuleftbar_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_menuleftbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_menuleftbar_vue__);











var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            gallery: {},
            post: {},
            display_post: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            other_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editGalleryPanel: false,
            viewGalleryPost: false,
            editGalleryPostPanel: false,
            removeGalleryPanel: false,
            removeGalleryPostPanel: false,
            product_details_descr: true,
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            action_loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {},

            addNewPost: false,
            imageForm: "",
            file_info: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-gallery-form': __WEBPACK_IMPORTED_MODULE_3__components_posts_newproductgallery_vue___default.a,

        'menu-left-bar': __WEBPACK_IMPORTED_MODULE_8__components_menuleftbar_vue___default.a

    },
    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;

            if (attr1 == 'add-new-post') {
                this.addNewPost = true;
            }
            if (attr1 == 'edit-gallery') {
                this.editGalleryPanel = true;
            }
            if (attr1 == 'remove-gallery') {
                this.removeGalleryPanel = true;
            }
            if (attr1 == 'view-gallery-post') {
                this.viewGalleryPost = true;
                this.display_post = attr2;
            }
            if (attr1 == 'close-view-gallery-post') {
                this.viewGalleryPost = false;
            }
            if (attr1 == 'edit-gallery-post') {
                this.editGalleryPostPanel = true;
            }
            if (attr1 == 'remove-gallery-post') {
                this.removeGalleryPostPanel = true;
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.product_item = attr2;
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.editGalleryPanel = false;
                this.editGalleryIPostPanel = false;
                this.removeGalleryPanel = false;
                this.removeGalleryPostPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
        },
        checkIfVideo: function checkIfVideo(url) {
            var ext = url.split('.').pop();
            if (service.video_exts.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.gallery.gallery_posts_group_point_id;

                            this.is_editing();

                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true;
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        setGallery: function setGallery() {
            var _this3 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.idg).then(function (response) {
                if (response.body.status == 200) {
                    _this3.gallery = response.body.data;
                    if (_this3.gallery.gallery_posts_group_posts.length > 0) {
                        _this3.display_post = _this3.gallery.gallery_posts_group_posts[0];
                    }

                    document.title = _this3.gallery.gallery_posts_group_name + " | " + _this3.gallery.gallery_posts_group_ownername + " | SP";

                    _this3.preset();

                    _this3.loading = false;
                } else {}
            }).catch(function (err) {});
        },
        addPostToGallery: function addPostToGallery() {
            var _this5 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this4 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this4.setGallery();
                                _this4.gallery = data.body.data_gallery;
                                _this4.addNewPost = false;
                                _this4.edit_mode = false;
                            }
                        }).catch(function (err) {
                            if (err) {
                                console.log(err);
                            }
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        editGallery: function editGallery() {
            var _this6 = this;

            this.activate_processing();

            var credentials = {
                gallery_group_name: this.gallery.gallery_posts_group_name,
                gallery_group_description: this.gallery.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.gallery.gallery_posts_group_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Lookbook Edited", 'Success!');

                        this.deactivate_processing();
                        this.editGalleryPanel = false;

                        navi.push('/' + this.$route.params.id + '/g/' + data.body.data_gallery_posts_group_url_name);
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this6.deactivate_processing();
                        _this6.editGalleryPanel = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        removeGallery: function removeGallery() {
            var _this7 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGallery(this, this.gallery.gallery_posts_group_id).then(function (data) {
                if (data.body.status == 200) {
                    location.replace('/' + this.$route.params.id);
                } else {
                    toastr.warning("Something went wrong", 'Warning!');
                    this.deactivate_processing();
                    this.removeGalleryPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this7.deactivate_processing();
                    _this7.removeGalleryPanel = false;
                    toastr.warning("Something went wrong", 'Warning!');
                }
            });
        },
        editGalleryPost: function editGalleryPost() {
            var _this8 = this;

            this.activate_processing();

            var credentials = {
                gallery_post_caption: this.display_post.gallery_post_caption,
                gallery_post_details: this.display_post.gallery_post_details,
                gallery_post_group: this.gallery.gallery_posts_group_id
            };

            var navi = this.$router;
            if (credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.display_post.gallery_post_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        toastr.success("Lookbook Post Edited", 'Success!');

                        this.deactivate_processing();
                        this.editGalleryPostPanel = false;
                        this.gallery = data.body.data;
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPostPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this8.deactivate_processing();
                        _this8.editGalleryPostPanel = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        removeGalleryPost: function removeGalleryPost() {
            var _this9 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGalleryPost(this, this.display_post.gallery_post_id).then(function (data) {
                if (data.body.status == 200) {
                    this.gallery = data.body.data;
                    this.deactivate_processing();
                    this.removeGalleryPostPanel = false;
                    this.viewGalleryPost = false;
                } else {
                    toastr.warning("Something went wrong", 'Warning!');
                    this.deactivate_processing();
                    this.removeGalleryPostPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this9.deactivate_processing();
                    _this9.removeGalleryPostPanel = false;
                    toastr.warning("Something went wrong", 'Warning!');
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            this.activate_processing();
            var payload = {
                data_type: "gallery_media"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.setGallery();
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        onFileChange2: function onFileChange2(e, type, data_id) {
            var _this10 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "gallery_media") {
                            _this10.setGallery();
                        }
                    }
                    _this10.deactivate_processing();
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this11 = this;

            service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this11, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this11.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        }
    },
    mounted: function mounted() {
        var top = document.getElementById("wrap").offsetTop;
        window.scrollTo(0, top);
    },
    created: function created() {

        this.setGallery();
    }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue__);










var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            sellpoint: {},
            posts: {},
            post: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            editPostPanel: false,
            removePostPanel: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            loading: false,
            action_loading: false,
            copied: false,
            addNewPost: false,
            imageForm: "",
            file_info: {}
        };
    },

    components: {},
    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;

            if (attr1 == 'add-new-post') {
                this.addNewPost = true;
            }
            if (attr1 == 'edit-post') {
                this.editPostPanel = true;
            }
            if (attr1 == 'remove-post') {
                this.removePostPanel = true;
            }

            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.product_item = attr2;
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removePostPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");

                            this.is_editing();

                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true;
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        checkIfVideo: function checkIfVideo(url) {
            var ext = url.split('.').pop();
            if (service.video_exts.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setPost: function setPost() {
            var _this3 = this;

            this.loading = true;
            service.getPostSearch(this, this.$route.params.idpos).then(function (response) {
                if (response.body.status == 200) {
                    _this3.post = response.body.data;
                    _this3.sellpoint.business_id = _this3.post.post_point_id;

                    _this3.getPosts();
                    _this3.preset();
                    _this3.loading = false;
                }
            }).catch(function (err) {});
        },
        getPosts: function getPosts() {
            var _this4 = this;

            service.getPointPosts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.posts = response.body.data;
                }
            }).catch(function (err) {});
        },
        editPost: function editPost() {
            var _this5 = this;

            this.activate_processing();

            var credentials = {
                post_title: this.post.post_title || "nill",
                post_text: this.post.post_text,
                post_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.post_title != undefined) {
                service.editPost(this, this.post.post_id, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Post Edited", 'Success!');

                        this.post = data.body.data;

                        this.deactivate_processing();
                        this.editPostPanel = false;
                    } else {
                        this.deactivate_processing();
                        this.editPostPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this5.deactivate_processing();
                        _this5.editPostPanel = false;
                        toastr.warning("Something went wrong", 'Warning!');
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
                this.deactivate_processing();
            }
        },
        removePost: function removePost() {
            var _this6 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deletePost(this, this.post.post_id).then(function (data) {
                if (data.body.status == 200) {
                    navi.push('/' + this.$route.params.id);
                } else {
                    toastr.warning("Something went wrong", 'Warning!');
                    this.deactivate_processing();
                    this.removePostPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this6.deactivate_processing();
                    _this6.removePostPanel = false;
                    toastr.warning("Something went wrong", 'Warning!');
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            var payload = {
                data_type: "posts"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.setPost();
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this7 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', "default_post_media");

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "posts") {
                            _this7.setPost();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        }
    },
    mounted: function mounted() {
        var top = document.getElementById("wrap").offsetTop;
        window.scrollTo(0, top);
    },
    created: function created() {

        this.setPost();
    }

});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue__);










var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            categories: {},
            main_category: {},
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sub_categories: [],
            product: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            other_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item_group: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel: false,
            editProductItemGroupPanel: false,
            removeItemGroupPanel: false,
            removeProductPanel: false,
            product_details_descr: true,
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setProductDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {},
            action_loading: false,
            product_is_ready_to_cart: false,
            product_item_selected: [],
            product_item_group_selected: [],
            data_cart_message: "",
            data_cart_group_message: "",
            data_cart_item_message: "",
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,
            check_order_quantity: ""

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default.a,
        "product-item-form": __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default.a,
        'add-to-cart-button': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default.a,
        'product-cta-button': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default.a,
        'menu-left-bar': __WEBPACK_IMPORTED_MODULE_7__components_menuleftbar_vue___default.a

    },
    computed: {},

    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkOrderQuantity: function checkOrderQuantity(qty) {
            if (this.product_item_selected.product_item_price > 0 && this.product_item.product_item_order_quantity != 0) {
                if (Number(qty) > this.product_item.product_item_quantity) {
                    this.check_order_quantity = "The quantity you entered is above Item Quantity";
                    this.product_is_ready_to_cart = false;
                    this.data_cart_message = "The quantity you entered is above Item Quantity";
                } else {
                    this.check_order_quantity = "";
                    this.product_is_ready_to_cart = true;
                    this.data_cart_message = "";
                }
            } else {
                this.check_order_quantity = "";
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = true;
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'edit-product') {
                this.editProductPanel = true;
            }
            if (attr1 == 'remove-product') {
                this.removeProductPanel = true;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.product_item = attr2;
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-item_group') {
                this.product_item_group = attr2;
                this.editProductItemGroupPanel = true;
            }
            if (attr1 == 'remove-product-item_group') {
                this.product_item_group = attr2;
                this.removeItemGroupPanel = true;
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product_item_group.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-product-delivery-option') {
                this.delivery_option.edit_set = false;
                this.setProductDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item = attr2;
                this.product_item_selected = attr2;

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                if (attr2.product_item_size != "Nill" && attr2.product_item_size != "") {
                    document.getElementById(attr2.product_item_id + "PRT").style = "border:1px solid #0000CC;";
                }

                this.data_cart_item_message = '';
                this.data_cart_message = '';
                this.prep_set_product_is_ready_to_cart();
            }
            if (attr1 == 'set-product-item-group') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item_group = attr2;
                this.product_item_group_selected = attr2;

                this.product_display_image.product_image = attr2.product_item_group_image;

                this.product_is_ready_to_cart = false;
                this.product_item_selected = [];

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style.border = "none";
                }

                document.getElementById(attr2.product_item_group_id + "PRTGR").style.border = "1px solid #0000CC";

                this.data_cart_group_message = '';

                if (attr2.product_items[0].product_item_size == "Nill" || attr2.product_items[0].product_item_size == "") {
                    this.setComponent('set-product-item', attr2.product_items[0]);
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                }
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.editProductItemGroupPanel = false;
                this.removeItemGroupPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
            var self = this;

            setTimeout(function () {
                self.action_loading = false;
            }, 2000);
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.product.product_business_id;

                            this.is_editing();

                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true;
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        set_data_messages: function set_data_messages(data, action) {
            if (this.product.product_service == 'P') {
                if (action == 'set') {
                    if (data == 'product-item') {}
                }
                if (action == 'unset') {}
            } else {}
        },
        prep_set_product_is_ready_to_cart: function prep_set_product_is_ready_to_cart() {
            if (this.product_item_selected.length != 0) {
                this.product_is_ready_to_cart = true;
            } else {
                this.data_cart_message = "make a selection before you proceed";
                if (this.product_item_group_selected.length != 0) {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_group_message = "please select Colour";
                    } else {
                        this.data_cart_group_message = "please select a Service Package";
                    }
                }
            }
        },
        isEmpty: function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        set_product_is_ready_to_cart: function set_product_is_ready_to_cart() {
            if (this.product.product_set_groups <= 1 && this.product.product_set_items <= 1) {
                this.product_item_selected = this.product_item;
                this.product_item_group_selected = this.product_item_group;
                this.product_is_ready_to_cart = true;
            }
        },
        setProduct: function setProduct() {
            var _this5 = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.idp).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product = response.body.data;

                    document.title = _this5.product.product_name + " | " + _this5.product.product_business_name + " | SP";

                    _this5.product_display_image = _this5.product.product_images[0];
                    _this5.product_item = _this5.product.product_items[0];
                    if (_this5.product.product_item_groups.length != 0) {
                        _this5.product_item_group = _this5.product.product_item_groups[0];
                    } else {
                        _this5.product_item_group = [];
                    }

                    _this5.product_set_shipping_fee_status = _this5.product.product_set_shipping_fee_status;

                    _this5.set_product_is_ready_to_cart();

                    _this5.siteUrl = service.siteUrl + "?p=" + _this5.product.product_url_name + "&p1=" + _this5.product.product_business_ownername + "&p2=" + _this5.product.product_url_name + "&p3=" + encodeURI(_this5.product.product_name) + "&p4=" + encodeURI(_this5.product.product_description) + "&p5=" + _this5.product_item.product_item_image + " ";

                    _this5.product.product_share_url = "http://sellpoints.com.ng/" + _this5.product.product_business_ownername + "/" + _this5.product.product_url_name;

                    _this5.preset();

                    _this5.setOtherProducts(_this5.product.product_business_id);

                    _this5.getCategories(_this5.product.product_business_category_id);

                    _this5.getSellpointCategories();

                    _this5.check_in_cart();
                    _this5.loading = false;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this6 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this6.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        check_in_cart: function check_in_cart() {
            this.cart.forEach(function (element) {
                if (element.product_item_id == this.product_item.product_item_id) {
                    this.is_product_in_cart = true;
                }
            }, this);
        },
        setOtherProducts: function setOtherProducts(sellpoint_id) {
            var _this7 = this;

            service.getBusinessProducts(this, sellpoint_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.other_products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getProductImages: function getProductImages() {
            var _this8 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this8.product.product_images = response.body.data;
                    _this8.product_display_image = _this8.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
            }).catch(function (err) {});
        },
        editProduct: function editProduct() {
            var _this9 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this9.editProductPanel = false;
                        _this9.product = response.body.data;
                        navi.push("/" + _this9.product.product_business_ownername + "/" + _this9.product.product_url_name);
                    } else {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                });
            } else {
                this.disable_btn = false;
            }
        },
        editProductItem: function editProductItem() {
            var _this10 = this;

            this.activate_processing();
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                product_item_price: this.product_item.product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this10.product_item = response.body.data;
                        _this10.deactivate_processing();
                        _this10.editProductItemPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this11 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this11.product.product_item_groups = response.body.data;

                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    } else {
                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this11.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            var _this12 = this;

            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this12.redir(_this12.$route.params.id1);

                    _this12.removeProductPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this12.disable_btn = false;
                    _this12.redir(_this12.$route.params.id1);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this13.redir(_this13.$route.params.id);
                    }
                    _this13.product.product_item_groups = response.body.data;

                    _this13.deactivate_processing();
                    _this13.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this13.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this14.redir(_this14.$route.params.id);
                    }
                    _this14.product.product_item_groups = response.body.data;
                    _this14.deactivate_processing();
                    _this14.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this14.deactivate_processing();
                }
            });
        },
        addProductDetail: function addProductDetail() {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                product_detail: this.details.new_product_detail || "nill",
                product_id: this.product.product_id
            };
            service.addProductDetail(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_details = data.body.data;
                    this.details = {};
                    this.deactivate_processing();
                } else {
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this15.details = {};
                _this15.deactivate_processing();
            });
        },
        editProductDetail: function editProductDetail() {
            var _this16 = this;

            this.details.product_id = this.product.product_id;
            service.editProductDetail(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this16.service = {};
            });
        },
        deleteProductDetail: function deleteProductDetail(details) {
            var _this17 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this17.service = {};
            });
        },
        setProductDelivery: function setProductDelivery() {
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.details = {};

                    this.details.edit_product_delivery = false;
                }
            }).catch(function (err) {});
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        addProductReview: function addProductReview() {
            var _this18 = this;

            var payload = {
                product_reviewed_by: this.user.user_id || 1,
                product_review: this.reviews.review || "nill",
                product_id: this.product.product_id
            };
            service.addProductReview(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_reviews = data.body.data;
                    this.reviews = {};
                }
            }).catch(function (err) {
                _this18.reviews = {};
            });
        },
        getProductInformation: function getProductInformation() {
            var _this19 = this;

            service.getProductInformation(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_information = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProductInformation: function addProductInformation() {
            var _this20 = this;

            var payload = {
                product_info_detail: this.information.product_info_detail || "nill",
                product_info_type: "text",
                product_id: this.product.product_id
            };
            if (payload.product_information != "nill") {
                service.addProductInformation(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.product.product_information = data.body.data;
                        this.information = {};
                    }
                }).catch(function (err) {
                    _this20.details = {};
                });
            }
        },
        editProductInformation: function editProductInformation() {
            var _this21 = this;

            this.details.product_id = this.product.product_id;
            service.editProductInformation(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this21.service = {};
            });
        },
        deleteProductInformation: function deleteProductInformation(details) {
            var _this22 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this22.service = {};
            });
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.setProductDeliveryInformation = false;

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this23.delivery_option.edit_set = false;
                        _this23.setProductDeliveryInformation = false;
                        _this23.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryFee: function deleteDeliveryFee(id) {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this24.delivery_option = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this25 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_product: this.product.product_id,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this25.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this26 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this26.delivery_option.edit_set = false;
                        _this26.editDeliveryInformation = false;
                    });
                } else {}
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this27 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this27.delivery_option = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: this.product_item.product_item_id,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D',
                coupon_business_category: 0,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date
            };
            service.setDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setDiscount = false;
                }
            }).catch(function (err) {});
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    this.editDiscount = false;
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    payload.discount_status_id = 6;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this28 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this28.getProductImages();
                            if (_this28.editProductItemGroupPanel) {
                                _this28.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this28.getProductInformation();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this29 = this;

            service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this29, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this29.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        handleScrollFix: function handleScrollFix(event) {
            var x = document.getElementById("menuHeader");

            var isMobile = false;
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                isMobile = true;
            }
            if (isMobile) {
                if (document.documentElement.scrollTop >= 300) {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        }
    },
    mounted: function mounted() {
        var top = document.getElementById("wrap").offsetTop;
        window.scrollTo(0, top);
    },
    created: function created() {
        if (this.$route.query.setup == "yes") {
            this.new_added = true;
        }
        this.setProduct();
        this.getStates();

        window.addEventListener('scroll', this.handleScrollFix);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScrollFix);
    }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_slider_component__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_slider_component__);













var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            filters: {},
            selected_filters: [],
            orders: {},
            notifications: {},
            messages: {},
            details: {},
            cities: {},
            states: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            discount_coupon: {},
            products_unfiltered: {},
            products: {},
            product: {},
            product_item: {},
            market: {},
            subscriptions: {},
            subscription: {},
            subscription_list: [],
            services: {},
            posts: {},
            set_post_view: [],
            galleria: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addPanel: false,
            addProductPanel: false,
            addPostPanel: false,
            addGalleryPanel: false,
            addProductGalleryPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            spMessagesPanel: false,
            spOrdersPanel: false,
            spServicesPanel: false,
            spBlogPanel: false,
            spGalleryPanel: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel: false,
            spSubscriptionPanel: false,
            setDiscount: false,
            viewDiscounts: true,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            newSubscriptionGroup: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            visitor_url: service.request_url,
            visitor_app: service.request_from,
            bg_main: '',
            other_delivery_option: false,
            edit_other_delivery_option: false,
            set_bank_details: false,
            edit_city: false,
            ipaddress: "",
            notifications_unread: 0,
            siteUrl: "",
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            copied: false,

            slider_type: [],
            slider_options: {
                min: 0,
                max: 0,
                width: "80%",
                processStyle: {
                    "backgroundImage": "-webkit-linear-gradient(left, #333333, #3498db)"
                }
            },
            price_filter_is_set: false,
            color_filter_is_set: false,
            size_filter_is_set: false,
            brand_filter_is_set: false,
            product_search_messsage: "",
            filter_array: [],
            sorting_by: 'best-match',
            sellpoint_product_item_groups: {},
            sellpoint_product_sizes: {},
            sellpoint_product_services: {},
            search_data: "",

            bottombar_search: false,
            action_loading: false,
            business_set_shipping_fee_status: 9

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default.a,
        'new-post-form': __WEBPACK_IMPORTED_MODULE_6__components_posts_newpost_vue___default.a,
        'new-gallery-form': __WEBPACK_IMPORTED_MODULE_7__components_posts_newgallery_vue___default.a,
        'new-product-gallery-form': __WEBPACK_IMPORTED_MODULE_8__components_posts_newproductgallery_vue___default.a,
        'menu-modal': __WEBPACK_IMPORTED_MODULE_9__components_menumodal_vue___default.a,
        'menu-left-bar': __WEBPACK_IMPORTED_MODULE_10__components_menuleftbar_vue___default.a,
        'vue-slider': __WEBPACK_IMPORTED_MODULE_11_vue_slider_component___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        closeMobileBottomBar: function closeMobileBottomBar() {
            document.getElementById("mobileBottomBar").style.display = "none";
        },
        mobileBottomBarActions: function mobileBottomBarActions(attr1, attr2) {
            document.getElementById("mobileBottomBar").style.display = "block";

            if (attr1 == 'display-search-bar') {
                this.bottombar_search = true;
            }
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        mouseover: function mouseover() {
            var x = document.getElementById("product-action-display-menu");
            x.style.display = "block";
        },
        mouseleave: function mouseleave() {
            var x = document.getElementById("product-action-display-menu");

            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        showSectionById: function showSectionById(section) {
            var x = document.getElementById(section);
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        copyLink: function copyLink() {
            if (this.copied) {
                this.copied = false;
            } else {
                this.$clipboard(this.siteUrl);
                this.copied = true;
            }
        },
        checkIfVideo: function checkIfVideo(url) {
            var ext = url.split('.').pop();
            if (service.video_exts.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;

            $('#menuModal').modal('hide');

            if (this.child_route_view) {
                this.$router.push('/' + this.$route.params.id);
                this.child_route_view = false;
            }

            document.getElementById("mobileSideNav").style.width = "0";

            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
            }
            if (attr1 == 'sellpoint-panel') {
                this.addPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.addGalleryPanel = false;
            }
            if (attr1 == 'spProductsPanel') {
                if (attr2 == 'show-products') {
                    this.products = this.products_unfiltered;
                }
                this.spMarketPanel = false;
                this.spProductsPanel = true;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;

                if (attr2 == 'market') {
                    this.spMarketPanel = true;
                }
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spProfilePanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = true;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spContactPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spDeliveryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spDeliveryPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spMessagesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spOrdersPanel = false;
                this.spMessagesPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spOrdersPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spSettingsPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = true;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spSubscriptionPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if (attr1 == 'spServicesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = true;
            }
            if (attr1 == 'spBlogPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spServicesPanel = false;
                this.spGalleryPanel = false;
                this.spBlogPanel = true;
            }
            if (attr1 == 'spGalleryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spServicesPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = true;
            }

            if (attr1 == 'add-product-to-subscription-group') {
                localStorage.setItem("sp-subscription", "active");
                localStorage.setItem("sp-subscription-active", attr2.business_subscription_group_id);
                localStorage.setItem("sp-subscription-group", attr2.business_subscription_group_name);

                if (this.sellpoint.business_market_category_id != 1) {
                    localStorage.setItem("sp-app-subscription-active", "active");
                    localStorage.setItem("sp-app-subscription", this.sellpoint.business_id);
                }

                this.setComponent('add-product', '');
            }
            if (attr1 == 'add-product') {
                this.addPanel = true;
                this.addProductPanel = true;
                this.addPostPanel = false;
                this.addGalleryPanel = false;
                this.addProductGalleryPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-post') {
                this.addPanel = true;
                this.addPostPanel = true;
                this.addProductPanel = false;
                this.addGalleryPanel = false;
                this.addProductGalleryPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-gallery') {
                this.addPanel = true;
                this.addGalleryPanel = true;
                this.addProductGalleryPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-gallery') {
                this.addPanel = true;
                this.addProductGalleryPanel = true;
                this.addGalleryPanel = false;
                this.addProductPanel = false;
                this.addPostPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'edit-category') {
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if (attr1 == 'reset-edit-category') {
                this.category.edit = false;
                this.category = {};
            }

            if (attr1 == 'view-all-products') {
                this.viewAllProductsBanner = false;
                this.products = this.products_unfiltered;
            }
            if (attr1 == 'list-view') {
                this.marketView = false;
                this.listView = true;
            }
            if (attr1 == 'market-view') {
                this.marketView = true;
                this.listView = false;
            }
            if (attr1 == 'add-delivery-information') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
            }
            if (attr1 == 'view-discounts') {
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.viewDiscounts = true;
            }
            if (attr1 == 'set-post-view') {
                this.set_post_view = attr2;
            }
            if (attr1 == 'add-subscription-group') {
                this.newSubscriptionGroup = true;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'edit-service') {
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'edit-tagline') {
                this.details = {};
                this.details.tagline_edit = true;
            }
            if (attr1 == 'edit-profile') {
                this.details = {};
                this.details.profile_edit = true;
            }
            if (attr1 == 'edit-contact-info') {
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if (attr1 == 'edit-delivery-information') {
                this.details = {};
                this.details.delivery_edit = true;
            }
            if (attr1 == 'edit-bank-details') {
                this.details = {};
                this.details.bank_details_edit = true;
                this.set_bank_details = true;
            }
            if (attr1 == 'reset-delivery-information') {
                this.addDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = false;
            }
            if (attr1 == 'edit-discount-coupon') {
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }
            if (attr1 == 'reset-discount-coupon') {
                this.viewDiscounts = true;
                this.discount_coupon.edit = false;
                this.discount_coupon = {};
                this.setDiscount = false;
            }
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },


        prep: function prep() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");

            return parts[0];
        },

        syncset: function syncset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.site_url,
                request_from: service.site_name,
                request_status: "SENDING...",
                request: service.request_url_page };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.request_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        toggleSidebar: function toggleSidebar() {
            if (this.showSidebarMobile == true) {
                this.showSidebarMobile = false;
            } else {
                this.showSidebarMobile = true;
            }
        },
        toggleFilterSortBoard: function toggleFilterSortBoard() {
            var x = document.getElementById("filterSortBoard");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        resetFilterSortOptions: function resetFilterSortOptions() {
            this.products = this.products_unfiltered;
            this.setComponent("spProductsPanel", "");
        },
        filterByPrice: function filterByPrice() {
            this.products = this.products_unfiltered;
            var self = this;
            this.products = this.products.filter(function (product) {
                return product.product_price_range >= self.slider_type[0] && product.product_price_range <= self.slider_type[1];
            });
            this.setComponent("spProductsPanel", "");
        },
        sortBy: function sortBy(sort_by) {
            this.sorting_by = sort_by;

            if (this.filter_array.length == 0) {
                this.products = this.products_unfiltered;
            }

            var self = this;
            var sorted_array = [];

            if (sort_by == 'featured') {
                sorted_array = this.products.filter(function (product) {
                    return product.product_is_featured == true;
                });
                if (sorted_array.length != 0) {
                    var orderd_sorted_array = this.local_sort_by_key(sorted_array, "product_featured_reg_date_f");
                    this.products = orderd_sorted_array.reverse();
                    this.product_search_messsage = "Showing Featured Products from list";
                }
            }

            if (sort_by == 'orders-made') {
                sorted_array = this.local_sort_by_key(this.products, "product_total_items_orders");
                this.products = sorted_array.reverse();
                this.product_search_messsage = "Showing Products from Highest to lowest Orders";
            }

            if (sort_by == 'discounted') {
                sorted_array = this.products.filter(function (product) {
                    return product.product_is_discounted != 0;
                });
                if (sorted_array.length != 0) {
                    this.products = this.local_sort_by_key(sorted_array, "product_reg_date_f");
                    this.product_search_messsage = "Showing Discounted Products from the list";
                }
            }

            if (sort_by == 'pre-orders') {
                sorted_array = this.products.filter(function (product) {
                    return product.product_is_featured == true;
                });
                if (sorted_array.length != 0) {
                    this.products = this.local_sort_by_key(sorted_array, "product_featured_reg_date_f");
                    this.product_search_messsage = "Showing Products that you can Pre Order";
                }
            }

            if (sort_by == 'price-low-high') {
                sorted_array = this.local_sort_by_key(this.products, "product_price_range");
                this.products = sorted_array;
                this.product_search_messsage = "Showing Products from Lowest to Highest prices";
            }

            if (sort_by == 'price-high-low') {
                sorted_array = this.local_sort_by_key(this.products, "product_price_range");

                this.products = sorted_array.reverse();
                this.product_search_messsage = "Showing Products from Highest to Lowest prices";
            }

            if (sorted_array.length == 0) {
                this.product_search_messsage = "No Products found...showing related matches";
            }

            if (this.filter_array.length != 0) {
                this.product_search_messsage = "";
            }

            this.setComponent("spProductsPanel", "");
        },
        local_sort_by_key: function local_sort_by_key(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];var y = b[key];
                return x < y ? -1 : x > y ? 1 : 0;
            });
        },
        filterBy: function filterBy(filter_key, filter_key_value_id, filter_key_value) {
            var array_row = [filter_key, filter_key_value_id, filter_key_value];

            if (this.filter_array.length != 0) {
                var index = this.filter_array.findIndex(function (c) {
                    return c[1] === filter_key_value_id;
                });
                if (index < 0) {
                    this.filter_array.push(array_row);
                }
            } else {
                this.filter_array.push(array_row);
            }

            var filtered_array = [];
            var data = this.filter_array;

            data.forEach(function (row) {
                if (row[0] == 1) {
                    var products_to_filter = this.products_unfiltered;
                    products_to_filter.forEach(function (product) {
                        if (product.product_category_id == row[1]) {
                            if (filtered_array.length != 0) {
                                var _index = filtered_array.findIndex(function (p) {
                                    return p.product_id === product.product_id;
                                });
                                if (_index < 0) {
                                    filtered_array.push(product);
                                }
                            } else {
                                filtered_array.push(product);
                            }
                        }
                    }, this);
                }

                if (row[0] == 2) {
                    var _products_to_filter = this.products_unfiltered;
                    _products_to_filter.forEach(function (product) {
                        product.product_item_groups.forEach(function (group) {
                            if (group.product_item_group_name == row[2]) {
                                if (filtered_array.length != 0) {
                                    var _index2 = filtered_array.findIndex(function (p) {
                                        return p.product_id === product.product_id;
                                    });
                                    if (_index2 < 0) {
                                        filtered_array.push(product);
                                    }
                                } else {
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);
                }

                if (row[0] == 3) {
                    var _products_to_filter2 = this.products_unfiltered;
                    _products_to_filter2.forEach(function (product) {
                        product.product_items.forEach(function (item) {
                            if (item.product_item_size == row[2]) {
                                if (filtered_array.length != 0) {
                                    var _index3 = filtered_array.findIndex(function (p) {
                                        return p.product_id === product.product_id;
                                    });
                                    if (_index3 < 0) {
                                        filtered_array.push(product);
                                    }
                                } else {
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);
                }

                if (row[0] == 4) {
                    var _products_to_filter3 = this.products_unfiltered;
                    _products_to_filter3.forEach(function (product) {
                        product.product_items.forEach(function (item) {
                            if (item.product_item_service_tag == row[2]) {
                                if (filtered_array.length != 0) {
                                    var _index4 = filtered_array.findIndex(function (p) {
                                        return p.product_id === product.product_id;
                                    });
                                    if (_index4 < 0) {
                                        filtered_array.push(product);
                                    }
                                } else {
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);
                }
            }, this);

            if (filtered_array.length != 0) this.products = filtered_array;else {
                this.products = this.products_unfiltered;
            }

            this.sortBy(this.sorting_by);

            this.setComponent("spProductsPanel", "");
        },
        searchProductsByBusiness: function searchProductsByBusiness() {
            var _this = this;

            service.searchProductsByBusiness(this, this.search_data, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.product.product_search_messsage = "Showing search result for " + _this.search_data;
                    if (_this.products.length == 0) {
                        _this.product.product_search_messsage = "No products found";
                    }
                    _this.setComponent("spProductsPanel", "");
                }
            }).catch(function (err) {});
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.setSellpoint();
                        }, _this2);
                    } else {
                        _this2.setSellpoint();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.setSellpoint();
                    }
                });
            } else {
                this.setSellpoint();
            }
        },
        is_editing: function is_editing() {
            var _this3 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.edit_mode = true;
                        _this3.can_edit = true;
                    } else {
                        _this3.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getIPAddress: function getIPAddress() {
            var _this4 = this;

            service.getIPAddress(this).then(function (response) {
                _this4.ipaddress = response.data;
            }).catch(function (err) {});
        },
        getStates: function getStates() {
            var _this5 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this5.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this6 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this6.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        setSellpoint: function setSellpoint() {
            var _this7 = this;

            this.loading = true;
            var sp = "";
            if (this.$route.params.id != undefined) {
                sp = this.$route.params.id;
            } else {
                sp = this.prep();
            }
            service.getBusinessByUserName(this, sp).then(function (response) {
                if (response.body.status == 200) {
                    _this7.sellpoint = response.body.data;
                    localStorage.setItem("sp#cp", _this7.sellpoint.business_username);
                    document.title = _this7.sellpoint.business_name + " | SP";
                    localStorage.setItem("sp_#_sellpoint", _this7.sellpoint.business_username);

                    _this7.siteUrl = service.siteUrl + "?s=" + _this7.sellpoint.business_username + "&s1=" + encodeURI(_this7.sellpoint.business_name) + "&s2=" + encodeURI(_this7.sellpoint.business_name) + "&s3=" + encodeURI(_this7.sellpoint.business_tagline) + "&s4=" + _this7.sellpoint.business_banner_image + " ";

                    _this7.is_editing();

                    if (_this7.sellpoint.business_market_category_id != 1) {
                        _this7.getSellpointMarket();
                    }
                    _this7.prepareFilters();

                    _this7.business_set_shipping_fee_status = _this7.sellpoint.business_set_shipping_fee_status;

                    if (_this7.sellpoint.business_layout == 1) {
                        _this7.spProductsPanel = true;
                    } else if (_this7.sellpoint.business_layout == 2) {
                        _this7.spServicesPanel = true;
                    } else if (_this7.sellpoint.business_layout == 3) {
                        _this7.spGalleryPanel = true;
                    } else if (_this7.sellpoint.business_layout == 4) {
                        _this7.spBlogPanel = true;
                    } else {
                        _this7.spProductsPanel = true;
                    }

                    _this7.loading = false;

                    var promises = [];
                    for (var i = 0; i < 9; ++i) {
                        if (i == 1) {
                            promises.push(_this7.getCategories(_this7.sellpoint.business_category_id));
                        }
                        if (i == 2) {
                            promises.push(_this7.getSellpointProducts());
                        }
                        if (i == 3) {
                            promises.push(_this7.getSellpointNotifications());
                        }

                        if (i == 4) {
                            promises.push(_this7.getSellpointMessages());
                        }

                        if (i == 5) {
                            promises.push(_this7.getSellpointOrders());
                        }

                        if (i == 6) {
                            promises.push(_this7.getFilters());
                        }
                        if (i == 7) {
                            promises.push(_this7.getPosts());
                        }
                        if (i == 8) {
                            promises.push(_this7.getGalleryPosts());
                        }
                    }

                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                        var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                        promises.forEach(function (promise) {
                            result.then(function () {});
                        });
                    }).catch(function (e) {});
                } else {
                    _this7.$router.push('/');
                }
            }).catch(function (err) {
                location.replace("/");

                _this7.loading = true;
            });
        },
        prepareFilters: function prepareFilters() {
            this.sellpoint.business_filters.forEach(function (filter) {
                if (filter.business_filter_id == 2) {
                    this.price_filter_is_set = true;
                }
                if (filter.business_filter_id == 3) {
                    this.color_filter_is_set = true;
                }
                if (filter.business_filter_id == 4) {
                    this.size_filter_is_set = true;
                }
            }, this);
        },
        getSellpointNotifications: function getSellpointNotifications() {
            var _this8 = this;

            service.getBusinessNotifications(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this8.notifications = response.body.data;
                    _this8.notifications_unread = response.body.data_1;
                }
            }).catch(function (err) {});
        },
        getSellpointMessages: function getSellpointMessages() {
            var _this9 = this;

            service.getBusinessMessages(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this9.messages = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointOrders: function getSellpointOrders() {
            var _this10 = this;

            service.getBusinessOrders(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this10.orders = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this11 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this11.products = response.body.data;
                    _this11.products_unfiltered = response.body.data;

                    _this11.slider_type = [response.body.min_price_range, response.body.max_price_range];
                    _this11.slider_options.min = response.body.min_price_range;
                    _this11.slider_options.max = response.body.max_price_range;

                    _this11.sellpoint_product_item_groups = response.body.data_product_items_groups_filtered;
                    _this11.sellpoint_product_sizes = response.body.data_product_sizes_filtered;
                    _this11.sellpoint_product_services = response.body.data_product_services_filtered;
                }
            }).catch(function (err) {});
        },
        getSellpointMarketProducts: function getSellpointMarketProducts() {
            var _this12 = this;

            service.getMarketProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this12.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this13 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this13.subscriptions = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this14 = this;

            service.getBusinessMarket(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this14.market = response.body.data;
                    _this14.getMarketMainProductsAsSubscriptions();
                    _this14.getSellpointMarketProducts();
                }
            }).catch(function (err) {
                _this14.getIPAddress();
                _this14.market = {};

                var err_payload = {
                    err_int_id: _this14.user.user_id || 0,
                    err_mod_id: 5,
                    err_route: _this14.$route.path,
                    err_func: "getSellpointMarket",
                    err_api_cl: "GET::" + err.url,
                    err_message: err.bodyText,
                    err_ln_rang: '363-377',
                    err_poss_cos: "returned could be 404 || 400",
                    err_ip_address: _this14.ipaddress
                };
            });
        },
        getPosts: function getPosts() {
            var _this15 = this;

            service.getPointPosts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this15.posts = response.body.data;
                }
            }).catch(function (err) {});
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this16 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, 50, 0, 50).then(function (response) {
                if (response.body.status == 200) {
                    _this16.galleria = response.body.data;
                }
            }).catch(function (err) {});
        },
        getFilters: function getFilters() {
            var _this17 = this;

            service.getFilters(this).then(function (response) {
                if (response.body.status == 200) {
                    _this17.filters = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this18 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this18.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        addCategory: function addCategory() {
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                business_id: this.sellpoint.business_id
            };
            service.addCategory(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Category Added Successfull", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {});
        },
        editCategory: function editCategory() {
            var _this19 = this;

            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Category edited", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {
                _this19.category = {};
            });
        },
        getCategoryProducts: function getCategoryProducts(category) {
            var products_to_filter = this.products_unfiltered;
            var fetch_array = [];
            products_to_filter.forEach(function (product) {
                if (product.product_category_id == category.business_category_id) {
                    fetch_array.push(product);
                }
            }, this);
            this.products = fetch_array;
            this.setComponent("spProductsPanel", "");
            this.viewAllProductsBanner = true;
        },
        onFileChange: function onFileChange(e, type) {
            var _this20 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this20.sellpoint.business_banner_image = data.body.data;
                        }
                        if (type == "business_brand_image") {
                            _this20.sellpoint.business_brand_image = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        addService: function addService() {
            var _this21 = this;

            var payload = {
                business_service: this.service.service_name || "Service Details",
                business_id: this.sellpoint.business_id
            };
            service.addService(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Service Added Successfully", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service = {};
                }
            }).catch(function (err) {
                _this21.service = {};
            });
        },
        editService: function editService() {
            var _this22 = this;

            this.service.business_id = this.sellpoint.business_id;
            service.editService(this, this.service).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Service edited", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service.edit_set = false;
                    this.service = {};
                }
            }).catch(function (err) {
                _this22.service = {};
            });
        },
        addSubscriptionGroup: function addSubscriptionGroup() {
            var payload = {
                business_id: this.sellpoint.business_id,
                business_subscription_group_name: this.subscription.group_name,
                business_subscription_group_list: this.subscription_list
            };
            service.addSubscriptionGroup(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Subscription Group Added Successfully", 'Success!');
                    this.sellpoint.business_subscription_groups = data.body.data;
                    this.subscription = {};
                    this.subscription_list = [];
                    var sub_group_id = data.body.data_sub_last;
                    var sub_group_name = data.body.data_sub_last_group;

                    localStorage.setItem("sp-subscription", "active");
                    localStorage.setItem("sp-subscription-active", sub_group_id);
                    localStorage.setItem("sp-subscription-group", sub_group_name);

                    if (this.sellpoint.business_market_category_id != 1) {
                        localStorage.setItem("sp-app-subscription-active", "active");
                        localStorage.setItem("sp-app-subscription", this.sellpoint.business_id);
                    }

                    this.newSubscriptionGroup = false;
                    this.setComponent('add-product', '');
                }
            }).catch(function (err) {});
        },
        editSubscriptionGroup: function editSubscriptionGroup() {},
        deleteSubscriptionGroup: function deleteSubscriptionGroup() {},
        addDeliveryOption: function addDeliveryOption() {
            var _this23 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this23.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            toastr.success("Sellpoint Delivery Details edited", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this24.delivery_option.edit_set = false;
                        _this24.editDeliveryInformation = false;
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this25 = this;

            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Delivery Details deleted", 'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this25.delivery_option = {};
            });
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this26 = this;

            if (attr == "tagline") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_tagline: this.sellpoint.business_tagline
                };
            }
            if (attr == "profile") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_profile: this.sellpoint.business_profile
                };
            }
            if (attr == "contact_info") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint edited", 'Success!');
                }
                this.details = {};
            }).catch(function (err) {
                _this26.details = {};
            });
        },
        sendBusinessContactForm: function sendBusinessContactForm() {
            var _this27 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                contact_form_name: this.contact_form.name || "nill",
                contact_form_email: this.contact_form.email || "nill",
                contact_form_message: this.contact_form.message || "nill"
            };
            service.sendBusinessContactForm(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Message Sent", 'Ok!');
                }
                this.contact_form = {};
            }).catch(function (err) {
                _this27.contact_form = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    product_item_id: 0,
                    is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                    coupon_business_category: this.discount_coupon.discount_category,
                    coupon_percentage: this.discount_coupon.discount_percentage,
                    coupon_start_date: this.discount_coupon.discount_start_date,
                    coupon_end_date: this.discount_coupon.discount_end_date
                };
                service.setDiscountsAndCoupons(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("New Discount Set", 'Update!');
                        this.sellpoint.business_discounts_coupons = data.body.data;
                        this.setComponentActions('reset-discount-coupon', '');
                    }
                }).catch(function (err) {});
            } else {
                validated_arr.forEach(function (error) {
                    toastr.error(error);
                }, this);
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        setBankDetails: function setBankDetails() {
            var payload = {
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessBankDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Bank Details Set", 'Update!');
                }
                this.set_bank_details = false;
            }).catch(function (err) {});
        },
        switchProcessingFee: function switchProcessingFee(to) {
            var payload = {
                business_process_fee_pay: to,
                business_id: this.sellpoint.business_id
            };

            service.switchProcessingFeePay(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Processing Fee Set", 'Reset!');
                    this.sellpoint.business_processing_fee_pay_status = to;
                }
            }).catch(function (err) {});
        },
        setShippingFeeStatus: function setShippingFeeStatus() {
            this.activate_processing();
            var payload = {
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id: this.sellpoint.business_id
            };

            service.setShippingFeeStatus(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Shipping Fee Ordering Set", 'Reset!');
                    this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        setFilterOptions: function setFilterOptions() {
            var payload = {
                business_filters: this.selected_filters,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessFilterOptions(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Filter Options Set", 'Update!');
                }
                this.sellpoint.business_filters = data.body.data;
            }).catch(function (err) {});
        },
        removeFilterOption: function removeFilterOption(option) {
            var payload = {
                business_filter: option,
                business_id: this.sellpoint.business_id
            };

            service.removeBusinessFilterOption(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Filter Option Removed", 'Update!');
                }
                this.sellpoint.business_filters = data.body.data;
            }).catch(function (err) {});
        },
        readNotifications: function readNotifications() {
            this.notifications_unread = 0;
            var payload = {
                notification_type: "business",
                notification_module: "notifications",
                notification_business: this.sellpoint.business_username
            };
            service.readNotifications(this, payload).then(function (data) {}).catch(function (err) {});
        },
        handleScrollFix: function handleScrollFix(event) {
            var x = document.getElementById("menuHeader");
            var s = document.getElementById("spSidebar");
            var m = document.getElementById("spMain");
            if ($(window).scrollTop() >= 300) {
                x.classList.add('sp-shop-menu-section-fixed-header');


                document.getElementById("product-action-display-menu").style.display = "block";
            } else {
                x.classList.remove('sp-shop-menu-section-fixed-header');

                document.getElementById("product-action-display-menu").style.display = "none";
            }

            var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
            if (!isMobile) {
                if (!this.child_route_view) {
                    if ($(window).scrollTop() > $('.sp-side').height() / 1 && $(window).scrollTop() > $('body').height() / 8) {
                        s.classList.add('sp-side-fixed-sidebar');
                        m.classList.add('sp-main-fixed-sidebar-effect');
                    } else {
                        s.classList.remove('sp-side-fixed-sidebar');
                        m.classList.remove('sp-main-fixed-sidebar-effect');
                    }
                }
            }
        }
    },
    mounted: function mounted() {
        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.setSellpoint();
        }
    },
    created: function created() {
        this.loading = true;
        if (this.$route.params.idp || this.$route.params.idg || this.$route.params.idpos) {
            this.child_route_view = true;
        }

        this.getStates();
        this.getIPAddress();

        window.addEventListener('scroll', this.handleScrollFix);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScrollFix);
    }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sellpoint_SellpointList_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sellpoint_SellpointList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sellpoint_SellpointList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductList_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_product_ProductList_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoints',
    data: function data() {
        return {
            sellpoints: {},
            img_url: service.imageURL
        };
    },

    components: {
        'sellpoint-list': __WEBPACK_IMPORTED_MODULE_1__components_sellpoint_SellpointList_vue___default.a,
        'product-list': __WEBPACK_IMPORTED_MODULE_2__components_product_ProductList_vue___default.a
    },
    methods: {
        getSellpoints: function getSellpoints() {
            var _this = this;

            service.getAllBusinesses(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.sellpoints = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        }
    },
    created: function created() {}

});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SideHustle',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            categories: {},
            details: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            products: {},
            product: {},
            market: {},
            product_item: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addProductPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            bg_main: ''

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default.a
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
            }
            if (attr1 == 'sellpoint-panel') {
                this.addProductPanel = false;
            }
            if (attr1 == 'spProductsPanel') {
                this.spMarketPanel = false;
                this.spProductsPanel = true;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;

                if (attr2 == 'market') {
                    this.spMarketPanel = true;
                }
            }
            if (attr1 == 'spProfilePanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = true;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
            }
            if (attr1 == 'spContactPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
            }
            if (attr1 == 'spDeliveryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = true;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'edit-category') {
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if (attr1 == 'reset-edit-category') {
                this.category.edit = false;
                this.category = {};
            }
            if (attr1 == 'view-all-products') {
                this.viewAllProductsBanner = false;
                this.getSellpointProducts();
            }
            if (attr1 == 'list-view') {
                this.marketView = false;
                this.listView = true;
            }
            if (attr1 == 'market-view') {
                this.marketView = true;
                this.listView = false;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'edit-service') {
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (attr1 == 'edit-tagline') {
                this.details = {};
                this.details.tagline_edit = true;
            }
            if (attr1 == 'edit-profile') {
                this.details = {};
                this.details.profile_edit = true;
            }
            if (attr1 == 'edit-contact-info') {
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if (attr1 == 'edit-delivery-information') {
                this.details = {};
                this.details.delivery_edit = true;
            }
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },


        prep: function prep() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");

            return parts[0];
        },

        toggleSidebar: function toggleSidebar() {
            if (this.showSidebarMobile == true) {
                this.showSidebarMobile = false;
            } else {
                this.showSidebarMobile = true;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.setSellpoint();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                        _this2.can_edit = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        setSellpoint: function setSellpoint() {
            var _this3 = this;

            var sp = "";
            if (this.$route.params.id != undefined) {
                sp = this.$route.params.id;
            } else {
                sp = this.prep();
            }
            service.getBusinessByUserName(this, "blazers").then(function (response) {
                if (response.body.status == 200) {
                    _this3.sellpoint = response.body.data;
                    _this3.is_editing();
                    _this3.getCategories(_this3.sellpoint.business_category_id);
                    _this3.getSellpointProducts();
                    if (_this3.sellpoint.business_market_category_id != 0) {
                        _this3.getSellpointMarket();
                        localStorage.setItem("sp_#_sellpoint", _this3.sellpoint.business_username);
                    }
                    _this3.spProductsPanel = true;
                }
            }).catch(function (err) {
                location.replace("/");
            });
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this5 = this;

            service.getBusinessMarket(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.market = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this6 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this6.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        sendBusinessContactForm: function sendBusinessContactForm() {
            var _this7 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                contact_form_name: this.contact_form.name || "nill",
                contact_form_email: this.contact_form.email || "nill",
                contact_form_message: this.contact_form.message || "nill"
            };
            service.sendBusinessContactForm(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Message Sent", 'Ok!');
                }
                this.contact_form = {};
            }).catch(function (err) {
                _this7.contact_form = {};
            });
        }
    },
    mounted: function mounted() {
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        }
    },
    created: function created() {
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.setSellpoint();
        }
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Account__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Cart__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Orders__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Buypoint_Order__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Buypoint_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Buypoint_Order__);






/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint_Buypoint___default.a,
    children: [{
        path: '/account',
        name: 'Account',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_Buypoint_Account___default.a
    }, {
        path: '/cart',
        name: 'Cart',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Buypoint_Cart___default.a
    }, {
        path: '/checkout',
        name: 'Checkout',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Buypoint_Checkout___default.a
    }, {
        path: '/orders',
        name: 'Orders',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_Buypoint_Orders___default.a
    }, {
        path: '/order',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_Buypoint_Order___default.a
    }]
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/create',
  name: 'CreateSellpoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default.a
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Dashboard_AccountDashboard__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Dashboard_AccountDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Dashboard_AccountDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Dashboard_SellpointDashboard__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Dashboard_SellpointDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Dashboard_SellpointDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Dashboard_TemplateDashboard__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Dashboard_TemplateDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Dashboard_TemplateDashboard__);



/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/dashboard',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Dashboard_TemplateDashboard___default.a,
  children: [{
    path: '',
    name: 'AccountDashboard',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Dashboard_AccountDashboard___default.a
  }, {
    path: ':id',
    name: 'SellpointDashboard',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Dashboard_SellpointDashboard___default.a
  }]
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Home__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Home___default.a
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Login__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login___default.a
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Manage__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/manage/:id',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default.a,
  children: [{
    path: '',
    name: 'Manage',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default.a
  }]
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Points__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Points___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Points__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/points',
  name: 'Points',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Points___default.a
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Register__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/register',
  name: 'register',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Register___default.a
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_Post__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Sellpoint_Gallery__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Sellpoint_Gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Sellpoint_Gallery__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/:id',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a,
  children: [{
    path: ':idp',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default.a
  }, {
    path: 'p/:idpos',
    name: 'Post',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_Post___default.a
  }, {
    path: 'g/:idg',
    name: 'Gallery',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Sellpoint_Gallery___default.a
  }]
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoints__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Sellpoints__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/sellpoints',
  name: 'Sellpoints',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoints___default.a
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_SideHustle__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_SideHustle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_SideHustle__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/sidehustle',
  name: 'SideHustle',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_SideHustle___default.a
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(9);





var sellpointActions = {
  allSellpoints: function allSellpoints(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ALL_SELLPOINTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/businesses', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], response.data);
    });
  }
};

var productActions = {
  allProducts: function allProducts(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ALL_PRODUCTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/products', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], response.data);
    });
  }
};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartGetters; });

var sellpointGetters = {
  allSellpoints: function allSellpoints(state, getters) {
    return state.sellpoints;
  },

  sellpointById: function sellpointById(state, getters) {
    return function (id) {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.sellpoint;
      }
    };
  }
};

var productGetters = {
  allProducts: function allProducts(state, getters) {
    return state.products;
  },

  productById: function productById(state, getters) {
    return function (id) {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.product;
      }
    };
  }
};

var cartGetters = {
  cartProducts: function cartProducts(state) {
    return state.added.map(function (_ref) {
      var id = _ref.id,
          quantity = _ref.quantity;

      var product_item = state.all.find(function (p) {
        return p._id === id;
      });

      return {
        name: product.name,
        price: product.price,
        quantity: quantity
      };
    });
  }
};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(9);


var _sellpointMutations, _productMutations, _cartMutations;



var sellpointMutations = (_sellpointMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* ALL_SELLPOINTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.sellpoints = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _sellpointMutations);

var productMutations = (_productMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* ALL_PRODUCTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* PRODUCT_BY_ID */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PRODUCT_BY_ID_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.product = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _productMutations);

var cartMutations = (_cartMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* VIEW_CART */], function (state) {
  return state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* ADD_TO_CART */], function (state, payload) {
  state.cart.push(payload);
  state.cart = state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* REMOVE_FROM_CART */], function (state, payload) {
  var index = state.cart.findIndex(function (p) {
    return p._id === payload;
  });
  state.cart.splice(index, 1);
}), _cartMutations);

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.285704e.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.285704e.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  "data-v-a2286696",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  "data-v-4ac01950",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-163c71ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(238)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  "data-v-c7034a58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  "data-v-3fe2c854",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  "data-v-2df61673",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-7257c66b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)
__webpack_require__(191)
__webpack_require__(183)
__webpack_require__(184)
__webpack_require__(187)
__webpack_require__(188)
__webpack_require__(189)
__webpack_require__(185)
__webpack_require__(186)
__webpack_require__(190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-11d00f0f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  "data-v-57c384de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  "data-v-5214cda8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-1da44c0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(236)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  "data-v-ac7df29c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  "data-v-1e83cedc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(233)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  "data-v-8965dae0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(239)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  "data-v-e6d13060",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-1d8fb3ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)
__webpack_require__(215)
__webpack_require__(207)
__webpack_require__(208)
__webpack_require__(211)
__webpack_require__(212)
__webpack_require__(213)
__webpack_require__(209)
__webpack_require__(210)
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  "data-v-573d2cde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(231)
__webpack_require__(230)
__webpack_require__(222)
__webpack_require__(223)
__webpack_require__(226)
__webpack_require__(227)
__webpack_require__(228)
__webpack_require__(224)
__webpack_require__(225)
__webpack_require__(229)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  "data-v-792c6947",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  "data-v-1c249854",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  "data-v-6a1a84e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-2b96d14b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 contact_form add-prd-item"
  }, [_c('h6', [_vm._v("Add New Variation")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('ul', {
    staticClass: "row"
  }, [((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', [(_vm.product.product_service == 'P') ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Colour Group:")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Service Package Group:")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "width": "5%"
    }
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showProductItemGroups) ? _vm._i(_vm.showProductItemGroups, null) > -1 : (_vm.showProductItemGroups)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.showProductItemGroups,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showProductItemGroups = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.showProductItemGroups = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showProductItemGroups = $$c
        }
      }
    }
  }), _vm._v("\n                                 Select from previously added "), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("colours")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("service packages")]) : _vm._e()])]), _vm._v(" "), (_vm.showProductItemGroups) ? _c('div', [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex,
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg.product_item_group_id)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('span', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      staticStyle: {
        "height": "4em",
        "width": "85%"
      },
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('span', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "4em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "12px"
      }
    }, [_vm._v("Add to " + _vm._s(pg.product_item_group_name) + " ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [((_vm.product.product_item_groups.length == 0)) ? _c('div', [_c('label', [_c('b', [_vm._v("Add new \n                            "), (_vm.product.product_service == 'P') ? _c('span', [_vm._v(" Colour")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('span', [_vm._v(" Service Package ")]) : _vm._e()])])]) : _c('div', {
    staticStyle: {
      "width": "5%",
      "margin-top": "1.3em"
    }
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-add-product-item-group', '')
      }
    }
  }), _vm._v("\n                            Or Add new \n                            "), (_vm.product.product_service == 'P') ? _c('span', [_vm._v(" Colour")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('span', [_vm._v(" Service Package ")]) : _vm._e()])])]), _vm._v(" "), ((!_vm.showProductItemGroups) && (_vm.showAddNewProductItemGroup || (_vm.product.product_item_groups.length == 0))) ? _c('div', [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Name\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Pick Colour\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Pick Media")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "80px",
        "width": "100px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Service Tag\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Price\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Weight(KG)\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Quantity\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("*Size\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('h4', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Enter Details of New Group Item")])])])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAdd) ? _c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-top-header padding-top-10 padding-bottom-10 padding-left-10"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._m(1), _vm._v(" "), (_vm.product.product_business_ownername != undefined) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_c('b', [_vm._v("| " + _vm._s(_vm.product.product_business_name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-mobile-menu"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.edit_mode) ? _c('span', {}, [_c('h6', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Shop Information")]), _vm._v(" "), (_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spMessagesPanel', '')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#notificationsModal"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('', '')
      }
    }
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spOrdersPanel', '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Shop Settings")])])]) : _vm._e()]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-menu-left-bar"
  }, [_c('menu-left-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-fixed-menu",
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('ul', {}, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])])])])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "edit-switch-bar"
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Product")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), (_vm.new_added) ? _c('div', [_c('p', {
    staticClass: "new-added"
  }, [_vm._v("You have added this product, you can edit details and add more pictures")])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [(!_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h4', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "images-slider img-main-frame"
  }, [_c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', {
    staticClass: "sp-prd-intro-block"
  }, [_c('h4', {
    staticClass: "hidden-sm hidden-xs"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Category: "), _c('span', [_c('b', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hozontal-flat-block"
  }, [_c('p', {
    staticClass: "pull-left"
  }, [_vm._v("reviews")]), _vm._v(" "), _c('p', {
    staticClass: "pull-right"
  }, [_vm._v("@"), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_business_ownername))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-attr-block"
  }, [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [(_vm.product_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price.toLocaleString('en', {
    useGrouping: true
  })))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price.toLocaleString('en', {
    useGrouping: true
  })))])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.product_item.product_item_total_discount != 0) ? _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" \r\n                      " + _vm._s(_vm.product_item.product_item_total_discount) + "% "), _c('span', [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "some-info"
  }, [(!_vm.edit_mode) ? _c('div', [(_vm.is_product_in_cart) ? _c('div', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                            "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [(!_vm.edit_mode) ? _c('ul', {
    staticClass: "col-xs-12 row margin-top-30"
  }, [_c('li', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('p', {}, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Quantity:  ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "102px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('product-cta-button', {
    attrs: {
      "productMain": _vm.product,
      "productItem": _vm.product_item
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItem": _vm.product_item
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner-info"
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-xs-8"
  }, [_c('div', {
    staticClass: "tiny-notice"
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                              ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                partners to make transactions seamless.\r\n                              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-md-12 col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list"
  }, [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                                  ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                                    ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-xs linky",
    staticStyle: {
      "cursor": "pointer",
      "padding": "10px 30px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Copy Link\r\n                            ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Product Pictures")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', [(_vm.editProductPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.product.product_category_id
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right action-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Product Name: ")]), _vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Category: ")]), _c('span', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product.product_item_groups.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Different Colors, Sizes, Plans Subscriptions ..etc")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('p', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h5', {
      staticStyle: {
        "font-size": "12px",
        "text-transform": "capitalize"
      }
    }, [_vm._v("Sizes in this "), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Colour:")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Subscription/Plan:")]) : _vm._e()]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('a', {
        staticClass: "box-wrap",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item', pt)
          }
        }
      }, [_vm._v("\r\n                                " + _vm._s(pt.product_item_size) + "\r\n                              ")])])
    })], 2), _vm._v(" "), _c('hr')])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {}, [(_vm.edit_mode) ? _c('p', [_vm._v("add other variations like colors, sizes etc")]) : _vm._e(), _vm._v(" "), (!_vm.addProductItemPanel) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-item', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [_c('button', {
    staticClass: "btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('div', [_c('product-item-form')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-product', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]), _vm._v(" "), (_vm.removeProductPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.editProductItemPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h4', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('label', [_vm._v(" Product Item Image")]), _vm._v(" "), _c('div', {
    staticClass: "images-slider"
  }, [_c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_item.product_item_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Change Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'product_image')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('span', {
    staticClass: "price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price.toLocaleString('en', {
    useGrouping: true
  })))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price.toLocaleString('en', {
    useGrouping: true
  })))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-12 contact_form",
    attrs: {
      "id": "editProductItem"
    }
  }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Item Price\r\n                                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_price),
      expression: "product_item.product_item_price"
    }],
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product_item.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_weight),
      expression: "product_item.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product_item.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_quantity),
      expression: "product_item.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product_item.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "pull-right",
    staticStyle: {
      "cursor": "pointer",
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-product-item', '')
      }
    }
  }, [_vm._m(16)]), _vm._v(" "), (_vm.removeItemPanel) ? _c('span', {
    staticClass: "pull-left col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeProductItem
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])]), _vm._v(" "), (_vm.product_item.product_item_total_discount != 0) ? _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" \r\n                      " + _vm._s(_vm.product_item.product_item_total_discount) + "% "), _c('span', [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "some-info"
  }, [(!_vm.edit_mode) ? _c('div', [(_vm.is_product_in_cart) ? _c('div', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                            "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])]) : _c('div', [(!_vm.edit_mode) ? _c('ul', {
    staticClass: "col-xs-12 row margin-top-30"
  }, [_c('li', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "quinty"
  }, [_vm._v(" \r\n                                Quantity: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    staticStyle: {
      "max-width": "52px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    staticClass: "col-xs-4",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItem": _vm.product_item
    }
  })], 1)]) : _vm._e()])]) : _vm._e()])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "specific-detail-cards padding-top-100 padding-bottom-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [(_vm.edit_mode) ? _c('div', [_c('h6', [_vm._v("ITEM DISCOUNTS")]), _vm._v(" "), _c('div', [(_vm.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(17)]) : _vm._e(), _vm._v(" "), (_vm.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _c('div', _vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_status_id == 5) ? _c('div', [(dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]), _vm._v(" "), (dc.discount_product_item != _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), (dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount', dc)
        }
      }
    }, [_vm._v("\r\n                                Edit Discount")]), _vm._v("    \r\n                              "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                Deactivate Discount")])]) : _vm._e(), _vm._v(" "), _c('hr')]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("You don't have an active discount")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-discount', '')
        }
      }
    }, [_vm._v("Set New Discount Or Coupon")])])])
  }))]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.details.edit_product_delivery) ? _c('div', {
    staticClass: "contact-form"
  }, [_c('li', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places")]), _vm._v(" "), _c('p', [(_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product-delivery', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                        Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                        partners to make transactions seamless.\r\n                      ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [_c('div', [_vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                          "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })]), _vm._v(" "), (_vm.editDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.delivery_option) + "\r\n                                "), _c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(_vm.delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.city),
        expression: "delivery_option.city"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(_vm.delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_business_delivery_options.length != 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]) : _vm._e(), _c('br'), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - " + _vm._s(delivery.business_delivery_option_price) + "\r\n                        ")])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-delivery-option', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Add Product Delivery Location")]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), (_vm.addDeliveryInformation) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('li', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn col-sm-4",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-sm-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("View Shipping Cost for different Locations")]), _vm._v(" "), _c('div', [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                          ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                            ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', {
    staticClass: "inner-info"
  }, [_c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("Copy Product Link and Share Anywhere\r\n                        ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row product-details-section",
    attrs: {
      "id": "productDetails"
    }
  }, [_c('div', {
    staticClass: "card item-decribe"
  }, [_c('ul', {
    staticClass: "nav nav-tabs animate fadeInUp"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("PRODUCT DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-information', '')
      }
    }
  }, [_vm._v("MORE INFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content animate fadeInUp details-box"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product_details_reviews) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [(_vm.product.product_reviews) ? _c('h6', [_vm._v(_vm._s(_vm.product.product_reviews.length) + " COMMENTS AND REVIEWS")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review) {
    return _c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": _vm.img_user_url + review.product_reviewed_by_image,
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h6', [_vm._v(_vm._s(review.product_reviewed_by)), _c('span', {
      staticClass: "pull-right"
    })]), _vm._v(" "), _c('p', {
      staticClass: "font-playfair"
    }, [_vm._v(_vm._s(review.product_review))]), _vm._v(" "), _c('h6', [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(review.product_review_date))])])])])
  }), _vm._v(" "), (!_vm.edit_mode) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("ADD COMMENT/REVIEW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You must have used this product to wrie a review.")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR REVIEW\r\n                                  "), _c('span', {
    staticClass: "pull-right"
  }, [_c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "bo",
      "id": "bo"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "bo")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "bo"
      }
    }
  }), _vm._v("Business Owner\r\n                                      ")]), _vm._v(" "), (!_vm.loggedIn) ? _c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "buyer",
      "id": "buyer"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "buyer")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "buyer"
      }
    }
  }), _vm._v("Buyer\r\n                                      ")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviews.review),
      expression: "reviews.review"
    }],
    domProps: {
      "value": (_vm.reviews.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviews.review = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-right no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductReview
    }
  }, [_vm._v("POST")])])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_information) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_vm._l((_vm.product.product_information), function(info) {
    return _c('div', {}, [(info.product_info_type == 'image') ? _c('div', [_c('p', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.img_product_url + info.product_info_detail,
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (info.product_info_type == 'text') ? _c('div', [_c('p', [_vm._v(_vm._s(info.product_info_detail))]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.information.product_info_detail),
      expression: "information.product_info_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product information"
    },
    domProps: {
      "value": (_vm.information.product_info_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.information.product_info_detail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductInformation
    }
  }, [_vm._v("Add to Product Information")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add an Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'product_information', _vm.product.product_id)
      }
    }
  })])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_descr) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('h6', [_vm._v("MORE DETAILS")]), _vm._v(" "), _c('ul', _vm._l((_vm.product.product_details), function(details) {
    return _c('li', [(_vm.edit_mode) ? _c('div', [(details.edit_product_detail) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (details.product_detail),
        expression: "details.product_detail"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (details.product_detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          details.product_detail = $event.target.value
        }
      }
    }), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": _vm.editProductDetail
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(details.product_detail) + "\r\n                              "), (_vm.edit_mode) ? _c('span', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-detail', details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductDetail(details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    })])]) : _vm._e()])]) : _c('p', [_vm._v(_vm._s(details.product_detail))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.new_product_detail),
      expression: "details.new_product_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product detail"
    },
    domProps: {
      "value": (_vm.details.new_product_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.new_product_detail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductDetail
    }
  }, [_vm._v("Add to Details")])])]) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "light-gray-bg padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "papular-block"
  }, _vm._l((_vm.other_products), function(o_product) {
    return _c('div', {
      staticClass: "shop-detail prd-market-block"
    }, [(_vm.product.product_id != o_product.product_id) ? _c('div', _vm._l((o_product.product_items), function(o_product_item, index2) {
      return _c('div', {
        staticClass: "row"
      }, [(index2 == 0) ? _c('div', {
        staticClass: "col-md-8 col-md-offset-2"
      }, [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_c('h4', [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_vm._v(_vm._s(o_product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(o_product_item.product_item_price))]), _vm._v(" "), _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "sp-prd-img img-1",
        attrs: {
          "src": _vm.img_product_url + o_product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _vm._m(20, true), _vm._v(" "), _c('ul', {
        staticClass: "item-owner"
      }, [_c('li', [_vm._v("Category:"), _c('span', [_vm._v(" " + _vm._s(o_product.product_category_name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(o_product.product_description))])])]) : _vm._e()])
    })) : _vm._e()])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "12em"
    },
    attrs: {
      "id": "removeProductModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_product_url + _vm.product_item.product_item_image
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn"
  }, [_vm._v("Yes Delete")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Yes, Remove")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modalDialog",
    staticStyle: {
      "margin-top": "4em"
    },
    attrs: {
      "id": "m"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loggedIn) ? _c('ul', {
    staticClass: "sp-menu-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("Hello " + _vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27)]) : _c('ul', {
    staticClass: "sp-menu-list"
  }, [_vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30)])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "-7px"
    },
    attrs: {
      "src": __webpack_require__(244),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left sp-search-menu"
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(" (Kg)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Colour: ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('div', {
    staticClass: "prd-color-block"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Size: ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('div', {
    staticClass: "prd-color-block"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-xs-2"
  }, [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-md-2 col-xs-12"
  }, [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Remove this Item "), _c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form col-md-6"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                            If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                            button.\r\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "stars"
  }, [_c('span', [_vm._v("YOUR RATING")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("I ALSO HAVE THESE")]), _vm._v(" "), _c('span', [_vm._v("Check out other products found in my sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" 10% "), _c('span', [_vm._v("OFF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Remove This Item ?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "border-bottom-color": "transparent",
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "pull-right",
    attrs: {
      "href": "#",
      "title": "Close"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "3em"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_vm._v("View Cart "), _c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Log Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Register")])])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    staticStyle: {
      "width": "98.8%"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-100 pages-in chart-page",
    staticStyle: {
      "background": "#2d3a4b",
      "border": "1px dashed #8a8787"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-3 col-sm-12 chart-card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "cart-summ"
  }, [_c('div', {
    staticClass: " cart-summ-card-left card col-sm-1",
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.cart.length)), _c('br'), _vm._v("items")])])]), _vm._v(" "), _c('div', {
    staticClass: " cart-summ-card-right card col-md-8",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._m(4), _vm._v(" "), _c('li', [_vm._v("₦" + _vm._s(_vm.total_order_amt))]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Shipping Fee: ")]), _vm._v("₦" + _vm._s(_vm.total_delivery_fee))]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 shopping-cart text-center",
    staticStyle: {
      "background": "#ffffff"
    }
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "row group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, [_c('h5', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(group[0]) + "'s Sellpoint")]), _c('br'), _vm._v(" "), _vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "row cart-details"
      }, [_c('li', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "pull-left"
      }, [(item.product_checked) ? _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }, [_c('del', [_vm._v("Selected")])]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Select "), _c('br'), _vm._v("Order")])]), _vm._v(" "), _c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [_c('div', {}, [_c('div', {
        staticClass: "quinty"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [_c('div', {}, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [(item.has_delivery) ? _c('div', {
        staticClass: "dropdown"
      }, [(group[1][index2].selected_product_delivery_option) ? _c('button', {
        staticClass: "dropbtn"
      }, [_vm._v(_vm._s(group.selected_product_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_product_delivery_option.business_delivery_option_price) + "▼")]) : _c('button', {
        staticClass: "dropbtn"
      }, [_vm._v("Select Delivery Option ▼")]), _vm._v(" "), _c('div', {
        staticClass: "dropdown-content"
      }, _vm._l((group[2]), function(option) {
        return _c('div', {
          staticClass: "row"
        }, [(option.business_delivery_product == item.product_main_id) ? _c('span', [_c('label', [(item.product_checked) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.product_delivery_fee),
            expression: "product_delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.product_delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_product_delivery_fee(index, option, index2)
            },
            "__c": function($event) {
              _vm.product_delivery_fee = option.business_delivery_option_id
            }
          }
        })]) : _vm._e(), _vm._v("\r\n                            " + _vm._s(option.business_delivery_option) + " - " + _vm._s(option.business_delivery_option_price) + "\r\n                          ")])]) : _vm._e()])
      }))]) : _c('div', [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("\r\n                        General Seller Delivery Set\r\n                      ")])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [(item.can_remove) ? _c('div', {}, [_c('label', [_vm._v("Remove: ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "icon-close"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    }), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', [(group[4]) ? _c('div', {
      staticClass: "pull-left coupons-sec"
    }, [_vm._m(5, true), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
      return _c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.coupon_code),
          expression: "coupon_code"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id,
          "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, coupon, coupon.discount_percentage)
          },
          "__c": function($event) {
            var $$a = _vm.coupon_code,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = coupon.discount_id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.coupon_code = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " - " + _vm._s(coupon.discount_percentage) + "% Off "), _c('b', [_vm._v("From " + _vm._s(coupon.discount_provider))])])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pull-right delivery-sec"
    }, [(group.products_without_delivery_details_count >= 1) ? _c('div', [(group[2]) ? _c('div', [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group[2].length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼")]) : _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v("Select Delivery Option " + _vm._s(group[0]) + " Orders▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((group[2]), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v("\r\n                              " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                            ")])]) : _vm._e()])
    }))])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total Orders from "), _c('b', [_vm._v(_vm._s(group[0]) + ":")]), _vm._v(" ₦" + _vm._s(group.total_order_amt))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total: ₦" + _vm._s(group.total_order_amt + group.total_delivery_charge))])]) : _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(7, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {
      staticClass: "row"
    }, [_vm._m(8, true)])])])], 2)
  })), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.checked_out.length != 0) ? _c('div', {
    staticClass: "col-sm-12 orders-panel pull-right",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('span', {
    staticClass: "col-sm-3"
  }, [_c('h5', [_vm._v("Your Orders")]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(_vm.total_order_amt))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Shipping Fee: ")]), _vm._v("₦" + _vm._s(_vm.total_delivery_fee))]), _vm._v("\r\n              qwe" + _vm._s(_vm.loggedIn) + "\r\n              "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 pull-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/empty-lonely-cart.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("I'm Lonely and Sad, please "), _c('a', {
    staticStyle: {
      "color": "rgb(252, 16, 75)"
    },
    attrs: {
      "href": "tour"
    }
  }, [_vm._v("fill me up")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 pull-right",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("Your cart is sad and empty,")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "rgb(252, 16, 75)",
      "color": "#ffffff"
    },
    attrs: {
      "href": "tour"
    }
  }, [_vm._v("Start Buying")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "margin-top": "6px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgb(252, 16, 75)"
    },
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")]), _vm._v(" to see products you added to your cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-summ",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "background": "#2d3a4b",
      "margin-bottom": "2em"
    }
  }, [_c('h3', {
    staticClass: "cart-title",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Your Cart")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Checkout items from each sellpoint, then click *Process Orders* to continue.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Total to checkout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "sp-wrap-cards"
  }, [_c('div', {
    staticClass: "sp-top-header padding-top-10 padding-bottom-10 padding-left-10"
  }, [_c('div', {
    staticClass: "sp-top-header-top"
  }, [((_vm.edit_mode && (_vm.visitor_url != ''))) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "5em",
      "height": "1em"
    },
    on: {
      "click": _vm.syncset
    }
  }, [_vm._v("Back to " + _vm._s(_vm.visitor_app))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-menu-left-bar"
  }, [_c('menu-left-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_vm._m(0), _vm._v(" "), (_vm.sellpoint.business_name != undefined) ? _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("| "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_group_id > 0) ? _c('div', [_c('a', {
    staticStyle: {
      "font-size": "10px",
      "color": "#b13504"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_market_group_username
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.sellpoint.business_market_group))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-search-menu hidden-xs"
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_data),
      expression: "search_data"
    }],
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    },
    domProps: {
      "value": (_vm.search_data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_data = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchProductsByBusiness
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-mobile-menu"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('span', {}, [_c('h6', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Shop Information")]), _vm._v(" "), (!_vm.edit_mode) ? _c('span', [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), ((_vm.sellpoint.business_layout == 1) || (_vm.products.length)) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("Shop")])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_layout == 2) || (_vm.services.length)) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spServicesPanel', '')
      }
    }
  }, [_vm._v("Services")])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_layout == 4) || (_vm.posts.length)) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spBlogPanel', '')
      }
    }
  }, [_vm._v("Blog")])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_layout == 3) || (_vm.galleria.length)) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spGalleryPanel', '')
      }
    }
  }, [_vm._v("Gallery")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_set_subscribe) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSubscriptionPanel', '')
      }
    }
  }, [_vm._v("Subscribe")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Us")])])]) : _c('span', [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 0) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("My Shop")])]) : _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("Shop")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spServicesPanel', '')
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spBlogPanel', '')
      }
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spGalleryPanel', '')
      }
    }
  }, [_vm._v("Gallery")])]), _vm._v(" "), (_vm.sellpoint.business_set_subscribe) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSubscriptionPanel', '')
      }
    }
  }, [_vm._v("Subscriptions")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spMessagesPanel', '')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spOrdersPanel', '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Sellpoint Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'dashboard/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View on Dashboard")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.child_route_view) ? _c('div', {
    staticClass: "sp-wrap-card-light"
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "border-radius": "5px",
      "background": "#ffffff",
      "padding": "0 6px 0 6px"
    }
  }, [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer",
      "color": "#363535"
    },
    attrs: {
      "title": "Share Sellpoint, Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "font-size": "1.8em"
    }
  })]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e(), _vm._v(" "), (_vm.copied) ? _c('sup', {
    staticStyle: {
      "border-radius": "5px",
      "background": "#ffffff",
      "padding": "2px",
      "font-size": "14px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("x")])]) : _vm._e()]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "32px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "sp-wrap-card-dashed"
  }, [(!_vm.child_route_view) ? _c('div', [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('section', {
    staticClass: "sp-shop-bnr",
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "data-stellar-background-ratio": "0.5"
    }
  }, [_c('div', {
    staticClass: "position-center-center",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("Change Banner Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_banner_image')
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('br')])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-shop-menu-section hidden-sm hidden-xs",
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row sp-shop-menu-horizontal"
  }, [_c('ul', {}, [(!_vm.edit_mode) ? _c('span', [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), ((_vm.sellpoint.business_layout == 1) || (_vm.products.length)) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'show-products')
      }
    }
  }, [_vm._v("Shop "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content shop-dropdown-content",
    attrs: {
      "id": "shop-dropdown-content"
    }
  }, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " --" + _vm._s(cat.business_category_id))])])
  }))]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_layout == 2) || (_vm.services.length)) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spServicesPanel', '')
      }
    }
  }, [_vm._v("Services")])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_layout == 4) || (_vm.posts.length)) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spBlogPanel', '')
      }
    }
  }, [_vm._v("Blog")])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_layout == 3) || (_vm.galleria.length)) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spGalleryPanel', '')
      }
    }
  }, [_vm._v("Gallery")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_set_subscribe) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSubscriptionPanel', '')
      }
    }
  }, [_vm._v("Subscribe")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Us")])])]) : _c('span', [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("Sellpoint Information "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content shop-dropdown-content"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 0) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("My Shop")])]) : _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("Shop")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spServicesPanel', '')
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spBlogPanel', '')
      }
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spGalleryPanel', '')
      }
    }
  }, [_vm._v("Gallery")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSubscriptionPanel', '')
      }
    }
  }, [_vm._v("Subscriptions")])]), _vm._v(" "), (_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spMessagesPanel', '')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spOrdersPanel', '')
      }
    }
  }, [_vm._v("Orders")])])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Sellpoint Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'dashboard/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View on Dashboard")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "hidden-lg hidden-md sp-action-display-menu",
    staticStyle: {
      "margin-left": "2em",
      "margin-right": "4em",
      "display": "none"
    },
    attrs: {
      "id": "product-action-display-menu"
    }
  }, [_c('ul', {}, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Search"
    },
    on: {
      "click": function($event) {
        _vm.showSectionById('searchSection')
      }
    }
  }, [_vm._v("Sort By "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content sort-dropdown-content",
    attrs: {
      "id": "sort-dropdown-content"
    }
  }, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('featured')
      }
    }
  }, [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Orders Made")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Discounted")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Pre-Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (Low to High)")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (High to Low)")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "filter"
    },
    on: {
      "click": function($event) {
        _vm.showSectionById('filterSection')
      }
    }
  }, [_vm._v("Filter Items")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-wrap-card-full",
    staticStyle: {
      "padding": "0 0 0 0.7em"
    }
  }, [(_vm.child_route_view) ? _c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-sm-3 sp-side",
    staticStyle: {
      "background": "none",
      "margin": "0 1em 0 -0.5em"
    },
    attrs: {
      "id": "spSidebar"
    }
  }, [_c('div', {
    staticClass: "shop-sidebar"
  }, [(_vm.can_edit) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: " sp-side-card sp-sidebar-sort-filter",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(8), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('featured')
      }
    }
  }, [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('orders-made')
      }
    }
  }, [_vm._v("Orders Made")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('discounted')
      }
    }
  }, [_vm._v("Discounted")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('pre-orders')
      }
    }
  }, [_vm._v("Pre-Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('price-low-high')
      }
    }
  }, [_vm._v("Price (Low to High)")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('price-high-low')
      }
    }
  }, [_vm._v("Price (High to Low)")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.filter_array.length != 0) ? _c('div', {
    staticClass: "sp-side-card sp-sidebar-sort-filter"
  }, [_c('div', {
    staticClass: "hidden-xs hidden-sm sp-side-card-header"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [(_vm.sorting_by != 'best-match') ? _c('span', [_vm._v(" Showing (" + _vm._s(_vm.sorting_by) + ") of ...")]) : _c('span', [_vm._v("you are searching for...")])])]), _vm._v(" "), _c('div', _vm._l((_vm.filter_array), function(filter) {
    return _c('li', [_c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(filter[2]))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 3) ? _c('div', {
    staticClass: " sp-side-card sp-sidebar-sort-filter"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._m(9), _vm._v(" "), _c('ul', _vm._l((_vm.sellpoint.business_markets), function(b) {
    return _c('li', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('a', {
      attrs: {
        "href": '/' + b.business_username
      }
    }, [_vm._v(_vm._s(b.business_name))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " sp-side-card sp-sidebar-sort-filter"
  }, [(_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "sp-side-card-header"
  }, [(_vm.edit_mode) ? _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("My Sellpoint Shop Categories")]) : _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("Take a pick")])]), _vm._v(" "), (_vm.category.edit) ? _c('div', [_c('h6', [_vm._v("Edit Category")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category),
      expression: "category.business_category"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category = $event.target.value
      }
    }
  }), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_c('i', {
    staticClass: "icon-check"
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit-category', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_categories) ? _c('ul', {}, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', {
      staticStyle: {
        "padding": "5px",
        "border-bottom": "1px solid #d1d5db"
      }
    }, [_c('p', [_c('span', {
      staticClass: "a-lf"
    }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.filterBy(1, cat.business_category_id, cat.business_category)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")]), _vm._v(" "), (_vm.edit_mode) ? _c('span', [(cat.can_edit == 1) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.setComponent('edit-category', cat)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]) : _vm._e()]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "sp-add-new-category",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "color": "#363535"
    }
  }, [_vm._v("Add New Category > ")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('li', [_c('label', [_vm._v("Select from related category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct
      }
    }, [_vm._v(_vm._s(ct.category_name))])
  })], 2)]), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('li', [_c('label', [_vm._v("Select a category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_category),
      expression: "category.new_category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "width": "245px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category.new_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct.sub_category_id
      }
    }, [_vm._v(_vm._s(ct.sub_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("OR")]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_listed_category),
      expression: "category.new_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Category"
    },
    domProps: {
      "value": (_vm.category.new_listed_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.new_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px",
      "margin-top": "1em"
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Add Category")])])])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "sp-side-card-header"
  }, [(_vm.edit_mode) ? _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("My Business Categories")]) : _vm._e()]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.sellpoint.business_market_categories), function(cat) {
    return _c('li', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('p', [_c('span', {
      staticClass: "a-lf"
    }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSellpointMarketProducts()
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")])]), _vm._v(" "), _c('ul', {}, _vm._l((cat.business_sub_categories), function(sub_cat) {
      return _c('li', {
        staticStyle: {
          "padding": "5px",
          "border-bottom": "1px solid #e5eaf0"
        }
      }, [_c('p', [_c('span', {
        staticClass: "a-lf"
      }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.getCategoryProducts(sub_cat.business_sub_category_id)
          }
        }
      }, [_vm._v(_vm._s(sub_cat.business_sub_category) + " ")])])])
    }))])
  }))])]), _vm._v(" "), (_vm.sellpoint_product_item_groups && (_vm.sellpoint_product_item_groups.length != 0)) ? _c('div', {
    staticClass: "sp-side-card sp-sidebar-sort-filter"
  }, [_vm._m(10), _vm._v(" "), _c('ul', _vm._l((_vm.sellpoint_product_item_groups), function(group) {
    return _c('li', [_c('a', {
      staticClass: "sort-by",
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.filterBy(2, group.product_item_group_id, group.product_item_group_name)
        }
      }
    }, [_vm._v("\r\n                                        " + _vm._s(group.product_item_group_name) + "\r\n                                    ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.sellpoint_product_sizes && (_vm.sellpoint_product_sizes.length != 0)) ? _c('div', {
    staticClass: "sp-side-card sp-sidebar-sort-filter"
  }, [_vm._m(11), _vm._v(" "), _c('ul', _vm._l((_vm.sellpoint_product_sizes), function(size) {
    return _c('li', [_c('a', {
      staticClass: "sort-by",
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.filterBy(3, size.product_item_id, size.product_item_size)
        }
      }
    }, [_vm._v("\r\n                                        " + _vm._s(size.product_item_size) + "\r\n                                    ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.sellpoint_product_services && (_vm.sellpoint_product_services.length != 0)) ? _c('div', {
    staticClass: "sp-side-card sp-sidebar-sort-filter"
  }, [_vm._m(12), _vm._v(" "), _c('ul', _vm._l((_vm.sellpoint_product_services), function(service) {
    return _c('li', [_c('a', {
      staticClass: "sort-by",
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.filterBy(3, service.product_item_id, service.product_item_size)
        }
      }
    }, [_vm._v("\r\n                                        " + _vm._s(service.product_item_service_tag) + "\r\n                                    ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "card col-sm-8 sp-main",
    staticStyle: {
      "padding-bottom": "8em"
    },
    attrs: {
      "id": "spMain"
    }
  }, [_c('div', {
    staticClass: "sp-wrap-card-header"
  }, [_c('div', {
    staticClass: "categories-slide"
  }, [_c('ul', {
    staticClass: "pull-left"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("All "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content"
  }, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")])])
  }))]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat, count) {
    return _c('li', {
      staticClass: "hidden-xs hidden-sm"
    }, [(count < 5) ? _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {}, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "showFilters"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilterSortBoard()
      }
    }
  }, [_vm._v("Sort")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "showFilters"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilterSortBoard()
      }
    }
  }, [_vm._v("Filter")])])]), _vm._v(" "), _c('div', {
    staticClass: "categories-slide hidden-lg hidden-md"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row filter-sort-board",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "filterSortBoard"
    }
  }, [_c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilterSortBoard()
      }
    }
  }, [_vm._v("Hide")]), _vm._v(" "), _c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.resetFilterSortOptions()
      }
    }
  }, [_vm._v("Reset Options")])]), _vm._v(" "), (_vm.price_filter_is_set) ? _c('div', {
    staticStyle: {
      "width": "45%",
      "padding-bottom": "1em",
      "margin-bottom": "6px",
      "border-bottom": "1px solid #f2f2f2"
    }
  }, [_c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Price")]), _vm._v(" "), _c('vue-slider', _vm._b({
    model: {
      value: (_vm.slider_type),
      callback: function($$v) {
        _vm.slider_type = $$v
      },
      expression: "slider_type"
    }
  }, 'vue-slider', _vm.slider_options, false)), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "8px"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("FILTER")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-8"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "sort-row",
    staticStyle: {
      "float": "right",
      "margin-left": "-2em"
    }
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("All "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content"
  }, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', {
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.filterBy(1, cat.business_category_id, cat.business_category)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 sort-row sort-row-left"
  }, [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('featured')
      }
    }
  }, [_vm._v("Featured")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('orders-made')
      }
    }
  }, [_vm._v("Orders")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('discounted')
      }
    }
  }, [_vm._v("Newest")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('pre-orders')
      }
    }
  }, [_vm._v("Discounted")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('price-low-high')
      }
    }
  }, [_vm._v("Pre-Orders")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('price-high-low')
      }
    }
  }, [_vm._v("Price\r\n                                "), _vm._m(15), _vm._v(" "), _vm._m(16)])])])])]), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [((_vm.sellpoint.business_market_category_id == 2) || (_vm.sellpoint.business_market_category_id == 5)) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "create?create=new"
    }
  }, [_vm._v("Add New Sellpoint")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 3) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "create?create=add"
    }
  }, [_vm._v("Add New Business")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewAllProductsBanner) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('view-all-products', '')
      }
    }
  }, [_vm._v("\r\n                        View all Products")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.addPanel) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "2px dashed #444"
    }
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "2em"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Cancel")])]), _vm._v(" "), (_vm.addProductPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('product-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addPostPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-post-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addGalleryPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-gallery-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addProductGalleryPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Sellpoint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-product-gallery-form')], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.spProductsPanel) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em"
    }
  }, [(_vm.product_search_messsage != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.product_search_messsage))]) : _vm._e()]), _vm._v(" "), (_vm.spMarketPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.market), function(sp) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      staticClass: "img-1 img-responsive",
      attrs: {
        "src": _vm.img_sellpoint_url + sp.business_brand_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-name"
    }, [_c('p', {
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_vm._v(_vm._s(sp.business_name))])])])])])])])
  })) : _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "item-display hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [(_vm.edit_mode) ? _c('div', {}, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product', '')
      }
    }
  }, [_vm._v("Add New Product")])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "hidden-md hidden-lg",
    staticStyle: {
      "margin-top": "1.3em"
    }
  }, [(_vm.sellpoint.business_market_category_id == 1) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-product', '')
      }
    }
  }, [_vm._v("Add New Product")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row fixed-pan-03"
  }, [(_vm.products.length > 0) ? _c('div', {}, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.listView) ? _c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('market-view', '')
      }
    }
  }, [_vm._v("\r\n                                Switch to Market View")])]) : _vm._e(), _vm._v(" "), (_vm.marketView) ? _c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('list-view', '')
      }
    }
  }, [_vm._v("\r\n                                Switch to List View")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.products.length) ? _c('span', [_c('p', [_vm._v("No Products added yet")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:start",
      value: (_vm.mouseover),
      expression: "mouseover",
      arg: "start"
    }],
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [(_vm.listView) ? _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-6 sp-prd-col-wrap"
    }, [_c('div', {
      staticClass: "sp-prd-col"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "item"
      }, [(index2 == 0) ? _c('div', [_c('a', {
        attrs: {
          "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [(product.product_images[0]) ? _c('div', {
        staticClass: "item-img sp-prd-list-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "img-2 sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-name"
      }, [_c('div', {
        staticClass: "sp-prd-name"
      }, [_c('a', {
        attrs: {
          "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_item_price))])])])]) : _vm._e()])
    }))])
  })) : _vm._e(), _vm._v(" "), (_vm.marketView) ? _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "shop-detail"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "row"
      }, [(index2 == 0) ? _c('div', {
        staticClass: "col-md-8 col-md-offset-2"
      }, [_c('h4', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "img-1",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _vm._m(18, true), _vm._v(" "), _c('ul', {
        staticClass: "item-owner"
      }, [_c('li', [_vm._v("Tagged By :"), _c('span', [_vm._v(" " + _vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('li', [_vm._v("Category:"), _c('span', [_vm._v(" " + _vm._s(product.product_category_name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()])
    }))
  })) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.spBlogPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [(_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-post', '')
      }
    }
  }, [_vm._v("+ New Blog")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "shop-detail"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-2"
    }, [_c('a', {
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/p/' + post.post_url_name
      }
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/p/' + post.post_url_name
      }
    }, [_vm._v(_vm._s(post.post_title))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_ownername))]), _vm._v(" "), (((_vm.set_post_view.length != 0) && (_vm.set_post_view.post_media_post == post.post_id))) ? _c('div', {
      staticClass: "item-img"
    }, [(_vm.checkIfVideo(_vm.set_post_view.post_media)) ? _c('iframe', {
      attrs: {
        "width": "420",
        "height": "315",
        "src": _vm.set_post_view.post_media
      }
    }) : _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": _vm.set_post_view.post_media,
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "item-img"
    }, [(post.post_media && (post.post_media.length != 0)) ? _c('div', [(_vm.checkIfVideo(post.post_media[0].post_media)) ? _c('iframe', {
      attrs: {
        "width": "420",
        "height": "315",
        "src": post.post_media[0].post_media
      }
    }) : _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post.post_media[0].post_media,
        "alt": ""
      }
    })]) : _vm._e()])]), _vm._v(" "), (post.post_media && (post.post_media.length > 1)) ? _c('div', {
      staticClass: "item-media-list"
    }, _vm._l((post.post_media), function(post_media) {
      return _c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-post-view', post_media)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-circle-o"
      })])
    })) : _vm._e(), _vm._v(" "), _vm._m(19, true), _vm._v(" "), _c('ul', {
      staticClass: "item-owner"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_text))]), _vm._v(" "), _c('br'), _c('br')])])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spServicesPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [_c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-6 sp-prd-col-wrap"
    }, [_c('div', {
      staticClass: "sp-prd-col"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "item"
      }, [(index2 == 0) ? _c('div', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_c('div', {
        staticClass: "item-img sp-prd-list-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "img-2 sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "item-name"
      }, [_c('div', {
        staticClass: "sp-prd-name"
      }, [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', {
        staticClass: "sp-prd-descr"
      }, [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.product_category_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_item_price))])])]) : _vm._e()])
    }))])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spGalleryPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "sp-template-add-btn-left"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-gallery', '')
      }
    }
  }, [_vm._v("+ New Lookbook")])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "sp-template-add-btn-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-gallery', '')
      }
    }
  }, [_vm._v("+ New Product Lookbook")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "gallerylist"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.galleria), function(gallery, gdex) {
    return _c('div', {
      staticClass: "col-md-3 col-xs-6",
      staticStyle: {
        "min-height": "300px",
        "max-height": "300px"
      }
    }, [_c('div', {}, [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/g/' + gallery.gallery_posts_group_url_name
      }
    }, [(gallery.gallery_posts_group_posts_media[0]) ? _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-img sp-prd-list-img",
      staticStyle: {
        "height": "220px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png",
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media,
        "alt": ""
      }
    })])]) : _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spProfilePanel) ? _c('div', {
    attrs: {
      "id": "sp-profile"
    }
  }, [_c('div', {
    staticClass: "history-block padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-9 sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-5 sp-pl0"
  }, [(_vm.details.tagline_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Enter Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('tagline')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v(" submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_tagline) ? _c('span', [_c('h2', [_vm._v(_vm._s(_vm.sellpoint.business_tagline) + "\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-tagline', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e()])]) : _c('span', [_c('h2', [_vm._v("Connect with me, through my Sellpoint\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-tagline', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-50"
  }, [_c('img', {
    staticClass: "img_responsive",
    attrs: {
      "src": _vm.img_sellpoint_url + _vm.sellpoint.business_brand_image,
      "width": "250",
      "height": "250"
    }
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Change Brand Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_brand_image')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 margin-top-50 sp-pl0"
  }, [(_vm.details.profile_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Your Business Profile")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('profile')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_profile) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_profile) + "\r\n                                        "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-profile', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("Making Business memories as exciting as fireworks display, on a New Year's Sky.\r\n                                        Having an online presence is crucial as it helps me connect with my customers irrespective of their location\r\n                                        "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-profile', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sp-profile-services"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h6', [_vm._v("My Services")]), _vm._v(" "), (_vm.edit_mode) ? _c('ul', _vm._l((_vm.sellpoint.business_services), function(service) {
    return _c('li', [(service.edit_set) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.business_service),
        expression: "service.business_service"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (service.business_service)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          service.business_service = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      attrs: {
        "type": "submit"
      },
      on: {
        "click": _vm.editService
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(service.business_service) + " "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-service', service)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })])])])
  })) : _c('ul', _vm._l((_vm.sellpoint.business_services), function(service) {
    return _c('li', [_c('p', [_vm._v(_vm._s(service.business_service))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.service_name),
      expression: "service.service_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter a service"
    },
    domProps: {
      "value": (_vm.service.service_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.service_name = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addService
    }
  }, [_vm._v("Add a Service")])]) : _vm._e()])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spContactPanel) ? _c('div', {
    attrs: {
      "id": "sp-contact"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block  sp-pl0"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form  sp-pl0"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12 sp-pl0",
    staticStyle: {
      "border": "1.5px rgb(16, 5, 82) solid",
      "padding": "4em",
      "min-height": "30em"
    }
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Contact Information")]), _vm._v(" "), (_vm.details.contact_info_edit) ? _c('div', {
    staticClass: "contact_form sp-pl0"
  }, [(_vm.edit_mode) ? _c('ul', {}, [_c('li', [_c('label', [_vm._v("Address\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Email(s)\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Phone(s)\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('contact_info')
      }
    }
  }, [_c('i', {
    staticClass: "icon-file"
  }), _vm._v("Save")]), _vm._v("\r\n                                              \r\n                                        "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]) : _c('div', [(_vm.sellpoint.business_address) ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]) : _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_emails) ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]) : _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_phones) ? _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]) : _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.edit_mode) ? _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-contact-info', '')
      }
    }
  }, [_vm._v("Edit Details")]) : _vm._e()])]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "col-sm-4 contact_form"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("SEND A MESSAGE")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *NAME ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.name),
      expression: "contact_form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *EMAIL\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.email),
      expression: "contact_form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR MESSAGE"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.message),
      expression: "contact_form.message"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.contact_form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-left no-margin",
    on: {
      "click": _vm.sendBusinessContactForm
    }
  }, [_vm._v("SEND MESSAGE")])])])])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spMessagesPanel) ? _c('div', {
    attrs: {
      "id": "sp-messages"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12",
    staticStyle: {
      "border": "1.5px rgb(16, 5, 82) solid",
      "padding": "4em",
      "min-height": "30em"
    }
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Your Messages")]), _vm._v(" "), (_vm.details.contact_info_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', [_c('label', [_vm._v("Address\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Email(s)\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Phone(s)\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('contact_info')
      }
    }
  }, [_c('i', {
    staticClass: "icon-file"
  }), _vm._v("Save")]), _vm._v("\r\n                                          \r\n                                    "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]) : _c('div', [(_vm.sellpoint.business_address) ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]) : _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_emails) ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]) : _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_phones) ? _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]) : _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v("No details yet")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-contact-info', '')
      }
    }
  }, [_vm._v("Edit Details")])])]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "col-sm-4 contact_form"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("SEND A MESSAGE")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *NAME ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.name),
      expression: "contact_form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *EMAIL\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.email),
      expression: "contact_form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR MESSAGE"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.message),
      expression: "contact_form.message"
    }],
    domProps: {
      "value": (_vm.contact_form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-left no-margin",
    on: {
      "click": _vm.sendBusinessContactForm
    }
  }, [_vm._v("SEND MESSAGE")])])])])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spOrdersPanel) ? _c('div', {
    attrs: {
      "id": "sp-orders"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Orders on " + _vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "overflow": "scroll"
    }
  }, [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Order From")]), _vm._v(" "), _c('th', [_vm._v("Order Total")]), _vm._v(" "), _c('th', [_vm._v("Payment Mode")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#2d3a4b"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_no))])]), _c('br'), _vm._v("\r\n                                        " + _vm._s(order.order_date) + "\r\n                                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_business))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spDeliveryPanel) ? _c('div', {
    attrs: {
      "id": "sp-delivery"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block .sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-8 sp-pl0"
  }, [_c('div', {
    staticClass: "horizontal-cards"
  }, [(_vm.edit_mode) ? _c('div', [_c('h6', [_vm._v("Your Sellpoint's Delivery Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("This is the general shipping Information that would be shown to buyers")])]) : _c('h6', [_vm._v("General Delivery Information")]), _vm._v(" "), (_vm.details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information) + "\r\n                                            "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-delivery-information', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                                Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                                partners to make transactions seamless.\r\n                                            "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-delivery-information', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('p', [_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                                            to have its on shipping fee, specify it when setting up your product.\r\n                                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("How would your Business Shipping Fee be calculated?")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "9",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "9")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "9"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "10",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "10")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "10"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "11",
      "value": "11"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "11")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "11"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sp-profile-services"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [_c('div', [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.editDeliveryInformation && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('li', [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('reset-delivery-information', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                                                    " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                                                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-delivery-information', '')
      }
    }
  }, [_vm._v("Add New Delivery Information")]), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.addDeliveryInformation) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('li', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-delivery-information', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]) : _c('div', [_c('ul', _vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('li', [_c('p', [_vm._v(_vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price))])])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spSettingsPanel) ? _c('div', {
    attrs: {
      "id": "sp-contact"
    }
  }, [_c('div', {
    staticClass: "history-block padding-bottom-100 col-sm-9 sp-pl0"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-12 sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Bank Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), (_vm.sellpoint.business_bank_details) ? _c('div', [(_vm.sellpoint.business_bank_details.length == 0 || _vm.set_bank_details) ? _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_name),
      expression: "sellpoint.business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_name),
      expression: "sellpoint.business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_number),
      expression: "sellpoint.business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("your details are securley saved")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-bank-details', '')
      }
    }
  }, [_vm._v("Edit Bank Details")])])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\r\n                                    be paid by you as you set your product, or by your customers as they buy. \r\n                                    Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set your Sellpoint Filters")]), _vm._v(" "), _c('p', [_vm._v("This helps your customers to filter your products and services based on parameters like: categories, prices, colors, etc.")]), _vm._v(" "), (_vm.sellpoint.business_filters) ? _c('div', [_c('div', _vm._l((_vm.sellpoint.business_filters), function(bfilter) {
    return _c('p', [_vm._v("\r\n                                        " + _vm._s(bfilter.business_filter_name) + " "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "padding": "0 3px 0 5px",
        "border-radius": "50%"
      },
      on: {
        "click": function($event) {
          _vm.removeFilterOption(bfilter.business_filter_id)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_vm._l((_vm.filters), function(filter) {
    return _c('label', {
      staticStyle: {
        "margin": "3px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_filters),
        expression: "selected_filters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": filter.filter_id,
        "checked": Array.isArray(_vm.selected_filters) ? _vm._i(_vm.selected_filters, filter.filter_id) > -1 : (_vm.selected_filters)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected_filters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter.filter_id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected_filters = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected_filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_filters = $$c
          }
        }
      }
    }), _vm._v(_vm._s(filter.filter_name) + "\r\n                                    ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.setFilterOptions
    }
  }, [_vm._v("Save Filter Options")])], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                                    You can set individual Product Discounts on thier product pages.\r\n                                ")]), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('span', [(_vm.setDiscount) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]) : _c('span', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an Ongoing discount, You can only set coupons. if you want to discontinue\r\n                                    running discount, click on De-Activate and then set a new one")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Coupon")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active != 1) ? _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-discount-coupon', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(22)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-discount-coupon', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.viewDiscounts && _vm.sellpoint.business_discounts_coupons) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), (dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                            Edit Coupon")]), _vm._v("    \r\n                                        "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                            Deactivate Coupon")])]) : _vm._e(), _vm._v(" "), _c('hr')])
  })], 2) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.spSubscriptionPanel) ? _c('div', [(_vm.edit_mode) ? _c('div', {
    staticStyle: {
      "margin-top": "1.3em"
    }
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-subscription-group', '')
      }
    }
  }, [_vm._v("Create a Subscription Group")])]) : _vm._e(), _vm._v(" "), (_vm.newSubscriptionGroup) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Setup New Subscription")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Name\r\n                                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription.group_name),
      expression: "subscription.group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.subscription.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subscription.group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addSubscriptionGroup
    }
  }, [_vm._v("Add Subscription")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('div', [_c('h4', [_vm._v("Subcription Groups")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_subscription_groups), function(subg) {
    return _c('div', [_vm._v("\r\n                            " + _vm._s(subg.business_subscription_group_name) + "\r\n                            "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.setComponent('add-product-to-subscription-group', subg)
        }
      }
    }, [_vm._v("Add New Product/Service as Subscriptions")])])
  })], 2)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-wrap-card-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em",
      "margin-left": "-2em",
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "bottombar-panel",
    attrs: {
      "id": "mobileBottomBar"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closeMobileBottomBar
    }
  }, [_vm._v("X")]), _vm._v(" "), (_vm.bottombar_search) ? _c('div', [_c('div', {
    staticClass: "sp-search-menu",
    staticStyle: {
      "width": "85%",
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_data),
      expression: "search_data"
    }],
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    },
    domProps: {
      "value": (_vm.search_data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_data = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchProductsByBusiness
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.mobileBottomBarActions('display-search-bar', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Search")])]), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27)])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "-7px"
    },
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#notificationsModal"
    }
  }, [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#notificationsModal"
    }
  }, [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs hidden-sm sp-side-card-header"
  }, [_c('h5', {
    staticClass: "shop-tittle margin-bottom-10"
  }, [_vm._v("Sort By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-side-card-header"
  }, [_c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("....")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs hidden-sm sp-side-card-header"
  }, [_c('h5', {
    staticClass: "shop-tittle margin-bottom-10"
  }, [_vm._v("Sort By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs hidden-sm sp-side-card-header"
  }, [_c('h5', {
    staticClass: "shop-tittle margin-bottom-10"
  }, [_vm._v("Sort By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs hidden-sm sp-side-card-header"
  }, [_c('h5', {
    staticClass: "shop-tittle margin-bottom-10"
  }, [_vm._v("Sort By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticClass: "p-tiny"
  }, [_c('b', [_vm._v("Categories:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-xs-4",
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('p', {
    staticClass: "p-tiny"
  }, [_c('b', [_vm._v("Sort Items by")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "title": "High to Low"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": "-9.2px"
    }
  }, [_c('a', {
    attrs: {
      "title": "Low to High"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "product-num"
  }, [_vm._v("Showing your products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" 10% "), _c('span', [_vm._v("OFF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form col-md-6"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                        If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                        button.\r\n                                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Timeline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _c('br'), _c('span', [_vm._v("Cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort"
  }), _c('br'), _c('span', [_vm._v("Sort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _c('br'), _c('span', [_vm._v("Chat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
}]}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "sp-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-12 foot-links",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("How to use")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("©  2015 Sellpoint. All rights reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])])
}]}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em",
      "margin-right": "1.6em"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "edit-switch-bar"
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Gallery")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_name) + " Lookbook")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [(!_vm.edit_mode) ? _c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "background": "#262b30",
      "border": "#000000 solid 1em",
      "min-height": "50em"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-8 gallery-left"
  }, [(_vm.display_post.gallery_post_media && (_vm.display_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('img', {
    staticClass: "img-1 sp-prd-img",
    attrs: {
      "src": _vm.display_post.gallery_post_media[0].gallery_post_media,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.display_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.display_post.gallery_post_details))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_text))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-4 gallery-right"
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post) {
    return _c('div', {
      staticClass: "post-folder"
    }, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-wrap"
    }, [_c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media,
        "alt": ""
      }
    })]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-4 col-xs-12",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "2em"
    }
  }, [(_vm.editGalleryPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Lookbook")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Name\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_posts_group_name),
      expression: "gallery.gallery_posts_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.gallery.gallery_posts_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_posts_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Details\r\n                                        "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_posts_group_text),
      expression: "gallery.gallery_posts_group_text"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.gallery.gallery_posts_group_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_posts_group_text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editGallery
    }
  }, [_vm._v("Save Lookbook")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-gallery', '')
      }
    }
  }, [_vm._v("Edit Lookbook Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Lookbook Name: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_text))]), _vm._v(" "), (_vm.gallery.gallery_posts_group_type == 1) ? _c('p', [_c('b', [_vm._v("Type:")]), _vm._v(" Posts Only Lookbook")]) : _vm._e(), _vm._v(" "), (_vm.gallery.gallery_posts_group_type == 2) ? _c('p', [_c('b', [_vm._v("Type:")]), _vm._v(" Product/Service Lookbook")]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Added On: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_time_ago))]), _vm._v(" "), (_vm.gallery.gallery_posts_group_posts) ? _c('p', [_c('b', [_vm._v("No. of Posts: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_posts.length))]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-gallery', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Gallery")]), _vm._v(" "), (_vm.removeGalleryPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Gallery?")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeGallery
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "card col-md-8 col-xs-12 padding-bottom-100",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Posts in Lookbook")]), _vm._v(" "), (_vm.gallery.gallery_posts_group_type == 2) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Posts in this lookbook can ony be edited on their product page when viewed")]) : _vm._e(), _vm._v(" "), (_vm.viewGalleryPost) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "dashed #cccccc"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [(!(_vm.display_post.gallery_post_product)) ? _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-gallery-post', '')
      }
    }
  }, [_vm._v("Edit Post")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('close-view-gallery-post', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.editGalleryPostPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Lookbook")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Caption\r\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_post.gallery_post_caption),
      expression: "display_post.gallery_post_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.display_post.gallery_post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.display_post.gallery_post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Details\r\n                                                "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_post.gallery_post_details),
      expression: "display_post.gallery_post_details"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.display_post.gallery_post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.display_post.gallery_post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editGalleryPost
    }
  }, [_vm._v("Save Post")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])])]) : _c('div', [_c('h6', [_c('b', [_vm._v("Post Caption: ")]), _vm._v(_vm._s(_vm.display_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.display_post.gallery_post_details))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Added On: ")]), _vm._v(_vm._s(_vm.display_post.gallery_post_time_ago))]), _vm._v(" "), (_vm.display_post.gallery_post_product && (_vm.display_post.gallery_post_product != 0)) ? _c('p', [_c('a', {
    staticClass: "btn btn-xs",
    attrs: {
      "href": '/' + _vm.gallery.gallery_posts_group_ownerusername + '/' + _vm.display_post.gallery_post_url_caption
    }
  }, [_vm._v("View Product/Service")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.removeGalleryPostPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Post?")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeGalleryPost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-gallery-post', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Post")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h5', [_vm._v("Post Media ")]), _vm._v(" "), (_vm.display_post.gallery_post_media && (_vm.display_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "img-row"
  }, [_vm._l((_vm.display_post.gallery_post_media), function(pm) {
    return _c('div', {
      staticClass: "img-column"
    }, [(_vm.checkIfVideo(pm.gallery_post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.gallery_post_media && (pm.gallery_post_media != 'error'))) ? _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": pm.gallery_post_media
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), (!(_vm.display_post.gallery_post_product)) ? _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.gallery_post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange2($event, 'gallery_media', _vm.display_post.gallery_post_id)
      }
    }
  })])])])]) : _c('div', [_vm._l((_vm.gallery.gallery_posts_group_posts), function(post) {
    return _c('div', {
      staticClass: "post-folder col-md-2 col-xs-4"
    }, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-wrap"
    }, [_c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(post.gallery_post_caption))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('view-gallery-post', post)
        }
      }
    }, [_vm._v("view post")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em"
    }
  }, [(_vm.addNewPost) ? _c('div', {
    staticClass: "cart-ship-info register col-sm-10 contact_form"
  }, [(_vm.gallery.gallery_posts_group_type == 2) ? _c('div', [_c('product-gallery-form')], 1) : _c('div', [_c('h6', [_vm._v("New Gallery Post")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Caption\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Details\r\n                                  "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])])])]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-new-post', '')
      }
    }
  }, [_vm._v("Add New Post")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "2em"
    }
  }, [_c('section', {
    staticClass: "padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("ALSO IN MY GALLERY")])])])])])])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('section', {
    staticClass: "sp-mini-wrap"
  }, [_c('div', {
    staticClass: "container padding-top-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-landing-circle col-md-6 col-md-offset-3 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row sp-inner-circle"
  }, [_c('div', {
    staticClass: "logo-image text-center"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "padding-top-20 padding-bottom-20",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d3a4b"
    }
  }, [_vm._v("Prepare and setup your interests, businesses and views for a larger world to connect.")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "font-size": "14px",
      "color": "#f8f9fa",
      "background": "#2d3a4b"
    },
    attrs: {
      "href": "register",
      "type": "button"
    }
  }, [_vm._v("Get Started")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    attrs: {
      "tyle": "text-align: center;"
    }
  }, [_c('p', {
    staticClass: "hidden-sm hidden-xs",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Have an Account? "), _c('a', {
    attrs: {
      "href": "login"
    }
  }, [_c('u', [_vm._v("Log In")])]), _c('br'), _vm._v(" Or  "), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_c('u', [_vm._v("Create an Account ")])])]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Have an Account? "), _c('a', {
    attrs: {
      "href": "login"
    }
  }, [_c('u', [_vm._v("Log In")])]), _vm._v(" Or  "), _c('br'), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_c('u', [_vm._v("Create an Account ")])])])])])])])])])])
}]}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("setting up your account....")])])])])
}]}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar ownmenu"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [_c('ul', {
    staticClass: "navbar-right"
  }, [(_vm.loggedIn) ? _c('li', {
    staticClass: "dropdown user-acc"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('h6', [_vm._v("HELLO! " + _vm._s(_vm.user))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]) : _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user-basket"
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._l((_vm.items), function(item) {
    return _c('li', [(!item.checked_out) ? _c('div', [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h6', {
      staticClass: "media-heading"
    }, [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.product_price) + " NGN")]), _vm._v(" "), _c('span', {
      staticClass: "qty"
    }, [_vm._v("QTY: " + _vm._s(item.quantity))]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.removeFromCart(item)
        }
      }
    }, [_vm._v("Remove")]), _vm._v("kk" + _vm._s(item.checked_out) + "\r\n                            ")])]) : _vm._e()])
  }), _vm._v(" "), _c('li', [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("SUBTOTAL: " + _vm._s(_vm.total) + " NGN")])]), _vm._v(" "), _c('li', {
    staticClass: "margin-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 "
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.checkout
    }
  }, [_vm._v("CHECK OUT")])])])])], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(243),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#nav-open-btn",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "nav-open-btn"
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "contact"
    }
  }, [_vm._v("Tour Markets")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_vm._v("MY CART")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("ACCOUNT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("LOG OUT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "cart",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('div', {
    staticClass: "cart-img"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive",
    attrs: {
      "src": "static/assets/images/cart-img-1.jpg",
      "alt": "..."
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "shopping-cart.html"
    }
  }, [_vm._v("VIEW CART")])])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    staticClass: "sp-shop-bnr",
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.68)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "data-stellar-background-ratio": "0.5"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.sellpoint.business_market_group_id != 0) ? _c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": _vm.sellpoint.business_market_group_username
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.sellpoint.business_market_group) + "\r\n                  ")])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_vm._v("Browse and purchase with fun, holla me if you need any help ")])]), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Change Banner Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_banner_image')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-50 padding-bottom-100"
  }, [_c('div', {
    staticClass: "col-sm-11 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12"
    }, _vm._l((product.product_items), function(item, index) {
      return _c('div', {
        staticClass: "card-flx ch-100"
      }, [(index == 0) ? _c('div', {
        staticClass: "story-post card-post"
      }, [_c('div', {
        staticClass: "post-image"
      }, [_c('img', {
        staticClass: "card-post-image",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _c('a', {
        staticClass: "avatar-ref",
        attrs: {
          "href": "#"
        }
      }, [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": _vm.img_user_url + 'smorc-eyes.jpg',
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('h4', {
        staticClass: "title"
      }, [_c('a', {
        attrs: {
          "href": "#"
        }
      }, [_c('b', [_vm._v(_vm._s(product.product_name))])])])]), _vm._v(" "), _vm._m(0, true)]) : _vm._e()])
    }))
  }), _vm._v(" "), (_vm.spMarketPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.market), function(sp) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      staticClass: "img-1",
      attrs: {
        "src": _vm.img_sellpoint_url + sp.business_brand_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-name"
    }, [_c('p', {
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_vm._v(_vm._s(sp.business_name))])])])])])])])
  })) : _vm._e()], 2)]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "card-flx-footer"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion-heart"
  }), _vm._v("57")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion-chatbubble"
  }), _vm._v("6")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion-eye"
  }), _vm._v("138")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-sm-8"
  })])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-100 pages-in chart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.orders.set) ? _c('div', {
    staticClass: "col-sm-12 card",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('h1', {
    staticClass: "card-title"
  }, [_vm._v("Your Orders")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Ordered From")]), _vm._v(" "), _c('th', [_vm._v("Order Total")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#df4d4d"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v("\r\n                      " + _vm._s(order.order_date) + "\r\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_business))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total))]), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])]) : _c('p', [_vm._v("No orders yet")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 shopping-cart text-center"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "ordersModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Order No " + _vm._s(_vm.order.order_no))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_image,
        "height": "50",
        "width": "50"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.product_name) + " - " + _vm._s(item.order_delivery_city))])])
  })], 2), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Payment Mode: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Status: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), (_vm.order.order_delivery_not_set) ? _c('div', [_c('p', [_c('b', [_vm._v("Delivery Details:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_not_set))])]) : _c('div', [_c('p', [_c('b', [_vm._v("Delivery Location:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_city))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Address:  ")]), _vm._v(_vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _vm._m(2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "hidden-sm hidden-xs pull-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/sp-truck.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Order Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-100 pages-in chart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-boarding-centered"
  }, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "12px",
      "color": "#2d3a4b",
      "text-decoration": "underline"
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [_c('form', {
    staticClass: "form sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Email Address\r\n                                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Password\r\n                                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])]), _vm._v(" "), _vm._m(4)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 shopping-cart text-center"
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "row group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 0),
        expression: "index == 0"
      }]
    }, [_c('h5', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(group[0]) + "'s Sellpoint")]), _c('br'), _vm._v(" "), _vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "row cart-details"
      }, [_c('li', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_image,
          "alt": ""
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), (item.product_checked) ? _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }, [_c('del', [_vm._v("Selected")])]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Select Order")])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [_c('div', {}, [_c('label', [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [_c('div', {}, [_c('div', {
        staticClass: "quinty"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [_c('div', {}, [_c('label', [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [(item.can_remove) ? _c('div', {}, [_c('label', [_vm._v("Remove: ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "icon-close"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }), _vm._v(" "), _c('div', [(item.has_delivery) ? _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("\r\n                        This product has specific delivery options,\r\n                        "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "#0c0c0c",
          "font-weight": "bolder"
        },
        on: {
          "click": function($event) {
            _vm.toggleProductDelivery('item-delivery-options', index, index2)
          }
        }
      }, [_vm._v("SELECT")]), _vm._v(" "), (item.display_delivery_details) ? _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "#ff0000",
          "font-size": "10px"
        },
        on: {
          "click": function($event) {
            _vm.toggleProductDelivery('hide-item-delivery-options', index, index2)
          }
        }
      }, [_vm._v(" / HIDE")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.display_delivery_details) ? _c('div', _vm._l((group[2]), function(option) {
        return _c('div', {
          staticClass: "row"
        }, [(option.business_delivery_product == item.product_main_id) ? _c('span', [_c('label', [(item.product_checked) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.delivery_fee),
            expression: "delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_product_delivery_fee(index, option, index2)
            },
            "__c": function($event) {
              _vm.delivery_fee = option.business_delivery_option_id
            }
          }
        })]) : _vm._e(), _vm._v("\r\n                              " + _vm._s(option.business_delivery_option) + " - " + _vm._s(option.business_delivery_option_price) + "\r\n                            ")])]) : _vm._e()])
      })) : _vm._e()])])
    }), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', [(group[4]) ? _c('div', {
      staticClass: "pull-left coupons-sec"
    }, [_vm._m(5, true), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
      return _c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.coupon_code),
          expression: "coupon_code"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id,
          "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, coupon, coupon.discount_percentage)
          },
          "__c": function($event) {
            var $$a = _vm.coupon_code,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = coupon.discount_id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.coupon_code = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " - " + _vm._s(coupon.discount_percentage) + "% Off "), _c('b', [_vm._v("From " + _vm._s(coupon.discount_provider))])])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pull-right delivery-sec"
    }, [(group.products_without_delivery_details_count >= 1) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(group[0]))]), _vm._v(" Sellpoint Delivery")]), _vm._v(" "), (group[2] && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "14px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group[2]) ? _c('div', {
      staticStyle: {
        "height": "5em",
        "overflow": "auto"
      }
    }, _vm._l((group[2]), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.delivery_fee),
          expression: "delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v("\r\n                                " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                              ")])]) : _vm._e()])
    })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_vm._v("Total Orders from "), _c('b', [_vm._v(_vm._s(group[0]) + ":")]), _vm._v(" ₦" + _vm._s(group.total_order_amt))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', [_vm._v("Total: ₦" + _vm._s(group.total_order_amt + group.total_delivery_charge))])]) : _c('span', [_c('p', [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(7, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "14px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {
      staticClass: "row"
    }, [_vm._m(8, true)])])])], 2)])
  })), _vm._v(" "), (_vm.checked_out.length != 0) ? _c('div', {
    staticClass: "orders-panel pull-right",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('span', {
    staticClass: "col-sm-12"
  }, [_c('p', [_c('b', [_vm._v("Total Order: ")]), _vm._v("₦" + _vm._s(_vm.total_order_amt + _vm.total_delivery_fee))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/sp-truck.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('h1', {
    staticClass: "cart-title"
  }, [_vm._v("Buy Now - Process Your Orders")]), _vm._v(" "), _c('p', [_vm._v("Please select your Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-image text-center"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-frown-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "text-align": "center"
    }
  }, [_vm._v("Dont have an Account?"), _c('br'), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_c('u', [_vm._v("Create an Account ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "sp-wrap-cards"
  }, [_c('div', {
    staticClass: "sp-top-header padding-top-10 padding-bottom-10 padding-left-10",
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [_c('div', {
    staticClass: "sp-top-header-top"
  }, [((_vm.edit_mode && (_vm.visitor_url != ''))) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "5em",
      "height": "1em"
    },
    on: {
      "click": _vm.syncset
    }
  }, [_vm._v("Back to " + _vm._s(_vm.visitor_app))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-menu-left-bar"
  }, [_c('menu-left-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_vm._m(0), _vm._v(" "), (_vm.sellpoint.business_name != undefined) ? _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("| "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_group_id > 0) ? _c('div', [_c('a', {
    staticStyle: {
      "font-size": "10px",
      "color": "#b13504"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_market_group_username
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.sellpoint.business_market_group))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-search-menu hidden-xs"
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_data),
      expression: "search_data"
    }],
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    },
    domProps: {
      "value": (_vm.search_data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_data = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchProductsByBusiness
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-mobile-menu"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-wrap-card-full",
    staticStyle: {
      "padding": "0 0 0 0.7em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sp-wrap-card-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em",
      "margin-left": "-2em",
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "bottombar-panel",
    attrs: {
      "id": "mobileBottomBar"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closeMobileBottomBar
    }
  }, [_vm._v("X")]), _vm._v(" "), (_vm.bottombar_search) ? _c('div', [_c('div', {
    staticClass: "sp-search-menu",
    staticStyle: {
      "width": "85%",
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_data),
      expression: "search_data"
    }],
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    },
    domProps: {
      "value": (_vm.search_data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_data = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchProductsByBusiness
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.mobileBottomBarActions('display-search-bar', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Search")])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "-7px"
    },
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Timeline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _c('br'), _c('span', [_vm._v("Cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort"
  }), _c('br'), _c('span', [_vm._v("Sort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _c('br'), _c('span', [_vm._v("Chat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
}]}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopping-cart"
  }, [(_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "cart-ship-info register col-sm-10 contact_form"
  }, [_c('h6', [_vm._v("New Post")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Title\n                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_title),
      expression: "post.post_title"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Post\n                           "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_text),
      expression: "post.post_text"
    }],
    domProps: {
      "value": (_vm.post.post_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image / Video")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addPost
    }
  }, [_vm._v("Post")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em",
      "margin-right": "1.6em"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "edit-switch-bar",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Post")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.post.post_title))])])]), _vm._v(" "), _c('div', {}, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10",
    staticStyle: {
      "background": "#2d3a4b"
    }
  }, [(!_vm.edit_mode) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 pull-left",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('a', {
    attrs: {
      "href": _vm.sellpoint.business_username + '/p/' + _vm.post.post_url_name
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.post.post_ownername))]), _vm._v(" "), _vm._l((_vm.post.post_media), function(post_media) {
    return _c('div', {
      staticClass: "item-img"
    }, [(_vm.checkIfVideo(post_media.post_media)) ? _c('iframe', {
      attrs: {
        "width": "420",
        "height": "315",
        "src": post_media.post_media
      }
    }) : _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post_media.post_media,
        "alt": ""
      }
    })])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "item-owner"
  }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(_vm.post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.post.post_text))]), _vm._v(" "), _c('br'), _c('br')], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/p/' + post.post_url_name
      }
    }, [_c('p', [_vm._v(_vm._s(post.post_ownername))]), _vm._v(" "), _vm._l((post.post_media), function(post_media) {
      return _c('div', {
        staticClass: "item-img"
      }, [(_vm.checkIfVideo(post_media.post_media)) ? _c('iframe', {
        attrs: {
          "width": "420",
          "height": "315",
          "src": post_media.post_media
        }
      }) : _c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": post_media.post_media,
          "alt": ""
        }
      })])
    }), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "item-owner"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_text))]), _vm._v(" "), _c('br'), _c('br')], 2)])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card sp-p-main col-md-6",
    staticStyle: {
      "padding": "2em"
    }
  }, [_c('div', [(_vm.editPostPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Post")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Title\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_title),
      expression: "post.post_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Post\r\n                                        "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_text),
      expression: "post.post_text"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.post.post_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editPost
    }
  }, [_vm._v("Save Post")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right action-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-post', '')
      }
    }
  }, [_vm._v("Edit Post Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Post Title: ")]), _vm._v(_vm._s(_vm.post.post_title))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.post.post_text))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-post', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Post")]), _vm._v(" "), (_vm.removePostPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Post?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removePost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Post Pictures")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.post.post_media), function(pm) {
    return _c('div', {
      staticClass: "img-column"
    }, [(_vm.checkIfVideo(pm.post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.post_media && (pm.post_media != 'error'))) ? _c('img', {
      attrs: {
        "src": pm.post_media
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'posts', _vm.post.post_id)
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "light-gray-bg padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("These would interest you too")]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('div', [_c('div', {
      staticClass: "col-md-8 col-md-offset-2"
    }, [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/p/' + post.post_url_name
      }
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/' + post.post_url_name
      }
    }, [_vm._v(_vm._s(post.post_title))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_ownername))]), _vm._v(" "), (post.post_media && (post.post_media.length != 0)) ? _c('div', [(_vm.checkIfVideo(post.post_media[0].post_media)) ? _c('iframe', {
      attrs: {
        "width": "420",
        "height": "315",
        "src": post.post_media[0].post_media
      }
    }) : _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post.post_media[0].post_media,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('ul', {
      staticClass: "item-owner"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_text))]), _vm._v(" "), _c('br'), _c('br')])])])
  })], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
}]}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-top-header padding-top-10 padding-bottom-10 padding-left-10"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._m(1), _vm._v(" "), (_vm.sellpoint.business_name != undefined) ? _c('a', {
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("| "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-mobile-menu"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.edit_mode) ? _c('span', {}, [_c('h6', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Shop Information")]), _vm._v(" "), (_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spMessagesPanel', '')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#notificationsModal"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('', '')
      }
    }
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spOrdersPanel', '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Shop Settings")])])]) : _vm._e()]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-menu-left-bar"
  }, [_c('menu-left-bar')], 1)]), _vm._v(" "), _c('h1', [_vm._v("Dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "sp-shop-menu-section",
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row sp-shop-menu-horizontal"
  }, [_c('ul', {}, [(!_vm.edit_mode) ? _c('span', _vm._l((_vm.sellpoint.business_categories), function(cat, count) {
    return _c('li', [(count < 5) ? _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat.business_category_id)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 0) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("My Shop")])]) : _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("Shop "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content shop-dropdown-content",
    attrs: {
      "id": "shop-dropdown-content"
    }
  }, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat.business_category_id)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")])])
  }))]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spServicesPanel', '')
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spBlogPanel', '')
      }
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spGalleryPanel', '')
      }
    }
  }, [_vm._v("Gallery")])]), _vm._v(" "), (_vm.edit_mode) ? _c('span', {
    staticClass: "sp-specific-menu"
  }, [(_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spMessagesPanel', '')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spOrdersPanel', '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Shop Settings")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "hidden-lg hidden-md sp-action-display-menu",
    staticStyle: {
      "margin-left": "2em",
      "margin-right": "4em",
      "display": "none"
    },
    attrs: {
      "id": "product-action-display-menu"
    }
  }, [_c('ul', {}, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Search"
    },
    on: {
      "click": function($event) {
        _vm.showSectionById('searchSection')
      }
    }
  }, [_vm._v("Sort By "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content sort-dropdown-content",
    attrs: {
      "id": "sort-dropdown-content"
    }
  }, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Orders Made")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Discounted")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Pre-Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (Low to High)")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (High to Low)")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "filter"
    },
    on: {
      "click": function($event) {
        _vm.showSectionById('filterSection')
      }
    }
  }, [_vm._v("Filter Items")])])])])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "sp-body",
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-5 padding-bottom-100",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.addProductPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Shop")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('product-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addPostPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Sellpoint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-post-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addGalleryPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Sellpoint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-gallery-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addProductGalleryPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Sellpoint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-product-gallery-form')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-sm-3 sp-side",
    attrs: {
      "id": "spSidebar"
    }
  }, [_c('div', {
    staticClass: "shop-sidebar"
  }, [(_vm.can_edit) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "sp-sidebar-sort-filter"
  }, [_c('h5', {
    staticClass: "shop-tittle margin-bottom-10"
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Orders Made")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Discounted")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Pre-Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (Low to High)")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (High to Low)")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.edit_mode) ? _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("My Sellpoint Shop Categories")]) : _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("Take a pick")]), _vm._v(" "), (_vm.category.edit) ? _c('div', [_c('h6', [_vm._v("Edit Category")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category),
      expression: "category.business_category"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category = $event.target.value
      }
    }
  }), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_c('i', {
    staticClass: "icon-check"
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit-category', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_categories) ? _c('ul', {}, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', {
      staticStyle: {
        "padding": "5px",
        "border-bottom": "1px solid #d1d5db"
      }
    }, [_c('p', [_c('span', {
      staticClass: "a-lf"
    }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat.business_category_id)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")]), _vm._v(" "), (_vm.edit_mode) ? _c('span', [(cat.can_edit == 1) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.setComponent('edit-category', cat)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]) : _vm._e()]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "sp-add-new-category",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "color": "#363535"
    }
  }, [_vm._v("Add New Category > ")]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Select from related category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_category),
      expression: "category.new_category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "width": "245px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category.new_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct.sub_category_id
      }
    }, [_vm._v(_vm._s(ct.sub_category_name))])
  })], 2)]), _vm._v(" "), _c('b', [_vm._v("OR")]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_listed_category),
      expression: "category.new_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Category"
    },
    domProps: {
      "value": (_vm.category.new_listed_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.new_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px",
      "margin-top": "1em"
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Add Category")])])]) : _vm._e()]) : _c('div', [(_vm.edit_mode) ? _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("My Market Categories")]) : _vm._e(), _vm._v(" "), _c('ul', {}, _vm._l((_vm.sellpoint.business_market_categories), function(cat) {
    return _c('li', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('p', [_c('span', {
      staticClass: "a-lf"
    }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSellpointMarketProducts()
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")])]), _vm._v(" "), _c('ul', {}, _vm._l((cat.business_sub_categories), function(sub_cat) {
      return _c('li', {
        staticStyle: {
          "padding": "5px",
          "border-bottom": "1px solid #e5eaf0"
        }
      }, [_c('p', [_c('span', {
        staticClass: "a-lf"
      }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.getCategoryProducts(sub_cat.business_sub_category_id)
          }
        }
      }, [_vm._v(_vm._s(sub_cat.business_sub_category) + " ")])])])
    }))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card col-sm-8 sp-main",
    attrs: {
      "id": "spMain"
    }
  }, [(_vm.sellpoint.business_market_category_id == 2) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "create?create=new"
    }
  }, [_vm._v("Add New Sellpoint")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 3) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "create?create=add"
    }
  }, [_vm._v("Add New Business")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewAllProductsBanner) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('view-all-products', '')
      }
    }
  }, [_vm._v("\r\n                View all Products")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.spProductsPanel) ? _c('div', [(_vm.spMarketPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.market), function(sp) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      staticClass: "img-1 img-responsive",
      attrs: {
        "src": _vm.img_sellpoint_url + sp.business_brand_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-name"
    }, [_c('p', {
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_vm._v(_vm._s(sp.business_name))])])])])])])])
  })) : _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "item-display hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product', '')
      }
    }
  }, [_vm._v("Add New Product")])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row filter-sort-board",
    attrs: {
      "id": "filterSortBoard"
    }
  }, [_c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilterSortBoard()
      }
    }
  }, [_vm._v("Hide")]), _vm._v(" "), _c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.resetFilterSortOptions()
      }
    }
  }, [_vm._v("Reset Options")])]), _vm._v(" "), (_vm.price_filter_is_set) ? _c('div', {
    staticStyle: {
      "width": "45%",
      "padding-bottom": "1em",
      "margin-bottom": "6px",
      "border-bottom": "1px solid #f2f2f2"
    }
  }, [_c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Price")]), _vm._v(" "), _c('vue-slider', _vm._b({
    model: {
      value: (_vm.slider_type),
      callback: function($$v) {
        _vm.slider_type = $$v
      },
      expression: "slider_type"
    }
  }, 'vue-slider', _vm.slider_options, false)), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "8px"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("FILTER")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Sort Items by")]), _vm._v(" "), _c('div', {
    staticClass: "sort-row"
  }, [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Featured")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Orders")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Newest")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Discounted")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Pre-Orders")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price\r\n                                "), _vm._m(11), _vm._v(" "), _vm._m(12)])])])])]), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "hidden-md hidden-lg",
    staticStyle: {
      "margin-top": "1.3em"
    }
  }, [(_vm.sellpoint.business_market_category_id == 1) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product', '')
      }
    }
  }, [_vm._v("Add New Product")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row fixed-pan-03"
  }, [(_vm.products.length > 0) ? _c('div', {}, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.listView) ? _c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('market-view', '')
      }
    }
  }, [_vm._v("\r\n                        Switch to Market View")])]) : _vm._e(), _vm._v(" "), (_vm.marketView) ? _c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('list-view', '')
      }
    }
  }, [_vm._v("\r\n                        Switch to List View")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "showFilters",
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilterSortBoard()
      }
    }
  }, [_vm._v("Filter Items")])])])]) : _vm._e(), _vm._v(" "), (!_vm.products.length) ? _c('span', [_c('p', [_vm._v("No Products added yet")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:start",
      value: (_vm.mouseover),
      expression: "mouseover",
      arg: "start"
    }],
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [(_vm.listView) ? _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-6 sp-prd-col-wrap"
    }, [_c('div', {
      staticClass: "sp-prd-col"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "item"
      }, [(index2 == 0) ? _c('div', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [(product.product_images[0]) ? _c('div', {
        staticClass: "item-img sp-prd-list-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "img-2 sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-name"
      }, [_c('div', {
        staticClass: "sp-prd-name"
      }, [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_item_price))])])])]) : _vm._e()])
    }))])
  })) : _vm._e(), _vm._v(" "), (_vm.marketView) ? _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "shop-detail"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "row"
      }, [(index2 == 0) ? _c('div', {
        staticClass: "col-md-8 col-md-offset-2"
      }, [_c('h4', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "img-1",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('ul', {
        staticClass: "item-owner"
      }, [_c('li', [_vm._v("Tagged By :"), _c('span', [_vm._v(" " + _vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('li', [_vm._v("Category:"), _c('span', [_vm._v(" " + _vm._s(product.product_category_name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()])
    }))
  })) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.spBlogPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [(_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-post', '')
      }
    }
  }, [_vm._v("+ New Blog")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "shop-detail"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-2"
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/' + post.post_url_name
      }
    }, [_vm._v(_vm._s(post.post_title))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_ownername))]), _vm._v(" "), _vm._l((post.post_media), function(post_media) {
      return _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": post_media,
          "alt": ""
        }
      })])
    }), _vm._v(" "), _vm._m(14, true), _vm._v(" "), _c('ul', {
      staticClass: "item-owner"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_text))]), _vm._v(" "), _c('br'), _c('br')], 2)])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spServicesPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [_c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-6 sp-prd-col-wrap"
    }, [_c('div', {
      staticClass: "sp-prd-col"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "item"
      }, [(index2 == 0) ? _c('div', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_c('div', {
        staticClass: "item-img sp-prd-list-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "img-2 sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "item-name"
      }, [_c('div', {
        staticClass: "sp-prd-name"
      }, [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', {
        staticClass: "sp-prd-descr"
      }, [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.product_category_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_item_price))])])]) : _vm._e()])
    }))])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spGalleryPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-gallery', '')
      }
    }
  }, [_vm._v("+ New Lookbook")])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-gallery', '')
      }
    }
  }, [_vm._v("+ New Product Lookbook")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.galleria), function(gallery) {
    return _c('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_c('div', {}, [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/g/' + gallery.gallery_posts_group_url_name
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-img sp-prd-list-img",
      staticStyle: {
        "height": "220px"
      }
    }, [_c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0],
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img-2 sp-prd-img",
      attrs: {
        "src": _vm.img_product_url + _vm.product_item.product_item_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spProfilePanel) ? _c('div', {
    attrs: {
      "id": "sp-profile"
    }
  }, [_c('div', {
    staticClass: "history-block padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-9 sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-5 sp-pl0"
  }, [(_vm.details.tagline_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Enter Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('tagline')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v(" submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_tagline) ? _c('span', [_c('h2', [_vm._v(_vm._s(_vm.sellpoint.business_tagline) + "\r\n                                "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-tagline', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e()])]) : _c('span', [_c('h2', [_vm._v("Connect with me, through my Sellpoint\r\n                                "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-tagline', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-50"
  }, [_c('img', {
    staticClass: "img_responsive",
    attrs: {
      "src": _vm.img_sellpoint_url + _vm.sellpoint.business_brand_image,
      "width": "250",
      "height": "250"
    }
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Change Brand Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_brand_image')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 margin-top-50 sp-pl0"
  }, [(_vm.details.profile_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Your Business Profile")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('profile')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_profile) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_profile) + "\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-profile', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("Making Business memories as exciting as fireworks display, on a New Year's Sky.\r\n                                    Having an online presence is crucial as it helps me connect with my customers irrespective of their location\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-profile', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sp-profile-services"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h6', [_vm._v("My Services")]), _vm._v(" "), (_vm.edit_mode) ? _c('ul', _vm._l((_vm.sellpoint.business_services), function(service) {
    return _c('li', [(service.edit_set) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.business_service),
        expression: "service.business_service"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (service.business_service)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          service.business_service = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      attrs: {
        "type": "submit"
      },
      on: {
        "click": _vm.editService
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(service.business_service) + " "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-service', service)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })])])])
  })) : _c('ul', _vm._l((_vm.sellpoint.business_services), function(service) {
    return _c('li', [_c('p', [_vm._v(_vm._s(service.business_service))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.service_name),
      expression: "service.service_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter a service"
    },
    domProps: {
      "value": (_vm.service.service_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.service_name = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addService
    }
  }, [_vm._v("Add a Service")])]) : _vm._e()])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spContactPanel) ? _c('div', {
    attrs: {
      "id": "sp-contact"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block  sp-pl0"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form  sp-pl0"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12 sp-pl0",
    staticStyle: {
      "border": "1.5px rgb(16, 5, 82) solid",
      "padding": "4em",
      "min-height": "30em"
    }
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Contact Information")]), _vm._v(" "), (_vm.details.contact_info_edit) ? _c('div', {
    staticClass: "contact_form sp-pl0"
  }, [(_vm.edit_mode) ? _c('ul', {}, [_c('li', [_c('label', [_vm._v("Address\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Email(s)\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Phone(s)\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('contact_info')
      }
    }
  }, [_c('i', {
    staticClass: "icon-file"
  }), _vm._v("Save")]), _vm._v("\r\n                                        \r\n                                  "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]) : _c('div', [(_vm.sellpoint.business_address) ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]) : _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_emails) ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]) : _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_phones) ? _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]) : _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.edit_mode) ? _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-contact-info', '')
      }
    }
  }, [_vm._v("Edit Details")]) : _vm._e()])]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "col-sm-4 contact_form"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("SEND A MESSAGE")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *NAME ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.name),
      expression: "contact_form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *EMAIL\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.email),
      expression: "contact_form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR MESSAGE"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.message),
      expression: "contact_form.message"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.contact_form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-left no-margin",
    on: {
      "click": _vm.sendBusinessContactForm
    }
  }, [_vm._v("SEND MESSAGE")])])])])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spMessagesPanel) ? _c('div', {
    attrs: {
      "id": "sp-messages"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12",
    staticStyle: {
      "border": "1.5px rgb(16, 5, 82) solid",
      "padding": "4em",
      "min-height": "30em"
    }
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Your Messages")]), _vm._v(" "), (_vm.details.contact_info_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', [_c('label', [_vm._v("Address\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Email(s)\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Phone(s)\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('contact_info')
      }
    }
  }, [_c('i', {
    staticClass: "icon-file"
  }), _vm._v("Save")]), _vm._v("\r\n                                      \r\n                                "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]) : _c('div', [(_vm.sellpoint.business_address) ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]) : _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_emails) ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]) : _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_phones) ? _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]) : _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v("No details yet")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-contact-info', '')
      }
    }
  }, [_vm._v("Edit Details")])])]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "col-sm-4 contact_form"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("SEND A MESSAGE")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *NAME ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.name),
      expression: "contact_form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *EMAIL\r\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.email),
      expression: "contact_form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR MESSAGE"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.message),
      expression: "contact_form.message"
    }],
    domProps: {
      "value": (_vm.contact_form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-left no-margin",
    on: {
      "click": _vm.sendBusinessContactForm
    }
  }, [_vm._v("SEND MESSAGE")])])])])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spOrdersPanel) ? _c('div', {
    attrs: {
      "id": "sp-orders"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Orders on " + _vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "overflow": "scroll"
    }
  }, [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Order From")]), _vm._v(" "), _c('th', [_vm._v("Order Total")]), _vm._v(" "), _c('th', [_vm._v("Payment Mode")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#2d3a4b"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_no))])]), _c('br'), _vm._v("\r\n                                    " + _vm._s(order.order_date) + "\r\n                                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_business))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spDeliveryPanel) ? _c('div', {
    attrs: {
      "id": "sp-delivery"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block .sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-8 sp-pl0"
  }, [(_vm.edit_mode) ? _c('h6', [_vm._v("Your Sellpoint's Delivery Information")]) : _c('h6', [_vm._v("General Delivery Information")]), _vm._v(" "), (_vm.details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information) + "\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-delivery-information', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                      Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                      partners to make transactions seamless.\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-delivery-information', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sp-profile-services"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [_c('div', [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.editDeliveryInformation && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('li', [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('reset-delivery-information', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                                              " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                                              "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-delivery-information', '')
      }
    }
  }, [_vm._v("Add New Delivery Information")]), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.addDeliveryInformation) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('li', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-delivery-information', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]) : _c('div', [_c('ul', _vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('li', [_c('p', [_vm._v(_vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price))])])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spSettingsPanel) ? _c('div', {
    attrs: {
      "id": "sp-contact"
    }
  }, [_c('div', {
    staticClass: "history-block padding-bottom-100 col-sm-9 sp-pl0"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-12 sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Bank Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), (_vm.sellpoint.business_bank_details) ? _c('div', [(_vm.sellpoint.business_bank_details.length == 0 || _vm.set_bank_details) ? _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_name),
      expression: "sellpoint.business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_name),
      expression: "sellpoint.business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_number),
      expression: "sellpoint.business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("your details are securley saved")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-bank-details', '')
      }
    }
  }, [_vm._v("Edit Bank Details")])])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\r\n                              be paid by you as you set your product, or by your customers as they buy. \r\n                              Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set your Sellpoint Filters")]), _vm._v(" "), _c('p', [_vm._v("This helps your customers to filter your products and services based on parameters like: categories, prices, colors, etc.")]), _vm._v(" "), (_vm.sellpoint.business_filters) ? _c('div', [_c('div', _vm._l((_vm.sellpoint.business_filters), function(bfilter) {
    return _c('p', [_vm._v("\r\n                                  " + _vm._s(bfilter.business_filter_name) + " "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "padding": "0 3px 0 5px",
        "border-radius": "50%"
      },
      on: {
        "click": function($event) {
          _vm.removeFilterOption(bfilter.business_filter_id)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_vm._l((_vm.filters), function(filter) {
    return _c('label', {
      staticStyle: {
        "margin": "3px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_filters),
        expression: "selected_filters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": filter.filter_id,
        "checked": Array.isArray(_vm.selected_filters) ? _vm._i(_vm.selected_filters, filter.filter_id) > -1 : (_vm.selected_filters)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected_filters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter.filter_id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected_filters = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected_filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_filters = $$c
          }
        }
      }
    }), _vm._v(_vm._s(filter.filter_name) + "\r\n                                ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.setFilterOptions
    }
  }, [_vm._v("Save Filter Options")])], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                              You can set individual Product Discounts on thier product pages.\r\n                            ")]), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('span', [(_vm.setDiscount) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]) : _c('span', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an Ongoing discount, You can only set coupons. if you want to discontinue\r\n                                running discount, click on De-Activate and then set a new one")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Coupon")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active != 1) ? _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-discount-coupon', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(17)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-discount-coupon', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.viewDiscounts && _vm.sellpoint.business_discounts_coupons) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), (dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                      Edit Coupon")]), _vm._v("    \r\n                                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                      Deactivate Coupon")])]) : _vm._e(), _vm._v(" "), _c('hr')])
  })], 2) : _vm._e()])])])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "notificationsModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(notification.notification_date))]), _c('br'), _vm._v("\r\n                  " + _vm._s(notification.notification_message))]), _vm._v(" "), _c('hr')])
  })), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "menuModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loggedIn) ? _c('ul', {
    staticClass: "sp-menu-list"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "href": "account"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name) + ". view account")])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24)]) : _c('ul', {
    staticClass: "sp-menu-list"
  }, [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Sellpoint Links")]), _vm._v(" "), _c('ul', {
    staticClass: "shop-cate"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("My Portfolio")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Me")])]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 0) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("My Shop")])]) : _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("Shop")])]), _vm._v(" "), (_vm.edit_mode) ? _c('span', [(_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Settings")])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "-7px"
    },
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left sp-search-menu"
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#notificationsModal"
    }
  }, [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('span', {
    staticClass: "product-num"
  }, [_vm._v("Showing your products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "title": "High to Low"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": "-9.2px"
    }
  }, [_c('a', {
    attrs: {
      "title": "Low to High"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" 10% "), _c('span', [_vm._v("OFF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form col-md-6"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                  If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                  button.\r\n                                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "border-bottom-color": "transparent",
      "margin-bottom": "2em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "3em"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_vm._v("View Cart "), _c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Log Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Register")])])
}]}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopping-cart"
  }, [_c('hr'), _vm._v(" "), (_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "cart-ship-info register col-sm-10  contact_form"
  }, [(!_vm.product_subscription_active) ? _c('div', [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _c('form', [_c('ul', {}, [_c('li', {
    staticClass: "col-sm-6 product-type"
  }, [_c('label', [_vm._v(" Product\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6 product-type"
  }, [_c('label', [_vm._v(" Service\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  })])]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.is_product_service) + " Information")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-3.6em"
    }
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Name\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\n                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\n                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\n                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Description\n                                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" *Price\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" *Weight(Kg)\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" *Quantity\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Image / Video")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('p', {
    staticClass: "p-tiny-descr"
  }, [_vm._v("\n                                    Continue to set up product and add different product variant like colours and sizes\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.is_product_service == 'service') ? _c('p', {
    staticClass: "p-tiny-descr"
  }, [_vm._v("\n                                    Continue to set up "), _c('b', [_vm._v("service")]), _vm._v(" and add different services details like, service packages, subscriptions and plans\n                                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Continue")])])])])])]) : _c('div', [_c('h6', [_vm._v("Add Subscription Plan")]), _vm._v(" "), _c('form', [_c('ul', {}, [_c('div', {
    staticStyle: {
      "margin-top": "-3.6em"
    }
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Plan Name\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Plan Description Name\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_descr_name),
      expression: "product.product_descr_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_descr_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_descr_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Plan Details")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription_list[0]),
      expression: "subscription_list[0]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subscription_list[0])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription_list, 0, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription_list[1]),
      expression: "subscription_list[1]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subscription_list[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription_list, 1, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription_list[2]),
      expression: "subscription_list[2]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subscription_list[2])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription_list, 2, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription_list[3]),
      expression: "subscription_list[3]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subscription_list[3])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription_list, 3, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription_list[4]),
      expression: "subscription_list[4]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subscription_list[4])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription_list, 4, $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription_list[5]),
      expression: "subscription_list[5]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subscription_list[5])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription_list, 5, $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.product_app_subscription_active) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Plan Limits")]), _vm._v(" "), _c('label', [_vm._v(" Products Limit\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_service_app_products_limit),
      expression: "product.product_service_app_products_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_service_app_products_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_service_app_products_limit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v(" Product Items Limit\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_service_app_product_items_limit),
      expression: "product.product_service_app_product_items_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_service_app_product_items_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_service_app_product_items_limit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v(" Posts Limit\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_service_app_posts_limit),
      expression: "product.product_service_app_posts_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_service_app_posts_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_service_app_posts_limit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v(" Gallery Lookbook Limit\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_service_app_gallery_limit),
      expression: "product.product_service_app_gallery_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_service_app_gallery_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_service_app_gallery_limit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v(" Gallery Lookbook Posts Limit\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_service_app_gallery_posts_limit),
      expression: "product.product_service_app_gallery_posts_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_service_app_gallery_posts_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_service_app_gallery_posts_limit = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" *Price\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Service Tag\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "col-md-6"
  }, [_vm._v(" *Subscription Duration\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_duration),
      expression: "product.product_item_service_duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_duration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_duration),
      expression: "service_duration"
    }],
    staticClass: "col-md-6 form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service_duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": " years"
    }
  }, [_vm._v("year(s)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": " months"
    }
  }, [_vm._v("month(s)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": " days"
    }
  }, [_vm._v("day(s)")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('p', {
    staticClass: "p-tiny-descr"
  }, [_vm._v("\n                                    Continue to set up product and add different product variant like colours and sizes\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.is_product_service == 'service') ? _c('p', {
    staticClass: "p-tiny-descr"
  }, [_vm._v("\n                                    Continue to set up "), _c('b', [_vm._v("service")]), _vm._v(" and add different services details like, service packages, subscriptions and plans\n                                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductSubscription
    }
  }, [_vm._v("Continue")])])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoints), function(sp) {
    return _c('li', {
      key: sp.business_id,
      staticClass: "col-md-6"
    }, [_c('article', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "static/assets/images/new-ar-img-1.jpg",
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sp-business-card"
    }, [_c('p', [_vm._v(_vm._s(sp.business_name))]), _vm._v(" "), _c('p', [_vm._v("Block 1B 2-face street AddisA Laos")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-small btn-round",
      attrs: {
        "href": 'points?pg=' + sp.business_url_name
      }
    }, [_vm._v("View my sellpoint")])])])])
  }))
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-150 padding-bottom-150"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "new-arrival-list"
  }, [_c('sellpoint-list'), _vm._v(" "), _vm._m(4)], 1)])])]), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar ownmenu"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#nav-open-btn",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "nav-open-btn"
    }
  }, [_c('ul', {
    staticClass: "nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [_c('ul', {
    staticClass: "navbar-right"
  }, [_c('li', {
    staticClass: "dropdown user-acc"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('h6', [_vm._v("HELLO! Jhon Smith")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("MY CART")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ACCOUNT INFO")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LOG OUT")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub-bnr",
    attrs: {
      "data-stellar-background-ratio": "0.5"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', [_vm._v("230 Sellpoints")]), _vm._v(" "), _c('p', [_vm._v("Connect Businesses through their Sellpoints")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Start")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("popular sellpoints")]), _vm._v(" "), _c('span', [_vm._v("Connect with top popular sellpoints, see what they are selling and other offers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center margin-top-50"
  }, [_c('a', {
    staticClass: "btn btn-small btn-round",
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" SHOW MORE...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "about-footer"
  }, [_c('img', {
    staticClass: "margin-bottom-30",
    attrs: {
      "src": "static/assets/images/logo-foot.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Where you sell.")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-call-end"
  }), _vm._v(" 080000000000")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtosell@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtobuy@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" info@sellpoint.ng")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOUR")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Sellpoints")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Find a Sellpoint")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Products")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Services")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Privacy Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Media ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("INFO")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to sell")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to buy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Support")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Career")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Shipping Options")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Knowledge Base")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOP LIST")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Health")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Community")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Events")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rights"
  }, [_c('p', [_vm._v("©  2015 sellpoint All right reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])])
}]}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopping-cart"
  }, [_c('hr'), _vm._v(" "), (_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "cart-ship-info register col-sm-10 contact_form"
  }, [_c('h6', [_vm._v("New Gallery")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Name\n                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Gallery Name"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Description\n                           "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('h6', [_vm._v("Add a Post to Gallery")]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Caption\n                               "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Details\n                               "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image / Video")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("Add")])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "sp-wrap-max-inner"
  }, [_c('section', {
    staticClass: "sp-boarding-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-boarding-centered"
  }, [_vm._m(0), _vm._v(" "), (_vm.onboarding) ? _c('div', {
    staticClass: "col-md-12 onboarding"
  }, [_c('div', {}, [_c('div', {
    staticClass: "sp-pan-inner-block-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sp-pan-inner-block"
  }, [_c('div', {
    staticClass: "sp-onboarding-block"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setupAccount('sp')
      }
    }
  }, [_vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-pan-inner-block"
  }, [_c('div', {
    staticClass: "sp-onboarding-block"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setupAccount('bp')
      }
    }
  }, [_vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.sp_set) ? _c('div', {
    staticClass: "sp-boarding-full-wrap"
  }, [(_vm.sp_set_layout) ? _c('div', {}, [_c('div', {
    staticClass: "sp-pan-inner-block",
    staticStyle: {
      "padding": "2em"
    }
  }, [_c('h6', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("How would like your Sellpoint to look like?")]), _vm._v(" "), _c('div', {
    staticClass: "sp-pan-interests"
  }, [_c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(1)
      }
    }
  }, [_c('b', [_vm._v("Shop")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display my products and services)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(2)
      }
    }
  }, [_c('b', [_vm._v("Services")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display services I offer)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(3)
      }
    }
  }, [_c('b', [_vm._v("Gallery")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display my events and colections)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(4)
      }
    }
  }, [_c('b', [_vm._v("Blog")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display my posts and stories)")])])])])])]) : _c('div', [_c('div', {}, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.add_sellpoint) ? _c('div', [_c('h6', [_vm._v("Add New Sellpoint")]), _vm._v(" "), (!_vm.add_business) ? _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Add an Existing Sellpoint")]), _vm._v(" "), _c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Username "), (!_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addExistingSellpoint
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('br'), _c('br')]) : _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Select an Existing Sellpoint")]), _vm._v(" "), _c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_user_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoints), function(sellpoint) {
    return _c('option', {
      domProps: {
        "value": sellpoint.business_username
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addSelectedExistingSellpoint
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Or Add A New Sellpoint")]), _vm._v(" "), _c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Or Select Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  }))]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewSellpoint
    }
  }, [_vm._v("Add New Sellpoint")])])])])]) : _c('div', [_c('h6', [_vm._v("Create Sellpoint")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.group_isset) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Sellpoint Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.market_category),
      expression: "business.market_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.market_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.market_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.mk_category_id
      }
    }, [_vm._v(_vm._s(category.mk_category_name))])
  }))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.business.business_view_layout == 2) ? _c('div', [_c('li', [_c('label', [_vm._v(" Business Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  }))])]) : _c('div', [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createSellpoint
    }
  }, [_vm._v("Create")])])])])])])])])])]), _vm._v(" "), (!_vm.not_onboarding) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelSetupAccount
    }
  }, [_vm._v(" << Back")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bp_set) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), _c('div', [_c('h6', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Setting up your Buypoint ...")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("What are you interested in?")]), _vm._v(" "), _c('div', {
    staticClass: "bp-interest-block"
  }, [_c('ul', _vm._l((_vm.categories), function(category) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.bp_interests),
        expression: "bp_interests"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": category.category_id,
        "checked": Array.isArray(_vm.bp_interests) ? _vm._i(_vm.bp_interests, category.category_id) > -1 : (_vm.bp_interests)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.bp_interests,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = category.category_id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.bp_interests = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.bp_interests = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.bp_interests = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(category.category_name) + "\r\n                                ")])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createBuypoint
    }
  }, [_vm._v("Proceed")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelSetupAccount
    }
  }, [_vm._v(" << Back")])])])])])])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(6)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-image text-center"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/logo-w.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-pan-inner-block"
  }, [_c('div', {
    staticClass: "sp-onboarding-block"
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Which would like to do first?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("You can always set up the remaining accounts anytime")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Setup a Sellpoint Seller Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Setup a Buypoint Buyer Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-footer-2"
  }, [_c('div', {
    staticClass: "foot-links"
  }, [_c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("How to use")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("©  2015 Sellpoint. All rights reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])
}]}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route",
    attrs: {
      "id": "wrapRoute"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-fixed-menu",
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('ul', {}, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em"
    },
    attrs: {
      "id": "content"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "edit-switch-bar",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Product")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), (_vm.new_added) ? _c('div', [_c('p', {
    staticClass: "new-added"
  }, [_vm._v("You have added this product, you can edit details and add more pictures")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [(!_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h4', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "images-slider img-main-frame"
  }, [(_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error') ? _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', {
    staticClass: "sp-prd-intro-block"
  }, [_c('h4', {
    staticClass: "hidden-sm hidden-xs"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Category: "), _c('span', [_c('b', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hozontal-flat-block"
  }, [_c('p', {
    staticClass: "pull-left"
  }, [_vm._v("reviews")]), _vm._v(" "), _c('p', {
    staticClass: "pull-right"
  }, [_vm._v("@"), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_business_ownername))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-attr-block"
  }, [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [(_vm.product_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_weight) + " (Kg)")])])]), _vm._v(" "), (((_vm.product.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "prd-color-block"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "product-item-group"
    }, [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', {}, [_c('div', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (((_vm.product_item_group.product_items) && (_vm.product_item_group.product_items.length != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [(((_vm.product.product_set_items != 0) && (_vm.product.product_set_items_params_check != 0))) ? _c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('div', {
    staticClass: "prd-color-block"
  }, _vm._l((_vm.product_item_group.product_items), function(pt) {
    return _c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [_c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.product_item.product_item_total_discount != 0) ? _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" \r\n                        " + _vm._s(_vm.product_item.product_item_total_discount) + "% "), _c('span', [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "some-info"
  }, [(!_vm.edit_mode) ? _c('div', [(_vm.is_product_in_cart) ? _c('div', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                              "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "102px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])]), _vm._v(" "), (_vm.product_item.product_item_quantity > 0) ? _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('hr'), _vm._v(" "), (_vm.data_cart_message) ? _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.data_cart_message))]) : _vm._e(), _vm._v(" "), (!_vm.product_is_ready_to_cart) ? _c('div', [_c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Buy Now")])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Add to Cart")])])]) : _c('div', [_c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('product-cta-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1)])]) : _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#ff0000"
    }
  }, [_vm._v("This Item is out of Stock")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner-info"
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-xs-8"
  }, [_c('div', {
    staticClass: "tiny-notice"
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                  Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                  partners to make transactions seamless.\r\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-md-12 col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list",
    staticStyle: {
      "display": "none"
    }
  }, [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                                    ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                                      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                                    "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                        ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                      " + _vm._s(delivery.business_delivery_option_price) + "\r\n                                    ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-xs linky",
    staticStyle: {
      "cursor": "pointer",
      "padding": "10px 30px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Copy Link\r\n                              ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Product Pictures")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', [(_vm.editProductPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right action-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Product Name: ")]), _vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Category: ")]), _c('span', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product.product_item_groups.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Different Colors, Sizes, Plans Subscriptions ..etc")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('p', {
      staticClass: "pull-left",
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      staticClass: "btn v-tiny-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-item_group', pg)
        }
      }
    }, [_c('i', {
      staticClass: "icon-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('remove-product-item_group', pg)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    }), _vm._v(" Delete")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [(_vm.editProductItemGroupPanel && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12 contact_form",
      attrs: {
        "id": "editProductItem"
      }
    }, [_c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', [_c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v("Name\r\n                                          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "80px",
          "width": "100px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn"
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])])]), _vm._v(" "), _c('li', {
      staticClass: "col-md-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn col-md-4",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn col-md-4",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "icon-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.removeItemGroupPanel && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [(_vm.product.product_service == 'P') ? _c('span', [_vm._v("Sizes in this Colour:")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Service Packages:")]) : _vm._e()]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P') ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-edit-product-item', pt)
          }
        }
      }, [_c('i', {
        staticClass: "icon-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('remove-product-item', pt)
          }
        }
      }, [_c('i', {
        staticClass: "icon-trash"
      })])]) : _vm._e()]), _vm._v(" "), (_vm.editProductItemPanel && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12 contact_form",
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('ul', {
        staticClass: "row"
      }, [_c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *"), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Product Item Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Product Item tYPE")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Service Tag\r\n                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Price\r\n                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                              "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                                  "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "btn col-md-4",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn col-md-4",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "icon-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.removeItemPanel && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs",
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    })], 2), _vm._v(" "), _c('hr')])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {}, [(_vm.product.product_service == 'P') ? _c('p', [_vm._v("add other variations like colors, sizes etc")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('p', [_vm._v("add other variations like the Service package, subscriptions and plans etc")]) : _vm._e(), _vm._v(" "), (!_vm.addProductItemPanel) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-item', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [_c('button', {
    staticClass: "btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('product-item-form')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-product', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]), _vm._v(" "), (_vm.removeProductPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "specific-detail-cards padding-top-100 padding-bottom-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [(_vm.edit_mode) ? _c('div', [_c('h6', [_vm._v("ITEM DISCOUNTS")]), _vm._v(" "), _c('div', [(_vm.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _c('div', [_vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_status_id == 5) ? _c('div', [(dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]), _vm._v(" "), (dc.discount_product_item != _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), (dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), _vm._v(" "), _c('hr')]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("You don't have an active discount")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-discount', '')
        }
      }
    }, [_vm._v("Set New Discount Or Coupon")])])])
  }), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have an active discount")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")])])], 2)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.details.edit_product_delivery) ? _c('div', {
    staticClass: "contact-form"
  }, [_c('li', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places")]), _vm._v(" "), _c('p', [(_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product-delivery', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                          Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                          partners to make transactions seamless.\r\n                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Product Charge is not on each Quantiy of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Product Charge is on each Quantiy of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [_c('div', [_vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                            "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })]), _vm._v(" "), (_vm.editDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.delivery_option) + "\r\n                                  "), _c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(_vm.delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.city),
        expression: "delivery_option.city"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(_vm.delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_business_delivery_options.length != 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _c('br'), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                              "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                  ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                " + _vm._s(delivery.business_delivery_option_price) + "\r\n                              ")]), _vm._v(" "), (_vm.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [(_vm.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-delivery-option', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', [_vm._v("You have not set your Business Delivery Locations")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px",
      "display": "none"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-delivery-option', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Add Product Delivery Location")]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), (_vm.addDeliveryInformation) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0",
      "display": "none"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('li', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn col-sm-4",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-sm-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("View Shipping Cost for different Locations")]), _vm._v(" "), _c('div', [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                            ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', {
    staticClass: "inner-info"
  }, [_c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("Copy Product Link and Share Anywhere\r\n                          ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row product-details-section",
    attrs: {
      "id": "productDetails"
    }
  }, [_c('div', {
    staticClass: "card item-decribe"
  }, [_c('ul', {
    staticClass: "nav nav-tabs animate fadeInUp"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("PRODUCT DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-information', '')
      }
    }
  }, [_vm._v("MORE INFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content animate fadeInUp details-box"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product_details_reviews) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [(_vm.product.product_reviews) ? _c('h6', [_vm._v(_vm._s(_vm.product.product_reviews.length) + " COMMENTS AND REVIEWS")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review) {
    return _c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": _vm.img_user_url + review.product_reviewed_by_image,
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h6', [_vm._v(_vm._s(review.product_reviewed_by)), _c('span', {
      staticClass: "pull-right"
    })]), _vm._v(" "), _c('p', {
      staticClass: "font-playfair"
    }, [_vm._v(_vm._s(review.product_review))]), _vm._v(" "), _c('h6', [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(review.product_review_date))])])])])
  }), _vm._v(" "), (!_vm.edit_mode) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("ADD COMMENT/REVIEW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You must have used this product to wrie a review.")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR REVIEW\r\n                                    "), _c('span', {
    staticClass: "pull-right"
  }, [_c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "bo",
      "id": "bo"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "bo")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "bo"
      }
    }
  }), _vm._v("Business Owner\r\n                                        ")]), _vm._v(" "), (!_vm.loggedIn) ? _c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "buyer",
      "id": "buyer"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "buyer")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "buyer"
      }
    }
  }), _vm._v("Buyer\r\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviews.review),
      expression: "reviews.review"
    }],
    domProps: {
      "value": (_vm.reviews.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviews.review = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-right no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductReview
    }
  }, [_vm._v("POST")])])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_information) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_vm._l((_vm.product.product_information), function(info) {
    return _c('div', {}, [(info.product_info_type == 'image') ? _c('div', [_c('p', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.img_product_url + info.product_info_detail,
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (info.product_info_type == 'text') ? _c('div', [_c('p', [_vm._v(_vm._s(info.product_info_detail))]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.information.product_info_detail),
      expression: "information.product_info_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product information"
    },
    domProps: {
      "value": (_vm.information.product_info_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.information.product_info_detail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductInformation
    }
  }, [_vm._v("Add to Product Information")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add an Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'product_information', _vm.product.product_id)
      }
    }
  })])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_descr) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('h6', [_vm._v("MORE DETAILS")]), _vm._v(" "), _c('ul', _vm._l((_vm.product.product_details), function(details) {
    return _c('li', [(_vm.edit_mode) ? _c('div', [(details.edit_product_detail) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (details.product_detail),
        expression: "details.product_detail"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (details.product_detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          details.product_detail = $event.target.value
        }
      }
    }), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": _vm.editProductDetail
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(details.product_detail) + "\r\n                                "), (_vm.edit_mode) ? _c('span', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-detail', details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductDetail(details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    })])]) : _vm._e()])]) : _c('p', [_vm._v(_vm._s(details.product_detail))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.new_product_detail),
      expression: "details.new_product_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product detail"
    },
    domProps: {
      "value": (_vm.details.new_product_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.new_product_detail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductDetail
    }
  }, [_vm._v("Add to Details")])])]) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "light-gray-bg padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "papular-block"
  }, _vm._l((_vm.other_products), function(o_product) {
    return _c('div', {
      staticClass: "shop-detail prd-market-block"
    }, [(_vm.product.product_id != o_product.product_id) ? _c('div', _vm._l((o_product.product_items), function(o_product_item, index2) {
      return _c('div', {
        staticClass: "row"
      }, [(index2 == 0) ? _c('div', {
        staticClass: "col-md-8 col-md-offset-2"
      }, [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_c('h4', [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_vm._v(_vm._s(o_product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(o_product_item.product_item_price))]), _vm._v(" "), _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "sp-prd-img img-1",
        attrs: {
          "src": _vm.img_product_url + o_product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('ul', {
        staticClass: "item-owner"
      }, [_c('li', [_vm._v("Category:"), _c('span', [_vm._v(" " + _vm._s(o_product.product_category_name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(o_product.product_description))])])]) : _vm._e()])
    })) : _vm._e()])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Groups/Types: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-xs-2"
  }, [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-md-2 col-xs-12"
  }, [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                              If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                              button.\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "stars"
  }, [_c('span', [_vm._v("YOUR RATING")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("I ALSO HAVE THESE")]), _vm._v(" "), _c('span', [_vm._v("Check out other products found in my sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" 10% "), _c('span', [_vm._v("OFF")])])
}]}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "menunavleftbar ownmenu"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content"
  }, [_c('li', [_c('h6', [_vm._v("Hello! " + _vm._s(_vm.user))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]) : _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log In")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/contact"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_vm._v("My Cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log Out")])])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "item-display"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("\r\n            bb" + _vm._s(_vm.ajk) + "bb---------\r\n            "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('a', {
      attrs: {
        "href": 'products?search=' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "item-name"
    }, [_c('a', {
      attrs: {
        "href": "#."
      }
    }, [_vm._v(_vm._s(product.product_name))]), _vm._v(" "), _c('p', [_vm._v("It's " + _vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product.product_price))])])])])
  }))])])]), _vm._v(" "), _vm._m(6)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar ownmenu"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#nav-open-btn",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "nav-open-btn"
    }
  }, [_c('ul', {
    staticClass: "nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [_c('ul', {
    staticClass: "navbar-right"
  }, [_c('li', {
    staticClass: "dropdown user-acc"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('h6', [_vm._v("HELLO! Jhon Smith")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("MY CART")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ACCOUNT INFO")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LOG OUT")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub-bnr",
    attrs: {
      "data-stellar-background-ratio": "0.5"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', [_vm._v("230 Sellpoints")]), _vm._v(" "), _c('p', [_vm._v("Connect Businesses through their Sellpoints")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Start")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('span', {
    staticClass: "product-num"
  }, [_vm._v("Showing 1 - 10 of 30 products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('select', {
    staticClass: "selectpicker"
  }, [_c('option', [_vm._v("Short By")]), _vm._v(" "), _c('option', [_vm._v("Short By")]), _vm._v(" "), _c('option', [_vm._v("Short By")])]), _vm._v(" "), _c('select', {
    staticClass: "selectpicker"
  }, [_c('option', [_vm._v("Filter By")]), _vm._v(" "), _c('option', [_vm._v("Short By")]), _vm._v(" "), _c('option', [_vm._v("Short By")])]), _vm._v(" "), _c('a', {
    staticClass: "grid-style",
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-grid"
  })]), _vm._v(" "), _c('a', {
    staticClass: "list-style",
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-list"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-img"
  }, [_c('img', {
    staticClass: "img-1",
    attrs: {
      "src": "static/assets/images/product-2-1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-2",
    attrs: {
      "src": "static/assets/images/product-2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "inn"
  }, [_c('a', {
    attrs: {
      "href": "static/assets/images/product-2-1.jpg",
      "data-lighter": ""
    }
  }, [_c('i', {
    staticClass: "icon-magnifier"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-basket"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#."
    }
  }, [_c('i', {
    staticClass: "icon-heart"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "about-footer"
  }, [_c('img', {
    staticClass: "margin-bottom-30",
    attrs: {
      "src": "static/assets/images/logo-foot.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Where you sell.")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-call-end"
  }), _vm._v(" 080000000000")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtosell@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtobuy@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" info@sellpoint.ng")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOUR")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Sellpoints")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Find a Sellpoint")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Products")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Services")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Privacy Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Media ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("INFO")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to sell")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to buy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Support")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Career")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Shipping Options")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Knowledge Base")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOP LIST")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Health")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Community")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Events")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rights"
  }, [_c('p', [_vm._v("©  2015 sellpoint All right reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])])
}]}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAdd) ? _c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _c('span', [_c('button', {
    staticClass: "cart-btn remove-btn",
    staticStyle: {
      "background": "#e05024"
    },
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove from Cart")]), _vm._v(" "), _c('button', {
    staticClass: "cart-btn view-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])
},staticRenderFns: []}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100",
    staticStyle: {
      "background": "#2d3a4b"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("About Me")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-map-pin"
  }), _vm._v(" "), _c('b', [_vm._v("Shipping Address: ")]), _vm._v(_vm._s(_vm.user.user_address)), _c('br'), _vm._v("\r\n                NIGERIA.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-envelope"
  }), _c('b', [_vm._v("Email: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:someone@example.com",
      "target": "_top"
    }
  }, [_vm._v(_vm._s(_vm.user.user_email))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_vm._m(3), _vm._v(" "), _c('h6', [_vm._v("My Boards")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "points"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Pick Some Items")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("My Sellpoints")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#559155"
    }
  }, [_vm._v("Here you go...")]), _vm._v(" "), (_vm.sellpoints) ? _c('ul', _vm._l((_vm.sellpoints), function(sp) {
    return _c('li', [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_vm._v(_vm._s(sp.business_name))])])
  })) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "create"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Create a Sellpoint")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("My Orders")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "points"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Pick Some Items")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card sp-bp-interest-block"
  }, [_c('h6', [_vm._v("My Buypoint Interests")]), _vm._v(" "), _c('ul', _vm._l((_vm.user_business_interests), function(bp) {
    return _c('li', [_c('a', {
      attrs: {
        "href": 'tour/' + bp.business_interest_category_name
      }
    }, [_vm._v(_vm._s(bp.business_interest_category_name))])])
  })), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Update my Interesta")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("Settings")]), _vm._v(" "), _vm._l((_vm.user), function(profile) {
    return _c('ul', [_vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _vm._m(9, true)])
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon-call-end"
  }), _vm._v(" "), _c('b', [_vm._v("Phone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("you can edit these details anytime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Edit Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "pink"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Want to Buy Something?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-chart"
  }), _vm._v("Items Bought \r\n              ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("In my Cart \r\n              ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("I want to buy \r\n              ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("Ordered \r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("Your Orders Brief.")])]), _vm._v(" "), _c('li')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-lock"
  }), _c('b', [_vm._v("Forgot Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" "), _c('b', [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('b', [_vm._v("Make a Complaint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" "), _c('b', [_vm._v("Request Help")])])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('section', {
    staticClass: "sp-boarding-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-boarding-centered"
  }, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "12px",
      "color": "#2d3a4b",
      "text-decoration": "underline"
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [_c('form', {
    staticClass: "form sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Email Address\r\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Password\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-image text-center"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "text-align": "center"
    }
  }, [_vm._v("Dont have an Account?"), _c('br'), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_c('u', [_vm._v("Create an Account ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-footer-2"
  }, [_c('div', {
    staticClass: "foot-links"
  }, [_c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("How to use")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("©  2015 Sellpoint. All rights reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])
}]}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopping-cart"
  }, [_c('hr'), _vm._v(" "), (_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "cart-ship-info register col-sm-10 contact_form"
  }, [(_vm.newGallery) ? _c('h6', [_vm._v("New Product Lookbook")]) : _c('p', {
    staticStyle: {
      "font-sixe": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v("Adding to new product post to " + _vm._s(_vm.existing_gallery.gallery_posts_group_name))]), _vm._v(" "), _c('form', [(_vm.newGallery) ? _c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Name\n                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Gallery Name"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Description\n                           "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Add Products")]), _vm._v(" "), _c('div', [(_vm.products.length && (_vm.products.length != 0)) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.products), function(p, pdex) {
    return _c('div', {
      key: pdex,
      staticClass: "col-xs-3",
      staticStyle: {
        "padding": "5px",
        "margin": "1em",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": p.product_name
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add-to-gallery-product', p)
        }
      }
    }, [(p.product_images[0]) ? _c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-select sp-prd-img",
      staticStyle: {
        "height": "4em",
        "width": "85%"
      },
      attrs: {
        "src": p.product_images[0].product_image,
        "id": p.product_id + 'PRD'
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "8px"
      }
    }, [_c('b', [_vm._v(_vm._s(p.product_name))])])])])
  }))]) : _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You do not have any products yet")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-add-product-form', '')
      }
    }
  }, [_c('b', [(_vm.products.length && (_vm.products.length != 0)) ? _c('span', [_vm._v(" Or ")]) : _vm._e(), _vm._v(" Add New Product / Service")])])]), _vm._v(" "), (_vm.showProductForm) ? _c('div', [_c('div', {
    staticClass: "cart-ship-info register col-sm-10  contact_form"
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _c('form', [_c('ul', {}, [_c('li', {
    staticClass: "col-sm-6 product-type"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_vm._v(" Product\n                                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6 product-type"
  }, [_c('label', [_vm._v(" Service\n                                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Name\n                                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Select Product Category\n                                       "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.sub_categories.length > 0) ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Shop Categories\n                                       "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [((_vm.sellpoint_categories.length > 0) || (_vm.sub_categories.length > 0)) ? _c('span', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\n                                           ")]) : _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v("\n                                              Enter " + _vm._s(_vm.is_product_service) + " Category\n                                           ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Description\n                                           "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" *Price\n                                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" *Weight(Kg)\n                                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" *Quantity\n                                           "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Image / Video")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pull-left btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add " + _vm._s(_vm.is_product_service))]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.canAddGallery) ? _c('li', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("Add Lookbook")])]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Select from your Products/Services to add to Gallery")])])
}]}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-100 pages-in chart-page checkout-main-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.total_orders_amount != 0) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-xs-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('h1', {
    staticClass: "card-title"
  }, [_vm._v("Checkout "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.total_orders_amount))])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please confirm your orders below")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card billing-details",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('h4', [_vm._v("Billing Details")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Name: " + _vm._s(_vm.payment_details.payment_payer_name))]), _vm._v(" "), _c('p', [_vm._v("Email: " + _vm._s(_vm.payment_details.payment_payer_email))]), _vm._v(" "), _c('p', [_vm._v("Contact Phone No: " + _vm._s(_vm.payment_details.payment_payer_phone))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-details"
  }, _vm._l((_vm.checkout_orders), function(order, index) {
    return _c('div', {
      staticClass: "order-inner"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('h6', [_vm._v("Orders from "), _c('b', [_vm._v(_vm._s(order.order_business))]), _vm._v(" Total: ₦" + _vm._s(order.order_total))]), _vm._v(" "), _vm._l((order.order_items), function(items, index2) {
      return _c('div', [_c('ol', [_vm._v(_vm._s(index2 + 1) + ". " + _vm._s(items.product_name) + " - SKU: " + _vm._s(items.product_item_sku) + " - ₦" + _vm._s(items.product_item_total_price))]), _vm._v(" "), (items.order_delivery_city) ? _c('div', [_c('p', [_vm._v("Delivery Address for " + _vm._s(items.product_name) + ":")]), _vm._v(" "), (items.order_user_delivery_addresses.length != 0) ? _c('div', [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Addresses that match this location; Please select address")]), _vm._v(" "), _vm._l((items.order_user_delivery_addresses), function(address) {
        return _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (items.order_user_delivery_address),
            expression: "items.order_user_delivery_address"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": address.address_id,
            "checked": _vm._q(items.order_user_delivery_address, address.address_id)
          },
          on: {
            "__c": function($event) {
              items.order_user_delivery_address = address.address_id
            }
          }
        }), _vm._v(" " + _vm._s(address.address_address) + " -" + _vm._s(address.address_city)), _c('br')])
      }), _vm._v(" "), _c('br')], 2) : _c('div', {
        staticClass: "contact-form"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (items.order_user_new_delivery_address),
          expression: "items.order_user_new_delivery_address"
        }],
        staticClass: "form-control",
        attrs: {
          "placeholder": "Enter Delivery Address"
        },
        domProps: {
          "value": (items.order_user_new_delivery_address)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            items.order_user_new_delivery_address = $event.target.value
          }
        }
      }, [_vm._v(_vm._s(items.order_user_delivery_address))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Delivery Location: "), _c('b', [_vm._v(_vm._s(items.order_delivery_city))])]), _vm._v(" "), _c('p', [_vm._v("Delivery Fee: "), _c('b', [_vm._v(_vm._s(items.order_delivery_fee))])])]), _vm._v(" "), (order.order_business_delivery_options.length != 0) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.displayDeliveryOptions(order)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-undo"
      }), _vm._v(" Change Delivery Details")])]) : _vm._e(), _vm._v(" "), (_vm.selected_order.order_no == order.order_no) ? _c('div', [(_vm.selected_order.display_delivery) ? _c('div', _vm._l((order.order_business_delivery_options), function(option) {
        return _c('div', [(option.business_delivery_product == items.product_id) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.item_delivery_fee),
            expression: "item_delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.item_delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_product_specific_delivery_fee(index, index2, option)
            },
            "__c": function($event) {
              _vm.item_delivery_fee = option.business_delivery_option_id
            }
          }
        }), _vm._v(_vm._s(option.business_delivery_option) + " - " + _vm._s(option.business_delivery_option_price)), _c('br')]) : _vm._e()])
      })) : _vm._e()]) : _vm._e()]) : _vm._e()])
    }), _vm._v(" "), _c('p', [_vm._v("Delivery Address:")]), _vm._v(" "), _c('div', {
      staticClass: "contact-form"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (order.order_user_new_delivery_address),
        expression: "order.order_user_new_delivery_address"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Enter Delivery Address"
      },
      domProps: {
        "value": (order.order_user_new_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          order.order_user_new_delivery_address = $event.target.value
        }
      }
    }, [_vm._v(_vm._s(order.order_user_delivery_address))])]), _vm._v(" "), (order.order_delivery_not_set) ? _c('div', [_c('p', [_c('b', [_vm._v("Delivery Details:  ")]), _vm._v(_vm._s(order.order_delivery_not_set))])]) : _c('div', [_c('p', [_vm._v("Delivery Location: "), _c('b', [_vm._v(_vm._s(order.order_delivery_city))])]), _vm._v(" "), _c('p', [_vm._v("Delivery Fee: "), _c('b', [_vm._v(_vm._s(order.order_delivery_fee))])])]), _vm._v(" "), (order.order_business_delivery_options.length != 0) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.displayDeliveryOptions(order)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-undo"
    }), _vm._v(" Change Delivery Details")])]) : _vm._e(), _vm._v(" "), (_vm.selected_order.order_no == order.order_no) ? _c('div', [(_vm.selected_order.display_delivery) ? _c('div', _vm._l((order.order_business_delivery_options), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (order.delivery_fee),
          expression: "order.delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(order.delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_delivery_fee(index, option)
          },
          "__c": function($event) {
            order.delivery_fee = option.business_delivery_option_id
          }
        }
      }), _vm._v(_vm._s(option.business_delivery_option) + " - " + _vm._s(option.business_delivery_option_price)), _c('br')]) : _vm._e()])
    })) : _vm._e()]) : _vm._e()], 2)])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.processPayment()
      }
    }
  }, [_vm._v("Process Payment")])])]) : _c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-xs-12",
    staticStyle: {
      "text-align": "center",
      "background": "#f1eae4",
      "margin-top": "8em",
      "padding-bottom": "2em"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Checkout "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-frown-o",
    staticStyle: {
      "font-size": "3em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "26px",
      "color": "#000000",
      "line-clamp": "1.4"
    }
  }, [_vm._v("Sorry no items to checkout. Have you selected Items from your "), _c('a', {
    staticStyle: {
      "color": "rgb(197, 49, 74)"
    },
    attrs: {
      "href": "cart"
    }
  }, [_vm._v("Cart?")])])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n     vbvbvb " + _vm._s(_vm.products) + "bvbvbv\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    attrs: {
      "id": "wrap"
    }
  }, [_c('section', {
    staticClass: "sp-boarding-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-boarding-centered"
  }, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "12px",
      "color": "#2d3a4b",
      "text-decoration": "underline"
    }
  }, [_vm._v("Create An Account")]), _vm._v(" "), _c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [_c('center', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "form sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Name\r\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Email Address\r\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Phone Number\r\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Password\r\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Sign Up")])])])])], 1)]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-image text-center"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Have an Account? "), _c('a', {
    attrs: {
      "href": "login"
    }
  }, [_c('u', [_vm._v("Log In")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-footer-2"
  }, [_c('div', {
    staticClass: "foot-links"
  }, [_c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("How to use")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("©  2015 Sellpoint. All rights reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])
}]}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "menuModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loggedIn) ? _c('ul', {
    staticClass: "sp-menu-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("Hello " + _vm._s(_vm.user))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _c('ul', {
    staticClass: "sp-menu-list"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "border-bottom-color": "transparent",
      "margin-bottom": "2em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "3em"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_vm._v("View Cart "), _c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Log Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Register")])])
}]}

/***/ }),
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[102]);


// WEBPACK FOOTER //
// static/js/app.cc146c2f6f087aa61366.js